import * as dbAccessor from '@/utils/dbAccessor'
import {getApprovalTypeString, getDifferenceShallow, getNullFields, Logger, addNumbers, convertTimestampToDateInObj, toLocalDateString, splitProductName, toPickerDateString, splitKeyword, toMoney, cloneDeep, getRandomIdByTime, warehousesSitesPredicates, validateUserModuleAuthority, loadDataRTAsync, updateDownloadFieldByLabels, extractFilenameFromUrl, addMonths, addDays} from '@/utils/tools'
import { ViteModel, Shipment, ArchivedShipment, Product, Announcement, PackageReportTenant, ProductTransfer, Support, Package, PriceHistory, OrderFactory } from '@/orm'
import guessCarrier from '@/utils/guessCarrier'
import JSZip from 'jszip'
import xlsx from 'xlsx'
import { generateTenantProductQuery, transformCombinedProducts, updateDClassProduct } from './tenantHelper'

const initialState = {
  products: [],
  offers: [],
  expiredOffers: [],
  archives: [],
  proposes: [],
  users: [],
  userRequest: [],
  groups: [],
  subscribed: {},
  tenant: {},
  inbound: [],
  shipments: [],
  archivedShipments: [],
  balance: {},
  tenantLimitedInfo: {},
  pendingTransactions: [],
  warehouses: [],
  reportLost: [],
  warehousesPromotionsMap: new Map(),
  warehouseBillings: [],
  warehouseLimitedInfoForTenant: [],
  tenantAnnouncements: [],
  pendingProductTransfers: [],
  supports: [],
  priceHistories: [],
  doneSupports: [],
  activeOrders: [],
  activeAppleOrders: [],
  historyAppleOrders: [],
  fulFillmentOrders: [],
  uploadHistory: {},
  tenantAddresses: [],
  tenantPackagings: [],
  templates: [],
  labelTemplates: [],
  labelTemplateDefaults: {},
  commodityTemplates: [],
  systemBalance: {},
  systemBalances: [],
  labelTemplateFlexibleVars: ['orderId', 'sku', 'quantity'],
  skuRequests: [],
  uploadedTrackings: new Set(),
  favorites: {},
  shipmentDrafts: [],
  amazonSites: [],
  hazmatSites: [],
  viteSupports: [],
  scheduleBMap: {},
  offlineDeposits: [],
  stores: [],
  unlinkPackageInfo: {},
  freightSites: [],
  tenantForecastTrackings: [],
  allCities: [],
  monthEndCloseData: [],
  WeChatBilling: [],
  returnPackageTimer: null,
  pendingOrdersTask: [],
  packings: [],
  organizationCommodities: [],
  commoditiesList: [],
  letterheads: [],
  eeveeDepartments: [],
  eeveeManagers: []
}

const state = Object.assign({}, initialState)

export const mutations = {
  setReturnPackageTimer (state, payload) {
    state.returnPackageTimer = payload
  },
  reset_state (state) {
    for (let prop in state) {
      state[prop] = initialState[prop]
    }
  },
  setMonthEndCloseData (state, payload) {
    state.monthEndCloseData = payload
  },
  setTenant (state, payload) {
    state.tenant = payload
  },
  setProducts (state, payload) {
    state.products = payload
  },
  setOffers (state, payload) {
    state.offers = payload
  },
  setExpiredOffers (state, payload) {
    state.expiredOffers = payload
  },
  setArchives (state, payload) {
    state.archives = payload
  },
  setProposes (state, payload) {
    state.proposes = payload
  },
  setUsers (state, payload) {
    state.users = payload
  },
  setUserRequest (state, payload) {
    state.userRequest = payload
  },
  setGroups (state, payload) {
    state.groups = payload
  },
  setInbound (state, payload) {
    state.inbound = payload
  },
  setShipments (state, payload) {
    state.shipments = payload
  },
  setArchivedShipments (state, payload) {
    state.archivedShipments = payload
  },
  setBalance (state, payload) {
    state.balance = payload
  },
  setPendingTransactions (state, payload) {
    state.pendingTransactions = payload
  },
  setTenantLimitedInfo (state, payload) {
    state.tenantLimitedInfo = payload
  },
  setWarehouses (state, payload) {
    state.warehouses = payload
  },
  setWarehouseLimitedInfoForTenant (state, payload) {
    state.warehouseLimitedInfoForTenant = payload
  },
  setWarehouseBillings (state, payload) {
    state.warehouseBillings = payload
  },
  addTosubscribed (state, payload) {
    state.subscribed = {...state.subscribed, ...payload}
  },
  clearSubscribed (state, payload) {
    let {data, initValues} = payload
    state.subscribed[data] = null
    state[data] = initValues
  },
  setReportLost (state, payload) {
    state.reportLost = payload
  },
  setWarehousesPromotionsMap (state, payload) {
    state.warehousesPromotionsMap = payload
  },
  setTenantAnnouncements (state, payload) {
    state.tenantAnnouncements = payload
  },
  setPendingProductTransfers (state, payload) {
    state.pendingProductTransfers = payload
  },
  setSupports (state, payload) {
    state.supports = payload
  },
  setPriceHistories (state, payload) {
    state.priceHistories = payload
  },
  setActiveOrders (state, payload) {
    state.activeOrders = payload
  },
  setActiveAppleOrders (state, payload) {
    state.activeAppleOrders = payload
  },
  setFulfillmentOrders (state, payload) {
    state.fulFillmentOrders = payload
  },
  setUploadHistory (state, payload) {
    state.uploadHistory = payload
  },
  setTenantAddresses (state, payload) {
    state.tenantAddresses = payload
  },
  setTenantPackagings (state, payload) {
    state.tenantPackagings = payload
  },
  setTemplates (state, payload) {
    state.templates = payload
  },
  setLabelTemplates (state, payload) {
    state.labelTemplates = payload
  },
  setLabelTemplateDefaults (state, payload) {
    state.labelTemplateDefaults = payload
  },
  setCommodityTemplates (state, payload) {
    state.commodityTemplates = payload
  },
  setSystemBalance (state, payload) {
    state.systemBalance = payload
  },
  setSystemBalances (state, payload) {
    state.systemBalances = payload
  },
  setSkuRequests (state, payload) {
    state.skuRequests = payload
  },
  setUploadedTrackings (state, payload) {
    state.uploadedTrackings = payload
  },
  setFavorites (state, payload) {
    state.favorites = payload
  },
  setShipmentDrafts (state, payload) {
    state.shipmentDrafts = payload
  },
  setAmazonSites (state, payload) {
    state.amazonSites = payload
  },
  setFreightSites (state, payload) {
    state.freightSites = payload
  },
  setHazmatSites (state, payload) {
    state.hazmatSites = payload
  },
  setViteSupports (state, payload) {
    state.viteSupports = payload
  },
  setScheduleBMap (state, payload) {
    state.scheduleBMap = payload
  },
  setOfflineDeposits (state, payload) {
    state.offlineDeposits = payload
  },
  setStores (state, payload) {
    state.stores = payload
  },
  setUnlinkPackageInfo (state, payload) {
    const now = new Date()
    state.unlinkPackageInfo = {
      exists: payload.length,
      updateTime: now
    }
  },
  setTenantForecastTrackings (state, payload) {
    state.tenantForecastTrackings = payload
  },
  setWeChatBilling (state, payload) {
    state.WeChatBilling = payload
  },
  setAllCities (state, payload) {
    state.allCities = payload
  },
  setPendingOrdersTask (state, payload) {
    state.pendingOrdersTask = payload
  },
  setPackings (state, payload) {
    state.packings = payload
  },
  setOrganizationCommodities (state, payload) {
    state.organizationCommodities = payload
  },
  setCommoditiesList (state, payload) {
    state.commoditiesList = payload
  },
  setLetterheads (state, payload) {
    state.letterheads = payload
  },
  setEeveeDepartments (state, payload) {
    state.eeveeDepartments = payload
  },
  setEeveeManagers (state, payload) {
    state.eeveeManagers = payload
  }
}

const getTrackingMonitorIdentity = getters => {
  const isAdmin = !!(getters.user && getters.user.isAdmin)
  const clientKey = String(getters.activeOrganization || '').trim()

  return {
    isAdmin,
    clientKey: !isAdmin && clientKey ? clientKey : null
  }
}

const sanitizeTrackingMonitorPayload = payload => {
  const sanitizedPayload = {...payload}
  delete sanitizedPayload.scope
  delete sanitizedPayload.organizationKey
  delete sanitizedPayload.clientKey
  return sanitizedPayload
}

export const actions = {
  reset_state ({commit}) {
    commit('reset_state')
  },
  async loadTenantData ({commit, getters}) {
    if (!getters.activeOrganization) return

    let successFunc = (doc) => {
      let tenant = doc.data()
      tenant.destinations = tenant.destinations ? tenant.destinations.map((item, index) => {
        return {...item, index}
      }) : []
      tenant.instructions = tenant.instructions ? tenant.instructions.map((item, index) => {
        return {...item, index}
      }) : []
      commit('setTenant', tenant)
    }

    let errorFunc = (error) => {
      console.error(error)
      commit('setLoading', false)
      throw error
    }

    return loadDataRTAsync(successFunc, errorFunc, (successFunc, errorFunc) => {
      let unsubscribe = dbAccessor.queryRT(successFunc, errorFunc, [], ['tenants', getters.activeOrganization])
      commit('addTosubscribed', {tenant: unsubscribe})
    })
  },
  getAllProducts ({commit, getters}) {
    if (getters.activeOrganization) {
      commit('setLoading', true)
      let successFunc = (docs) => {
        let products = []
        docs.forEach(doc => {
          const obj = convertTimestampToDateInObj(doc.data())
          const upc = obj.upc
          const id = doc.id
          obj.onlyForSearch = [...(obj.asin || []), ...(obj.sku || []), obj.note || ''].join()
          products.push({...obj, upc, id})
        })
        commit('setProducts', products)
        commit('setLoading', false)
      }

      let errorFunc = (error) => {
        console.log(error)
        commit('setLoading', false)
        throw error
      }

      let unsubscribe = dbAccessor.queryStoreRT(successFunc, errorFunc, [], 'tenants', getters.activeOrganization, 'inventory')
      commit('addTosubscribed', {products: unsubscribe})
    }
  },
  async addProduct ({commit, getters}, payload) {
    const {weight, length, width, height, unit} = payload
    if (weight && length && width && height && unit) {
      payload.isDClassProduct = true
    }
    const organizationKey = getters.activeOrganization
    const query = dbAccessor.buildStoreQuery(['tenants', organizationKey])
    const warehouses = getters.warehouses || []
    const field = 'productIndex'
    const increment = 1
    let index = null
    try {
      await dbAccessor.runInTransactionStore(async transaction => {
        try {
          const sfDoc = await transaction.get(query)
          const newObj = {}

          if (!sfDoc.exists) {
            console.log('Document does not exist, create one now')
            newObj[field] = increment
          } else {
            const oldValue = sfDoc.data()[field] || 0
            const newValue = addNumbers(oldValue, increment)
            newObj[field] = newValue
          }
          index = newObj[field].toString().padStart(8, '0')
          payload.id = index
          payload.isArchived = false
          const inventoryDoc = dbAccessor.buildStoreQuery(['tenants', organizationKey, 'inventory', index])
          const doc = await transaction.get(inventoryDoc)
          if (doc.exists) {
            throw Error('Product already exists')
          }
          const path = doc.ref.path
          if (payload.isDClassProduct) {
            await updateDClassProduct(transaction, payload, warehouses, organizationKey, path)
          }

          transaction.set(doc.ref, dbAccessor.addNewDocTimestamp(payload))
          if (!sfDoc.exists) {
            transaction.set(query, dbAccessor.addNewDocTimestamp(newObj))
          } else {
            transaction.update(query, dbAccessor.addUpdateDocTimestamp(newObj))
          }
        } catch (error) {
          throw error
        }
      })

      Logger.changeLog({
        beforeValue: {},
        actionPayload: payload,
        actionName: 'addProduct',
        categories: ['inventory'],
        keys: [index],
        keywords: payload.upc ? [payload.upc] : []
      })

      if (payload.upc) {
        if (!payload.isDClassProduct) {
          await dbAccessor.callFunction('processPackages', { tenantKey: organizationKey, productId: payload.id, upc: payload.upc })
        }
      }

      return index
    } catch (error) {
      if (error.message !== 'add-product-fail') {
        Logger.critical('addProduct', { error: 'post-add-product-fail: ' + error.message, ...payload })
      }
    }
  },
  async editProduct ({ commit, getters }, payload) {
    const { newProduct, isTriggerProcessPackage = false } = payload
    const warehouses = getters.warehouses || []
    let oldProduct = getters.products.find(product => product.id === newProduct.id)
    let isUPCChanged = (oldProduct.upc !== newProduct.upc)
    Logger.log('editProduct', { isUPCChanged: isUPCChanged, ...newProduct })
    const { weight, length, width, height, unit } = newProduct
    if (weight && length && width && height && unit) {
      newProduct.isDClassProduct = true
    }
    const organizationKey = getters.activeOrganization
    if (newProduct.upc && isUPCChanged && !confirm('Are you sure to use the upc? The related Task will confirm automatically')) {
      return
    }

    try {
      await dbAccessor.runInTransactionStore(async (transaction) => {
        const inventoryDoc = await transaction.get(dbAccessor.buildStoreQuery(['tenants', organizationKey, 'inventory', newProduct.id]))
        const path = inventoryDoc.ref.path
        if (newProduct.isDClassProduct) {
          await updateDClassProduct(transaction, newProduct, warehouses, organizationKey, path)
        }
        transaction.update(inventoryDoc.ref, dbAccessor.addUpdateDocTimestamp({ ...newProduct, value: dbAccessor.deleteField() }))
      })

      if ((newProduct.upc && isUPCChanged) || isTriggerProcessPackage) {
        let warehouseKeys = [...new Set(getters.warehouseSites.map(({ warehouseKey }) => warehouseKey))]
        let payload = (newProduct.upc && isUPCChanged) ?
          { tenantKey: organizationKey, productId: newProduct.id, actionType: 'updateUpc', warehouseKeys }
          : { tenantKey: organizationKey, productId: newProduct.id }
        if (!newProduct.isDClassProduct) {
          await dbAccessor.callFunction('processPackages', payload)
        }
      }

      let logBeforeValue = { ...oldProduct }
      let logPayload = { ...newProduct, isTriggerProcessPackage }
      let keywords = new Set()
      logPayload.upc && keywords.add(logPayload.upc)
      logBeforeValue.upc && keywords.add(logBeforeValue.upc)
      delete logBeforeValue.distribution
      delete logPayload.distribution
      Logger.changeLog({
        beforeValue: logBeforeValue,
        actionPayload: logPayload,
        actionName: 'editProduct',
        categories: ['inventory'],
        keys: [newProduct.id],
        keywords: [...keywords]
      })

      return 'success'
    } catch (error) {
      Logger.critical('editProduct', { error: error.message, isUPCChanged: isUPCChanged, ...newProduct, isTriggerProcessPackage })
    }
  },
  clearAllOfferData ({state}) {
    state.subscribed.offers && state.subscribed.offers()
    state.subscribed.archives && state.subscribed.archives()
    state.subscribed.proposes && state.subscribed.proposes()
    delete state.subscribed.offers
    delete state.subscribed.archives
    delete state.subscribed.proposes
    state.offers = initialState.offers
    state.archives = initialState.archives
    state.proposes = initialState.proposes
  },
  clearAllGroupData ({state}) {
    state.subscribed.groups && state.subscribed.groups()
    delete state.subscribed.groups
    state.groups = initialState.groups
  },
  proposeOffer ({commit, getters}, payload) {
    payload.uid = getters.uid
    payload.userName = getters.userExtra.name
    payload.isPropose = true
    payload.isExpired = false
    delete payload.expirationDate
    return dbAccessor.insertStore(payload, 'offers', 'offers', 'proposes')
      .then(() => {
        return 'success'
      })
  },
  getProposedOffers ({commit, getters}, payload) {
    commit('setLoading', true)
    let successFunc = (docs) => {
      const workForSet = new Set(Object.keys(getters.activeWorkfor || {}))
      let proposes = docs.docs
        .map(doc => {
          const obj = convertTimestampToDateInObj(doc.data())
          const key = doc.id
          return {...obj, key}
        })
        .filter(offer => getters.activeOrganization ? true : workForSet.has(offer.tenantKey))
      commit('setProposes', proposes.sort((a, b) => a.createTime - b.createTime))
      commit('setLoading', false)
    }

    let errorFunc = (error) => {
      console.log(error)
      commit('setLoading', false)
      throw error
    }
    // get all offers for a tenant or for a member
    let predicates = getters.activeOrganization
      ? [{
        field: 'tenantKey',
        compare: '==',
        value: getters.activeOrganization
      }]
      :
      [
        {
          field: 'uid',
          compare: '==',
          value: getters.uid
        }
      ]
    let unsubscribe = dbAccessor.queryStoreRT(successFunc, errorFunc, predicates, 'offers', 'offers', 'proposes')
    commit('addTosubscribed', {proposes: unsubscribe})
  },
  acceptPropose ({commit, getters, dispatch}, payload) {
    // do we need to update the offer quantity. Not doing it now
    let {key, comments, ...item} = payload
    console.log(item.offerKey, item.quantity)
    return dbAccessor.runInBatch(async (batch) => {
      let offerRef = dbAccessor.buildStoreQuery(['offers', 'offers', 'proposes', key])
      let taskRef = dbAccessor.buildStoreQuery(['tasks', 'tasks', 'active']).doc()
      let originOfferRef = dbAccessor.buildStoreQuery(['offers', 'offers', 'active', item.offerKey])
      batch.delete(offerRef)
      batch.set(taskRef, dbAccessor.addUpdateDocTimestamp({
        ...item,
        searchKeywords: [item.offerKey, ...splitProductName(item.productName), item.userName]
      }))
      batch.update(originOfferRef, dbAccessor.addUpdateDocTimestamp({
        proposeQuantity: dbAccessor.incrementField(item.quantity)
      }))
    })
      .then(() => {
        dispatch('setProductPriceHistoryOfferNode', {
          productId: payload.productId,
          data: {
            offerId: payload.offerKey,
            price: payload.price,
            bonus: payload.bonus,
            allowSelf: !payload.isOnlyShipToWarehouse
          }
        })
      })
  },

  cancelPropose ({commit, getters}, payload) {
    return dbAccessor.removeStore('offers', 'offers', 'proposes', payload.key)
  },

  updatePropose ({commit, getters}, payload) {
    let item = {
      price: payload.price,
      quantity: payload.quantity,
      warehouse: payload.warehouse
    }
    return dbAccessor.updateFieldsStore(item, 'offers', 'offers', 'proposes', payload.key)
      .catch(error => {
        console.log(error.code)
        if (error.code === 'not-found') {
          console.log('document not found, no ops')
          return {message: 'The propose has been removed. Operation canceled'}
        } else {
          throw error
        }
      })
  },
  addProposeComment ({getters, commit}, payload) {
    let {comment, docKey} = payload
    return dbAccessor.updateFieldAddToArrayStore('comments', comment, 'offers', 'offers', 'proposes', docKey)
  },
  removeProposeComment ({getters, commit}, payload) {
    let {comment, docKey} = payload
    comment = convertTimestampToDateInObj(comment)
    let createTime
    if (comment.createTime) {
      createTime = comment.createTime
    } else { return Promise.reject(Error('create time missing')) }
    let predicate = {
      field: 'createTime',
      value: createTime
    }
    console.log('remove item')
    return dbAccessor.updateFieldRemoveOneFromArrayStore('comments', predicate, 'offers', 'offers', 'proposes', docKey)
  },
  getAllOffers ({commit, getters}) {
    commit('setLoading', true)
    let successFunc = (docs) => {
      const workForSet = new Set(Object.keys(getters.activeWorkfor || {}))
      const offers = docs.docs
        .map(doc => {
          const obj = convertTimestampToDateInObj(doc.data())
          const key = doc.id
          return {...obj, key}
        })
        .filter(offer => getters.activeOrganization ? true : workForSet.has(offer.tenantKey))
      commit('setExpiredOffers', offers.filter(item => item.isExpired))
      commit('setOffers', offers)
      commit('setLoading', false)
    }
    let errorFunc = (error) => {
      console.error(error)
      commit('setLoading', false)
      throw error
    }
    // get all offers for a tenant or for a member
    let predicates = getters.activeOrganization
      ? [{
        field: 'tenantKey',
        compare: '==',
        value: getters.activeOrganization
      }]
      :
      [
        {
          field: `userVisible`,
          compare: 'array-contains',
          value: getters.uid
        }
      ]
    let unsubscribe = dbAccessor.queryRT(successFunc, errorFunc, predicates, ['offers', 'offers', 'active'])
    commit('addTosubscribed', {offers: unsubscribe})
  },

  async addOffer ({commit, dispatch, getters}, payload) {
    payload.warehouseKeys = [...(new Set(payload.warehouseSites.map(({warehouseKey}) => warehouseKey)))]

    payload.taken = 0
    payload.tenantKey = getters.activeOrganization
    payload.lastEditTime = dbAccessor.getServerTimestamp()
    let index = await dbAccessor.increaseValueInTransactionStore('activeIndex', 1, ['offers', 'offers'])

    index = index.toString().padStart(4, '0')
    Logger.log('addOffer', {...payload, index})

    payload.isExpired = payload.expirationDate < new Date() ? (payload.isExpired = true) : (payload.isExpired = false)
    if (getNullFields(payload).length !== 0) {
      return Promise.reject(Error('Detect undefined fields in the payload: ' + payload))
    }
    if (!getters.productsWithUpcChangeableFlag.some(product => product.id === payload.productId)) {
      return Promise.reject(Error('Product has been archived.'))
    }
    await dbAccessor.updateStore(payload, 'offers', 'offers', 'active', index)
    dispatch('setProductPriceHistoryOfferNode', {
      productId: payload.productId,
      data: {
        offerId: index,
        price: payload.price,
        bonus: payload.bonus,
        allowSelf: !payload.isOnlyShipToWarehouse
      }
    })
    return dbAccessor.callFunction('notifyOfferUpdated', {newOffer: payload, oldOffer: {}, key: index})
  },
  editOffer ({commit, dispatch, getters}, payload) {
    let {offer, oldOffer, moveToTop} = payload
    if (offer.expirationDate > new Date()) offer.isExpired = false
    if (offer.expirationDate < new Date()) offer.isExpired = true
    offer.warehouseKeys = [...(new Set(offer.warehouseSites.map(({warehouseKey}) => warehouseKey)))]
    let updatedOffer = getDifferenceShallow(offer, oldOffer, {key: offer.key})
    moveToTop && (updatedOffer.lastEditTime = dbAccessor.getServerTimestamp())
    Logger.log('editOffer', payload)
    return dbAccessor.updateFieldsStore(updatedOffer, 'offers', 'offers', 'active', offer.key)
      .then(() => {
        dbAccessor.callFunction('notifyOfferUpdated', {newOffer: offer, oldOffer, key: offer.key})
        dispatch('setProductPriceHistoryOfferNode', {
          productId: offer.productId,
          data: {
            offerId: offer.key,
            price: offer.price,
            bonus: offer.bonus,
            allowSelf: !offer.isOnlyShipToWarehouse
          }
        })
      })
  },
  async archiveOffer ({commit, getters}, payload) {
    // check if has propose offers
    if (getters.proposes.some(({offerKey}) => offerKey === payload.key)) {
      alert(`Can't archive this offer(id: ${payload.key}). There are active proposes, please resolve these proposes first.`)
      return
    }

    if (!payload.ignoreCheckTasks) {
      const existedRelatedTask = (await dbAccessor.queryWithPagination([
        {field: 'offerKey', compare: '==', value: payload.key}
      ], ['tasks', 'tasks', 'active'], null, true, undefined, 1)).size
      if (existedRelatedTask ? !confirm(`Warning: The related tasks won't be able to confirm. \nDo you want to proceed? `) : !confirm('Are you sure to archive?')) {
        return
      }
    }
    payload.searchKeywords = splitProductName(payload.productName)
    delete payload.ignoreCheckTasks
    return dbAccessor.removeAndInsertBatchStore(['offers', 'offers', 'active', payload.key], payload, ['offers', 'offers', 'archives'])
  },
  restoreOffer ({commit, getters}, payload) {
    return dbAccessor.removeAndInsertBatchStore(['offers', 'offers', 'archives', payload._key], payload, ['offers', 'offers', 'active', payload.key])
  },
  getArchiveOffersPagination ({commit, getters}, payload) {
    if (!getters.activeOrganization) {
      const error = 'it is not an organization'
      commit('setError', error)
      return Promise.resolved('resolved')
    }

    let predicates = [{
      field: 'tenantKey',
      compare: '==',
      value: getters.activeOrganization
    }]

    payload.startDate && payload.endDate && (predicates = [...predicates, {
      field: `createTime`,
      compare: '>=',
      value: payload.startDate
    },
    {
      field: `createTime`,
      compare: '<=',
      value: payload.endDate
    }])

    if (payload.predicates && payload.predicates.predicateText) {
      predicates.push({
        field: `searchKeywords`,
        compare: 'array-contains',
        value: payload.predicates.predicateText
      })
    }

    return dbAccessor.queryWithPagination(predicates, ['offers', 'offers', 'archives'], 'createTime', true, payload && payload.startAfter, payload && payload.limit)
  },
  getMemberRequested ({commit, getters}) {
    let predicates = [{
      field: 'TenantID',
      compare: '==',
      value: getters.activeOrganization
    }]
    dbAccessor.queryWithPredicatesStore(predicates, 'requests')
      .then((docs) => {
        let userRequest = []
        docs.forEach(doc => {
          const obj = doc.data()
          obj.tenantKey = getters.activeOrganization
          const requestKey = doc.id
          obj.status = 'pending'
          obj.balance = 0
          userRequest.push({...obj, requestKey})
        })
        commit('setUserRequest', userRequest)
      })
  },
  handleUserRequest ({commit, getters, dispatch}, payload) {
    if (getters.users.map(user => user.uid).includes(payload.request.uid)) {
      if (confirm('This user has already been added before, would you like to change the status to accepted?')) {
        return dispatch('editUserStatus', {userKey: payload.request.uid, approvalType: 3})
          .then(() => {
            dbAccessor.removeStore('requests', payload.request.requestKey)
            let userRequest = getters.userRequest.filter(request => request.requestKey !== payload.request.requestKey)
            return commit('setUserRequest', userRequest)
          })
      } else {
        return
      }
    }
    return dbAccessor.callFunction('handleUserRequest', payload)
      .then(() => {
        let userRequest = getters.userRequest
        for (let i = 0; i < userRequest.length; i++) {
          if (userRequest[i].uid === payload.request.uid) {
            userRequest[i].status = 'accepted'
            userRequest[i].approvalType = 3
            delete userRequest[i].requestKey
            userRequest.splice(i, 1)
            userRequest = [...userRequest]
          }
        }
        commit('setUserRequest', userRequest)
      })
  },
  rejectUserRequest ({commit, getters}, payload) {
    return dbAccessor.callFunction('handleUserRequest', payload)
      .then(() => {
        let userRequest = getters.userRequest
        for (let i = 0; i < userRequest.length; i++) {
          if (userRequest[i].uid === payload.request.uid) {
            userRequest.splice(i, 1)
            userRequest = [...userRequest]
          }
        }
        commit('setUserRequest', userRequest)
      })
  },
  async removeUser ({commit, getters}, payload) {
    let newUsers
    await dbAccessor.runInTransactionStore(async transaction => {
      const doc = await transaction.get(dbAccessor.buildStoreQuery(['tenants', getters.activeOrganization, 'general', 'users']))
      const {users} = doc.data()
      newUsers = users.filter(user => user.uid !== payload.uid)
      transaction.update(doc.ref, dbAccessor.addUpdateDocTimestamp({
        users: newUsers
      }))
    })
    commit('setUsers', newUsers)
  },
  editUserStatus ({commit, getters}, payload) {
    let userRef = dbAccessor.buildStoreQuery(['users', payload.userKey])
    let usersRef = dbAccessor.buildStoreQuery(['tenants', getters.activeOrganization, 'general', 'users'])
    return dbAccessor.runInTransactionStore(transaction => {
      return Promise.all([transaction.get(userRef), transaction.get(usersRef)])
        .then(([doc, usersDoc]) => {
          const tenantKey = getters.activeOrganization
          let newPayload = doc.data()
          newPayload.workfor[tenantKey] = payload.approvalType
          let users = usersDoc.get('users') || []
          for (let i = 0; i < users.length; i++) {
            if (users[i].uid === payload.userKey) {
              users[i].approvalType = payload.approvalType
            }
          }
          return transaction
            .update(userRef, dbAccessor.addUpdateDocTimestamp(newPayload))
            .update(usersRef, dbAccessor.addUpdateDocTimestamp({users}))
        })
    })
  },
  clearAllUserData () {
    delete state.users
    state.users = initialState.users
  },
  getAllGroups ({commit, getters}) {
    let successFunc = (docs) => {
      let groups = []
      docs.forEach(doc => {
        const group = doc.data()
        group.groupKey = doc.id
        groups.push(group)
      })
      let sortFunc = (a, b) => {
        if (a.name.toLowerCase() < b.name.toLowerCase()) return -1
        if (a.name.toLowerCase() > b.name.toLowerCase()) return 1
        return 0
      }
      groups.sort(sortFunc)
      commit('setGroups', groups)
    }

    let errorFunc = (error) => {
      console.log(error)
      throw error
    }

    let predicates = []
    let unsubscribe = dbAccessor.queryStoreRT(successFunc, errorFunc, predicates, 'tenants', getters.userExtra.organizations[0], 'groups')
    commit('addTosubscribed', {groups: unsubscribe})
  },
  addGroup ({commit, getters}, payload) {
    return dbAccessor.insertStore(payload, 'tenants', getters.activeOrganization, 'groups')
  },
  editGroup ({commit, getters, dispatch}, payload) {
    const {name, members, groupKey} = payload
    return dbAccessor.updateStore({name, members}, 'tenants', getters.activeOrganization, 'groups', groupKey)
      .then(() => dispatch('addUserToOfferByUpdateUserGroup', {groupKeys: [groupKey], uids: members.map(({uid}) => uid)}))
  },
  editUserGroups ({commit, getters, dispatch}, payload) {
    const {uid, name, groupKeys, initGroupKeys} = payload
    const initGroupKeySet = new Set(initGroupKeys)
    const groupKeySet = new Set(groupKeys)
    let groupKeysToAdd = groupKeys.filter(key => !initGroupKeySet.has(key))
    let groupKeysToDelete = initGroupKeys.filter(key => !groupKeySet.has(key))

    return dbAccessor.runInTransactionStore(async transaction => {
      const refBuilder = (key) => dbAccessor.buildStoreQuery(['tenants', getters.activeOrganization, 'groups', key])
      const addDocs = await Promise.all(groupKeysToAdd.map(key => transaction.get(refBuilder(key))))
      const deleteDocs = await Promise.all(groupKeysToDelete.map(key => transaction.get(refBuilder(key))))

      addDocs.forEach(doc => {
        let {members} = doc.data()
        transaction.update(doc.ref, dbAccessor.addUpdateDocTimestamp({members: [...members, {uid, name}]}))
      })

      deleteDocs.forEach(doc => {
        let {members} = doc.data()
        transaction.update(doc.ref, dbAccessor.addUpdateDocTimestamp({members: members.filter(member => member.uid !== uid)}))
      })
    })
      .then(() => dispatch('addUserToOfferByUpdateUserGroup', {groupKeys, uids: [uid]}))
  },
  async deleteGroup ({commit, getters}, payload) {
    const docId = payload.groupKey
    if (getters.tenantLimitedInfo.defaultUsers
      .some(user => user.isGroup && user.key === docId)) {
      await dbAccessor.updateFieldsStore({
        defaultUsers: getters.tenantLimitedInfo.defaultUsers.filter(user => user.key !== docId)
      }, 'tenantLimitedInfo', getters.activeOrganization)
    }
    await dbAccessor.removeStore('tenants', getters.userExtra.organizations[0], 'groups', docId)
  },
  getMembers ({commit, getters}) {
    commit('setLoadingMembers', true)
    if (!getters.activeOrganization) return Promise.resolve('not an org')
    /**
     *
     * @param {firebase.firestore.DocumentSnapshot} doc
     */
    const successFunc = doc => {
      const {users = []} = (doc.exists ? doc.data() : {})
      commit('setUsers', users.sort((a, b) => {
        if (a.name.toLowerCase() < b.name.toLowerCase()) return -1
        if (a.name.toLowerCase() > b.name.toLowerCase()) return 1
        return 0
      }))
      commit('setLoadingMembers', false)
    }
    let unsubscribe = dbAccessor.queryRT(
      successFunc,
      (error) => {
        console.log(error)
        commit('setLoading', false)
        throw error
      },
      [],
      ['tenants', getters.activeOrganization, 'general', 'users']
    )
    commit('addTosubscribed', {usersForTenant: unsubscribe})
  },
  addUserToOfferByUpdateUserGroup ({commit, getters}, payload) {
    const {groupKeys = [], uids = []} = payload
    if (!Array.isArray(uids) || !uids.length) return

    const {offers = []} = getters
    return offers
      .filter(({selected}) => Array.isArray(selected.groups) && selected.groups.some(group => groupKeys.includes(group.key)))
      .map(({key}) => dbAccessor.updateFieldAddToSetArray(['offers', 'offers', 'active', key], 'userVisible', ...uids))
  },
  getInboundForDetails ({commit, getters}, payload) {
    let predicates = [
      {
        field: 'productId',
        compare: '==',
        value: payload.actionPayload.productId
      },
      {
        field: 'transactionType',
        compare: '==',
        value: 'inbound'
      },
      {
        field: 'tenantKey',
        compare: '==',
        value: getters.activeOrganization
      }
    ]

    payload.startDate && payload.endDate && (predicates = [...predicates, {
      field: `createTime`,
      compare: '>=',
      value: payload.startDate
    },
    {
      field: `createTime`,
      compare: '<=',
      value: payload.endDate
    }])

    if (payload.predicates.predicateSelect) {
      predicates.push({
        field: `userKey`,
        compare: '==',
        value: payload.predicates.predicateSelect
      })
    }
    return dbAccessor.queryWithPagination(predicates, ['transaction'], 'createTime', true, payload && payload.startAfter, payload && payload.limit)
  },
  getProductInfo ({commit, getters}, payload) {
    return dbAccessor.queryStore('tenants', payload.tenantKey, 'inventory', payload.productId)
  },
  retryOrderShipment ({commit, getters}, ordersTaskId) {
    if ((getters.systemBalance.balance || 0) <= (getters.systemBalance.lowestBalance || 0)) {
      if (!getters.isModeLabel) {
        throw Error('Can not create label, balance is too low.')
      }
    }
    Logger.log('retryOrderShipment', ordersTaskId)
    return dbAccessor.callFunction('processLabelTask', {
      ordersTaskId: ordersTaskId,
      clientKey: getters.activeOrganization,
      type: 'retryProcessOrderShipment'
    })
  },
  async addOrderShipment ({commit, dispatch, getters}, payload) {
    if ((getters.systemBalance.balance || 0) <= (getters.systemBalance.lowestBalance || 0)) {
      if (!getters.isModeLabel) {
        throw Error('Can not create label, balance is too low.')
      }
    }
    Logger.log('addOrderShipment', payload)
    let {labels, shipments, keywords} = payload
    if (labels.length <= 0) {
      return {
        successLabels: [],
        errorLabels: []
      }
    }
    const payloadShipments = shipments.map(shipment => {
      shipment.tenantKey = getters.activeOrganization
      shipment.tenantName = getters.tenant.name
      shipment.orgEmail = getters.userExtra.email
      let payloadShipment = new Shipment(shipment)
      return {...payloadShipment.getData(), _key: payloadShipment._key, orderProcessTime: shipment.orderProcessTime}
    })
    try {
      labels.forEach(label => {
        label.clientType = 'VITE'
      })
      await dbAccessor.callFunction('processOrders', {
        labels,
        keywords,
        shipments: payloadShipments,
        clientKey: getters.activeOrganization,
        clientName: getters.tenantLimitedInfo.name,
        isBeta: getters.isLabelBetaUser,
        type: 'addOrderShipmentInBatch',
        margin: getters.systemBalance.margin || 0
      })
    } catch (err) {
      throw Error(err.message)
    }
    return null
  },
  async editOrderShipmentTask ({commit, dispatch, getters}, payload) {
    Logger.log('editOrderShipmentTask', payload)
    let {labels, shipments, keywords} = payload
    if (labels.length <= 0) {
      return {
        successLabels: [],
        errorLabels: []
      }
    }
    const payloadShipments = shipments.map(shipment => {
      shipment.tenantKey = getters.activeOrganization
      shipment.tenantName = getters.tenant.name
      shipment.orgEmail = getters.userExtra.email
      let payloadShipment = new Shipment(shipment)
      return {...payloadShipment.getData(), _key: payloadShipment._key, orderProcessTime: shipment.orderProcessTime, shipmentTaskId: shipment.shipmentTaskId}
    })
    try {
      await dbAccessor.callFunction('processOrders', {
        labels,
        keywords,
        shipments: payloadShipments,
        clientKey: getters.activeOrganization,
        clientName: getters.tenantLimitedInfo.name,
        isBeta: getters.isLabelBetaUser,
        type: 'editOrderShipmentTask',
        margin: getters.systemBalance.margin || 0
      })
    } catch (err) {
      throw Error(err.message)
    }
    return null
  },
  async deleteOrderShipmentTask ({commit, dispatch, getters}, payload) {
    Logger.log('deleteOrderShipmentTask', payload)
    let { shipmentTaskId } = payload
    try {
      await dbAccessor.callFunction('processOrders', {
        shipmentTaskId,
        clientKey: getters.activeOrganization,
        clientName: getters.tenantLimitedInfo.name,
        type: 'deleteOrderShipmentTask'
      })
    } catch (err) {
      throw Error(err.message)
    }
    return null
  },
  async addShipment ({commit, dispatch, getters}, payload) {
    const shipmentDocSnapshot = await dbAccessor.queryStore(
      'shipments',
      payload._key
    )
    if (shipmentDocSnapshot.exists && shipmentDocSnapshot.data().status !== 'pending') {
      throw Error('shipment-existed')
    }
    Logger.log('addShipment', payload)
    const isHasCombinedUpc = payload.products.some(product => product.isCombined)

    if (isHasCombinedUpc) {
      const getProductInfoById = generateTenantProductQuery(dbAccessor, getters.activeOrganization)
      const transformedShipments = await transformCombinedProducts(
        payload,
        getProductInfoById
      )
      payload = transformedShipments
    }
    payload.tenantKey = getters.activeOrganization
    payload.tenantName = getters.tenant.name
    payload.orgEmail = getters.userExtra.email
    payload.creator = getters.userExtra.name
    const targetDraft = getters.shipmentsAndDrafts.find(item => item._key === payload.draftKey) || {}
    payload.draftComments = targetDraft.draftComments
    payload.exceptionRootFields = {}
    Object.entries(targetDraft).map(([key, val]) => {
      if (key.startsWith('lastRead_draftComments_')) {
        payload.exceptionRootFields[key] = val
      }
    })

    let {keywords, ...shipment} = payload
    let {products} = payload
    let {shipDate = toPickerDateString(new Date()), isApiOrder = false} = payload.selectedOrder || {}
    let payloadShipment = Shipment.newDoc({...shipment, isUnzipSingleFile: true})
    let productDictionary = {}
    products.forEach(product => {
      productDictionary[product.id] = productDictionary[product.id] || []
      productDictionary[product.id].push(product)
    })
    if (payload.draftKey) {
      const draftDocSnapshot = await dbAccessor.queryStore(
        'tenants',
        getters.activeOrganization,
        'shipmentDrafts',
        payload.draftKey
      )
      if (!draftDocSnapshot.exists) throw Error('draft-not-existed')
    }
    return ViteModel.startTransaction(async (transaction) => {
      let organizationRef = null
      const shipmentRef = dbAccessor.buildStoreQuery(['shipments', payload._key])
      let transactionGets = [
        transaction.get(shipmentRef),
        ...Object.keys(productDictionary).map((productId) => Product.getT(transaction, payload.tenantKey, productId))
      ]
      let [dbShipmentDoc, ...gets] = await Promise.all(transactionGets)
      const firebaseLabels = await Promise.all(payload.labels.map(label =>
        dbAccessor.buildStoreQuery(['labels', label.requestId]).get()
      ))
      // scan form
      const hasScanForm = firebaseLabels.some(label => label.get('isNeedToConfirm'))
      if (hasScanForm) {
        organizationRef = await transaction.get(
          dbAccessor.buildStoreQuery([
            'warehouses',
            payload.warehouseKey,
            'organizations',
            payload.tenantKey
          ])
        )
      }

      if (payloadShipment.orderChange) {
        let {orderInfo, ...skuToFulfillQty} = payloadShipment.orderChange
        let orderDoc = await transaction.get(dbAccessor.buildStoreQuery([
          'tenants',
          getters.activeOrganization,
          'orders',
          orderInfo._key
        ]))

        if (!orderDoc.exists) throw Error('Order doc not found.')
        let {items, status, shipments = []} = orderDoc.data()
        if (status === 'shipped') throw Error('Order has already been fulfilled.')
        items.forEach(item => {
          let {sku} = item
          let orderShipment = {}
          if (skuToFulfillQty[sku] && skuToFulfillQty[sku].fulfillQty) {
            let {fulfillQty, orderItemId} = skuToFulfillQty[sku]
            item.quantityShipped += fulfillQty
            orderShipment = {
              key: payload._key,
              orderItemId,
              quantity: fulfillQty,
              shipDate,
              carrierCode: payload.labels[0]?.serviceType,
              carrierName: payload.labels[0]?.carrier,
              trackingNumber: payloadShipment.trackingNum,
              status: 'pending'
            }
            shipments.push(orderShipment)
          }
          // over shipped
          if (item.quantityShipped > item.quantityPurchased) {
            throw Error(`OverShipped quantity for item sku: ${sku}`)
          }
        })

        let keywordsArr = keywords.split(' ')
        keywordsArr.pop()
        let fullKeywords = keywordsArr.join(' ')
        if (items.some(item => item.quantityPurchased - item.quantityShipped > 0)) {
          transaction.update(orderDoc.ref, dbAccessor.addUpdateDocTimestamp({
            status: 'partial',
            items,
            shipments,
            keywords: dbAccessor.fieldArrayUnion([...splitKeyword(keywords), fullKeywords]),
            processTime: new Date()
          }))
        } else {
          transaction.update(orderDoc.ref, dbAccessor.addUpdateDocTimestamp({
            status: isApiOrder ? 'readyToFulfillment' : 'closed',
            items,
            shipments,
            keywords: dbAccessor.fieldArrayUnion([...splitKeyword(keywords), fullKeywords]),
            processTime: new Date()
          }))
        }
      }
      payloadShipment.keywords = payloadShipment.keywords
        .filter(item => item)
      if (!dbShipmentDoc.exists) {
        payloadShipment.insertOrUpdateT(transaction)
      } else {
        let {readyLabels} = dbShipmentDoc.data()
        payloadShipment.labels.forEach(item => {
          let targetLabel = readyLabels.find(label => label.orderId === item.orderId)
          if (targetLabel) {
            item.url = targetLabel.url
            item.trackingNum = targetLabel.trackingNumber
          }
        })
        payloadShipment.trackingNum = payloadShipment.labels
          .filter(item => item.trackingNum)
          .map(item => item.trackingNum)
          .join(' ')
        payloadShipment.keywords = [...payloadShipment.keywords, ...payloadShipment.trackingNum.split(' ')]
        if (payloadShipment.labels.length || payloadShipment.files.length) {
          dbAccessor.callFunction('processShipmentLabelFiles', {...payloadShipment.getData(), key: payload._key})
        }
        payloadShipment.insertOrUpdateT(transaction)
      }

      gets.forEach(originProduct => {
        if (!originProduct) {
          throw Error('missing-product')
        } else {
          const key = originProduct.getKey()
          productDictionary[key].forEach(product => {
            // update quantity
            originProduct.quantity -= product.toShip
            // update fbm
            let distribution = originProduct.distribution
            if (distribution[product.fbmKey].quantity >= product.toShip) {
              distribution[product.fbmKey].quantity -= product.toShip
              if (distribution[product.fbmKey].quantity === 0) { delete distribution[product.fbmKey] }
            } else {
              throw Error('quantity error')
            }
          })
          originProduct.updateT(transaction)
        }
      })

      payloadShipment.labels.forEach(label => {
        const labelRef = dbAccessor.buildStoreQuery(['labels', label.orderId.split('-')[1]])
        transaction.update(labelRef, {shipmentId: payloadShipment._key, hasShipment: true})
      })

      // scan form
      if (hasScanForm) {
        const ref = await dbAccessor.buildStoreQuery([
          'warehouses',
          payload.warehouseKey,
          'waitingScanFormShipments'
        ]).get()
        const updatePayload = {}
        firebaseLabels.forEach(label => {
          const isNeedToConfirm = label.get('isNeedToConfirm')
          const requestId = label.get('requestId')
          const targetScanFormShipmentRef = ref.docs.find(doc => {
            const shipmentsMap = doc.get('shipments') || {}
            return shipmentsMap[requestId]
          })
          if (targetScanFormShipmentRef && isNeedToConfirm) {
            const data = {}
            const key = `shipments.${requestId}`
            data[`${key}.shipmentId`] = payload._key
            data[`${key}.warehouseSite`] = payload.siteKey
            data[`${key}.email`] = payload.orgEmail
            data[`${key}.organizationId`] = organizationRef.get('organizationId') || ''

            const obj = updatePayload[targetScanFormShipmentRef.id] || {}
            updatePayload[targetScanFormShipmentRef.id] = { ...obj, ...data }
          }
        })
        for (let id in updatePayload) {
          const ref = dbAccessor.buildStoreQuery([
            'warehouses',
            payload.warehouseKey,
            'waitingScanFormShipments',
            id
          ])
          transaction.update(ref, updatePayload[id])
        }
      }
    })
      .catch(error => {
        Logger.critical('Add Shipment', error.message)
        console.error(error)
        let newError = Error('new-shipment-error')
        newError.internalError = error
        throw newError
      })
      .then((data) => {
        let uploadMetadataPromises = payload.files.map(file => {
          return ViteModel.updateFileMetadata(file.fullPath, {...file, shipmentKey: payload._key})
        })
        return Promise.all(uploadMetadataPromises)
      })
      .catch(error => {
        if (error.message === 'new-shipment-error') throw error
      })
  },
  getShipments ({commit, getters, dispatch}) {
    let predicates = []
    const {
      activeOrganization,
      activeWarehouse,
      currentWarehouseUserSites,
      uid,
      user
    } = getters
    if (activeOrganization) {
      predicates = [{
        field: `tenantKey`,
        compare: '==',
        value: activeOrganization
      }]
    } else if (activeWarehouse) {
      predicates = [{
        field: `userKey`,
        compare: '==',
        value: activeWarehouse
      }, ...warehousesSitesPredicates(activeWarehouse, user.roles, currentWarehouseUserSites, 'siteKey')]
    } else {
      predicates = [{
        field: `userKey`,
        compare: '==',
        value: uid
      }]
    }
    const cbFunc = (data) => {
      data.forEach(shipment => {
        const {name, content} = shipment.destination
        shipment.destinationForDisplay = name === '-- Other --' ? content : name
        shipment.keywordString += `, ${getters.organizationKeyToId.get(shipment.tenantKey)}, ${shipment.tenantName}`
      })
      if (activeOrganization) {
        if (data.some(shipment => shipment.isNeedHandler)) {
          dispatch('addNotification', {
            key: 'newOutboundMessages',
            displayName: 'new outbound messages',
            pathName: 'outbound messages',
            path: '/outBoundHistory'
          })
        } else commit('removeNotification', {key: 'newOutboundMessages'})
      }
      commit('setShipments', data)
    }
    let unsubscribe = Shipment.getRT(cbFunc, predicates, [['isExpedited', true], ['createTime', false]])
    commit('addTosubscribed', {shipments: unsubscribe})
  },

  getDeletedShipments ({commit, getters}, payload) {
    let predicates = [{
      field: `tenantKey`,
      compare: '==',
      value: getters.activeOrganization
    }]

    if (payload.predicates && payload.predicates.predicateText) {
      let keywordText = payload.predicates.predicateText
      if (payload.predicates.predicateText.startsWith && payload.predicates.predicateText.startsWith('**')) {
        keywordText = keywordText.slice(2)
      } else {
        keywordText = keywordText.toUpperCase()
      }
      predicates.push({
        field: `keywords`,
        compare: 'array-contains-any',
        value: [keywordText]
      })
    }

    payload.startDate && payload.endDate && (predicates = [...predicates, {
      field: `createTime`,
      compare: '>=',
      value: payload.startDate
    },
    {
      field: `createTime`,
      compare: '<=',
      value: payload.endDate
    }])

    if (payload.predicates && payload.predicates.predicateSelect) {
      predicates.push({
        field: `userKey`,
        compare: '==',
        value: payload.predicates.predicateSelect
      })
    }
    return dbAccessor.queryWithPagination(predicates, ['deletedShipments'], 'createTime', true, payload && payload.startAfter, payload && payload.limit)
  },

  getArchivedShipments ({commit, getters}, payload) {
    let predicates = []
    if (getters.activeOrganization) {
      predicates = [{
        field: `tenantKey`,
        compare: '==',
        value: getters.activeOrganization
      }]
    } else if (getters.activeWarehouse) {
      predicates = [{
        field: `userKey`,
        compare: '==',
        value: getters.activeWarehouse
      }, ...warehousesSitesPredicates(getters.activeWarehouse, getters.user.roles, getters.currentWarehouseUserSites, 'siteKey')]
    } else {
      predicates = [{
        field: `userKey`,
        compare: '==',
        value: getters.uid
      }]
    }

    if (payload.predicates && payload.predicates.predicateText) {
      predicates.push({
        field: `keywords`,
        compare: 'array-contains',
        value: payload.predicates.predicateText.toUpperCase()
      })
    }

    if (payload && payload.predicates && payload.predicates.actionPredicates) {
      predicates = [...predicates, ...payload.predicates.actionPredicates]
    }

    payload.startDate && payload.endDate && (predicates = [...predicates, {
      field: `createTime`,
      compare: '>=',
      value: payload.startDate
    },
    {
      field: `createTime`,
      compare: '<=',
      value: payload.endDate
    }])

    if (payload.predicates && payload.predicates.predicateSelect) {
      if (getters.activeOrganization) {
        predicates.push({
          field: `userKey`,
          compare: '==',
          value: payload.predicates.predicateSelect
        })
      } else {
        predicates.push({
          field: `tenantKey`,
          compare: '==',
          value: payload.predicates.predicateSelect
        })
      }
    }
    return dbAccessor.queryWithPagination(predicates, ['archivedShipments'], 'createTime', true, payload && payload.startAfter, payload && payload.limit)
      .then(querySnapshots => {
        const result = querySnapshots.size
          ?
          {
            models: querySnapshots.docs.map(doc => {
              return new ArchivedShipment(ArchivedShipment._extractDoc(doc))
            }),
            docs: querySnapshots
          }
          : {models: [], docs: querySnapshots}
        return result
      })
  },

  getShippedForecastShipments ({commit, getters}, payload) {
    let predicates = [
      {
        field: `isForecastedPackages`,
        compare: '==',
        value: true
      }
    ]
    if (getters.activeOrganization) {
      predicates.push({
        field: `tenantKey`,
        compare: '==',
        value: getters.activeOrganization
      })
    } else if (getters.activeWarehouse) {
      predicates.push({
        field: `userKey`,
        compare: '==',
        value: getters.activeWarehouse
      })
      predicates = [
        ...predicates,
        ...warehousesSitesPredicates(getters.activeWarehouse, getters.user.roles, getters.currentWarehouseUserSites, 'siteKey')]
    }

    if (payload.predicates && payload.predicates.predicateText) {
      predicates.push({
        field: `keywords`,
        compare: 'array-contains',
        value: payload.predicates.predicateText.toUpperCase()
      })
    }

    payload.startDate && payload.endDate && (predicates = [...predicates, {
      field: `createTime`,
      compare: '>=',
      value: payload.startDate
    },
    {
      field: `createTime`,
      compare: '<=',
      value: payload.endDate
    }])

    return dbAccessor.queryWithPagination(predicates, ['archivedShipments'], 'createTime', true, payload && payload.startAfter, payload && payload.limit)
      .then(querySnapshots => querySnapshots.size ?
        { models: querySnapshots.docs.map(doc => {
          return new ArchivedShipment(ArchivedShipment._extractDoc(doc))
        }),
        docs: querySnapshots} : {models: [], docs: querySnapshots})
  },

  cancelShipment  ({commit, getters}, payload) {
    Logger.log('cancelShipment', payload)
    return dbAccessor.callFunction('processShipment', {
      shipmentKey: payload._key,
      type: 'cancel',
      cancelerKey: getters.userExtra.uid,
      cancelerName: getters.userExtra.name
    })
  },
  clearShipmentData ({state}) {
    state.subscribed.shipments && state.subscribed.shipments()
    state.subscribed.archivedShipments && state.subscribed.archivedShipments()
    delete state.subscribed.shipments
    delete state.subscribed.archivedShipments
    state.shipments = initialState.shipments
    state.archivedShipments = initialState.archivedShipments
  },
  getPaymentRequestForTenant ({commit, getters}) {
    commit('setLoading', true)
    let successFunc = (docs) => {
      let paymentRequests = []
      docs.forEach((doc) => {
        paymentRequests.push({...convertTimestampToDateInObj(doc.data()), paymentKey: doc.id})
      })
      commit('setPaymentRequests', paymentRequests)
      commit('setLoading', false)
    }

    let errorFunc = (error) => {
      console.log(error)
      commit('setLoading', false)
      throw error
    }

    let predicates = [{
      field: 'tenantKey',
      compare: '==',
      value: getters.activeOrganization
    }]

    let unsubscribe = dbAccessor.queryRT(successFunc, errorFunc, predicates, ['paymentRequest'], 'createTime', false)
    commit('addTosubscribed', {paymentRequests: unsubscribe})
  },
  clearPaymentRequestData ({getters, commit}) {
    getters.subscribed.paymentRequests && getters.subscribed.paymentRequests()
    let data = 'paymentRequests'
    commit('clearSubscribed', {data, initValues: initialState[data]})
  },
  getBalancesForTenant ({commit, getters}) {
    let predicates = [{
      field: `tenantKey`,
      compare: '==',
      value: getters.activeOrganization
    }]

    let successFunc = (docs) => {
      let balances = {}
      docs.forEach((doc) => {
        balances[doc.data().userKey] = doc.data()
        balances[doc.data().userKey].balanceKey = doc.id
      })
      commit('setBalance', balances)
    }

    let errorFunc = (error) => {
      console.log(error)
      commit('setLoading', false)
      throw error
    }

    let unsubscribe = dbAccessor.queryRT(successFunc, errorFunc, predicates, ['balance'])
    commit('addTosubscribed', {balances: unsubscribe})
  },
  getAllSystemBalances ({commit, getters}) {
    if (getters.subscribed.systemBalance) return
    const {
      user = {},
      mainAccount = {},
      departments = [],
      isSystemSalesRoleOnly = false
    } = getters
    const { multiFactor = {} } = user
    const userMetaData = multiFactor.user || {}
    let predicates = []
    if (isSystemSalesRoleOnly) {
      const departmentOwnerTarget = departments.find(department => department.leaderName === user.userMeta?.displayName || department.leaderName === user?._delegate.displayName)
      if (departmentOwnerTarget) {
        predicates.push({
          field: `department`,
          compare: '==',
          value: departmentOwnerTarget.name
        })
      } else if (departments.some(({managers = []}) => managers.includes(user.userMeta?.displayName) || managers.includes(user?._delegate.displayName))) {
        predicates.push({
          field: `accountManager`,
          compare: '==',
          value: userMetaData.displayName || mainAccount.name || ''
        })
      } else {
        return
      }
    }
    let successFunc = (docs) => {
      let balances = docs.docs.map((doc) => {
        return {...convertTimestampToDateInObj(doc.data()), clientKey: doc.id}
      })
      commit('setSystemBalances', balances)
    }

    let errorFunc = (error) => {
      console.log(error)
      commit('setLoading', false)
      throw error
    }

    let unsubscribe = dbAccessor.queryRT(successFunc, errorFunc, predicates, ['systemBalance'])
    commit('addTosubscribed', {systemBalance: unsubscribe})
  },
  clearBalancesData ({getters, commit}) {
    getters.subscribed.balances && getters.subscribed.balances()
    let data = 'balances'
    commit('clearSubscribed', {data, initValues: initialState[data]})
  },
  makePayment ({commit, getters}, payload) {
    let nullfields = getNullFields(payload)
    if (nullfields.length > 0) {
      let error = `payload contains null value property (${nullfields.join(',')}). make payment canceled`
      return Promise.reject(Error(error))
    }

    let {userKey, userName, tenantKey, tenantName, amount, estimateDeliverDate, note = ''} = payload
    let paymentMethod = payload.method.displayName ? payload.method.displayName : ''
    let emailPayload = {userKey, userName, tenantKey, tenantName, amount, note, methodName: paymentMethod, estimateDeliverDate: toLocalDateString(estimateDeliverDate)}
    let emailNullfields = getNullFields(emailPayload)
    if (emailNullfields.length > 0) {
      let error = `payload contains null value property (${emailNullfields.join(',')}). make payment canceled`
      return Promise.reject(Error(error))
    }

    Logger.log('makePayment', payload)

    return dbAccessor.runInTransactionStore(async transaction => {
      let paymentRequestDoc = await transaction.get(dbAccessor.buildStoreQuery(['paymentRequest', payload.paymentKey]))
      if (!paymentRequestDoc.exists) throw Error('Payment request has been removed or canceled by the user')
      let balanceDoc = await transaction.get(dbAccessor.buildStoreQuery(['balance', `${tenantKey}_${userKey}`]))
      if (!balanceDoc.exists) throw Error('balance doc is missing')
      let {total} = balanceDoc.data()
      total = addNumbers(total, -payload.amount)
      if (total < 0) throw Error('Payment amount exceeded total balance.')
      payload.newTotalBalance = total
      transaction.delete(paymentRequestDoc.ref)
      transaction.update(balanceDoc.ref, dbAccessor.addUpdateDocTimestamp({total}))
      transaction.set(dbAccessor.getNewDocumentKey('transaction'), dbAccessor.addNewDocTimestamp({...payload, transactionType: 'payment', isPayment: true, isPending: false}))
    })
      .then(() => {
        dbAccessor.callFunction('notifyPaymentFinished', emailPayload)
        console.log('Payment success!')
      })
  },
  getPendingTransactionForTenant ({commit, getters}) {
    commit('setLoading', true)
    let predicates = [
      {
        field: `tenantKey`,
        compare: '==',
        value: getters.activeOrganization
      },
      {
        field: `isPending`,
        compare: '==',
        value: true
      }
    ]
    return dbAccessor.queryWithPredicates(predicates, ['transaction'], 'pendingEndDate', false)
      .then((docs) => {
        let pendingTransactions = []
        docs.forEach((doc) => {
          pendingTransactions.push(convertTimestampToDateInObj(doc.data()))
        })
        commit('setPendingTransactions', pendingTransactions)
        commit('setLoading', false)
      })
  },
  getHistoryTransactionForTenant ({commit, getters}, payload) {
    let predicates = [
      {
        field: `tenantKey`,
        compare: '==',
        value: getters.activeOrganization
      }
    ]

    if (payload && payload.predicates) {
      if (payload.predicates.predicateCheckBox) {
        predicates.push({
          field: `transactionType`,
          compare: '==',
          value: 'payment'
        })
      }
      if (payload.predicates.predicateSelect) {
        predicates.push({
          field: `userKey`,
          compare: '==',
          value: payload.predicates.predicateSelect
        })
      }
      if (payload.predicates.predicateSwitch) {
        payload.startDate && payload.endDate && (predicates = [...predicates, {
          field: `estimateDeliverDate`,
          compare: '>=',
          value: payload.startDate
        },
        {
          field: `estimateDeliverDate`,
          compare: '<=',
          value: payload.endDate
        }])
      } else {
        payload.startDate && payload.endDate && (predicates = [...predicates, {
          field: `createTime`,
          compare: '>=',
          value: payload.startDate
        },
        {
          field: `createTime`,
          compare: '<=',
          value: payload.endDate
        }])
      }
    }

    let orderBy = 'createTime'
    payload && payload.predicates && payload.predicates.predicateSwitch && (orderBy = 'estimateDeliverDate')

    return dbAccessor.queryWithPagination(predicates, ['transaction'], orderBy, true, payload && payload.startAfter, payload && payload.limit)
  },
  cancelTenantPaymentRequest ({commit, getters}, payload) {
    Logger.log('cancelUserPaymentRequest', payload)
    let {tenantKey, userKey} = payload
    return dbAccessor.runInTransactionStore(async transaction => {
      let paymentRequestDoc = await transaction.get(dbAccessor.buildStoreQuery(['paymentRequest', payload.paymentKey]))
      if (!paymentRequestDoc.exists) throw Error('Payment request has been removed or canceled by the user')
      let balanceDoc = await transaction.get(dbAccessor.buildStoreQuery(['balance', `${tenantKey}_${userKey}`]))
      if (!balanceDoc.exists) throw Error('balance doc is missing')
      let {released} = balanceDoc.data()
      released = addNumbers(released, payload.amount)

      transaction.delete(paymentRequestDoc.ref)
      transaction.update(balanceDoc.ref, dbAccessor.addUpdateDocTimestamp({released}))
    })
  },
  addAdjustBalance ({commit, getters}, payload) {
    Logger.log('addAdjustBalance', payload)
    let balanceKey = `${getters.activeOrganization}_${payload.userKey}`
    return dbAccessor.runInTransactionStore(async transaction => {
      let balanceDoc = await transaction.get(dbAccessor.buildStoreQuery(['balance', balanceKey]))
      if (!balanceDoc.exists) throw Error('balance doc is missing')
      let {total, released} = balanceDoc.data()
      released = released + payload.amount
      total = total + payload.amount
      transaction.update(balanceDoc.ref, dbAccessor.addUpdateDocTimestamp({total, released}))
      transaction.set(dbAccessor.getNewDocumentKey('transaction'), dbAccessor.addNewDocTimestamp({...payload, newTotalBalance: total}))
      return 'success'
    })
  },
  async adjustSystemBalance ({ getters }, payload) {
    const {
      clientKey,
      amount,
      note = '',
      clientName = '',
      keywords = [],
      type = 'balance',
      offlineDepositDocId = '',
      offlineType = '',
      attachments = []
    } = payload || {}

    if (!clientKey) throw Error('clientKey is required')
    if (typeof amount !== 'number' || Number.isNaN(amount) || amount === 0) throw Error('invalid amount')

    const operatorName = (getters.operator && getters.operator.name) || (getters.userExtra && getters.userExtra.name) || 'root admin'
    const requestId = `ACB-${getRandomIdByTime(4)}`
    const normalizedKeywords = (Array.isArray(keywords) ? keywords : splitKeyword(keywords || ''))
      .map(item => `${item}`.trim())
      .filter(Boolean)
    const keywordDisplay = normalizedKeywords.join(' ')

    const fields = {
      action: 'adjustSystemBalance',
      status: 'pending',
      requestId,
      clientKey,
      clientName,
      amount: toMoney(amount),
      note,
      details: note,
      type,
      keywords: [type, ...normalizedKeywords.map(item => item.toUpperCase()), `${toMoney(amount)}`],
      keywordDisplay,
      attachments: Array.isArray(attachments) ? attachments : [],
      offlineDepositDocId,
      offlineType,
      isModeLabel: getters.isModeLabel,
      operator: {
        name: operatorName,
        userKey: getters.uid || ''
      }
    }

    return dbAccessor.callFunction('auditClientBalance', fields)
      .then((res) => (res && res.data) || {})
      .catch((error) => {
        throw Error(dbAccessor.getCallFunctionErrMsg(error) || error.message || 'adjust-system-balance-failed')
      })
  },
  getTenantLimitedInfo ({getters, commit, dispatch}) {
    let successFunc = (doc) => {
      const data = doc.data()
      const {application} = data
      if (application && application.status) {
        const isSuccess = application.status === 'success'
        dispatch('addNotification', {
          key: 'general',
          displayName: `an ${application.status} application`,
          pathName: isSuccess ? 'new feature' : 'support',
          path: isSuccess ? application.link : '/support'
        })
        dispatch('getFeatureApplication')
      }
      commit('setTenantLimitedInfo', data)
    }

    let errorFunc = (error) => {
      console.log(error)
      commit('setLoading', false)
      throw error
    }

    let unsubscribe = dbAccessor.queryRT(successFunc, errorFunc, [], ['tenantLimitedInfo', getters.activeOrganization])
    commit('addTosubscribed', {tenantLimitedInfo: unsubscribe})
  },
  async changeTenantLimitedInfo ({getters, dispatch}, payload) {
    // 打开保存的时候直接运行一次，记录数据
    if (payload.isAutoMonthEndClose && payload.isNeedExecuteMonthEndClose) dispatch('callMonthEndClose')
    await dbAccessor.updateFieldsStore(payload, 'tenantLimitedInfo', getters.activeOrganization)
    if (payload.enableAmazonSites) {
      dispatch('getAmazonSites')
    }
    return 'done'
  },
  changeWarehouseLimitedInfo ({getters, commit}, payload) {
    let {isNeedUpdateWarehouseLimitInfo = false, featuresInOrg = {}, generalSettings = {}, defaultLabelCheckChannels = []} = payload
    Object.keys(generalSettings).forEach(key => {
      if (generalSettings[key] === undefined) {
        generalSettings[key] = null
      }
    })
    const needToUpdateDataObj = {generalSettings, defaultLabelCheckChannels}
    if (!isNeedUpdateWarehouseLimitInfo) return dbAccessor.updateFieldsStore(needToUpdateDataObj, 'warehouses', getters.activeWarehouse)
    return dbAccessor.runInTransactionStore(async transaction => {
      let warehouseDoc = await transaction.get(dbAccessor.buildStoreQuery(['warehouses', getters.activeWarehouse]))
      let warehouseLimitInfoDoc = await transaction.get(dbAccessor.buildStoreQuery(['warehouseLimitedInfo', getters.activeWarehouse]))
      transaction.update(warehouseDoc.ref, needToUpdateDataObj)
      transaction.update(warehouseLimitInfoDoc.ref, {featuresInOrg})
    })
  },
  getWarehousesForTenant ({getters, commit, dispatch}, payload) {
    let tenantKey = payload
    let subscribes = getters.subscribed

    subscribes['warehouses'] && (subscribes['warehouses']())

    return new Promise((resolve, reject) => {
      let successFunc = (doc) => {
        let warehouses = doc.data().warehouses
        warehouses.forEach(warehouse => {
          warehouse.sites.forEach(site => {
            warehouse.orgId && (site.orgId = warehouse.orgId)
          })
          if (warehouse.warehouseName === 'self') {
            warehouse.warehouseName = 'Others'
          }
        })
        warehouses.sort((a, b) => {
          if (a.warehouseName === 'Others') {
            return 1
          }
          return -1
        })

        let oldWarehouses = getters.warehouses
        let needToResubscribePromotion = (warehouses.length !== oldWarehouses.length) ||
          warehouses.some((item, index) => item.warehouseKey !== oldWarehouses[index].warehouseKey)

        commit('setWarehouses', warehouses)
        needToResubscribePromotion && dispatch('getWareHousesPromotionsForTenant')
        resolve('subscribed')
      }

      let errorFunc = (error) => {
        console.error(`Warehouses RT error`, error)
        reject(Error(`Warehouses RT error`))
      }

      let unsubscribe = dbAccessor.queryRT(successFunc, errorFunc, [], ['tenantLimitedInfo', tenantKey])
      commit('addTosubscribed', {warehouses: unsubscribe})
    })
  },
  getWarehousesBillingsForTenant ({getters, commit}) {
    if (!getters.activeOrganization) {
      return
    }

    const successFunc = (docs) => {
      let billings = docs.docs.map(doc => {
        return {key: doc.id, ...doc.data()}
      })
      commit('setWarehouseBillings', billings)
    }
    const errorFunc = error => {
      console.log(error)
    }
    const predicates = [{
      field: 'tenantKey',
      compare: '==',
      value: getters.activeOrganization
    }]
    let unsubscribe = dbAccessor.queryCollectionGroupRT(successFunc, errorFunc, predicates, 'billings')
    commit('addTosubscribed', {warehousesBillings: unsubscribe})
  },
  getWareHousesPromotionsForTenant ({getters, commit}) {
    // unsubscribe first, this will be trigger whenever warehouse list changes
    let subscribes = getters.subscribed
    Object.keys(subscribes).forEach(key => {
      if (key.startsWith('warehousesPromotion_') && subscribes[key]) {
        subscribes[key]()
        subscribes[key] = null
      }
    })

    // now re-subscribe
    let wrappedSuccessFunc = promotionWarehouseKey => promotionsDocs => {
      let today = (new Date()).getTime() / 1000
      let promotionsMap = new Map([...getters.warehousesPromotionsMap])

      let activePromotions = []
      if (!promotionsDocs.empty) {
        activePromotions = promotionsDocs.docs.map(promotionDoc => {
          let promotion = promotionDoc.data()
          promotion.key = promotionDoc.id
          return promotion
        }).filter(promotion => (promotion.startDate && promotion.startDate.seconds <= today)
          && !(!promotion.isAllowMultiple && promotion.depositList
            && promotion.depositList.includes(getters.activeOrganization)
          )
        )
      }
      if (activePromotions.length > 0) {
        promotionsMap.set(promotionWarehouseKey, convertTimestampToDateInObj(activePromotions))
      } else if (promotionsMap.has(promotionWarehouseKey)) {
        promotionsMap.delete(promotionWarehouseKey)
      }
      commit('setWarehousesPromotionsMap', promotionsMap)
    }

    let errorFunc = error => {
      console.error(error)
    }

    getters.allPreferredWarehouses.forEach(warehouse => {
      let unsubscribe = dbAccessor.queryStoreRT(
        wrappedSuccessFunc(warehouse.warehouseKey), errorFunc, [{
          field: 'endDate',
          compare: '>=',
          value: new Date()
        }],
        'warehouses', warehouse.warehouseKey, 'promotions')
      commit('addTosubscribed', {['warehousesPromotion_' + warehouse.warehouseKey]: unsubscribe})
    })
  },
  updateTenantReadList ({getters, commit}, readListMap) {
    let promiseArr = []
    readListMap.forEach((promotions, warehouseKey) => {
      promiseArr = promiseArr.concat(
        promotions.map(promotionId => {
          return dbAccessor.updateFieldAddToSetArray(
            ['warehouses', warehouseKey, 'promotions', promotionId],
            'readList', getters.activeOrganization
          )
        })
      )
    })

    return Promise.all(promiseArr)
  },
  async getWarehouseLimitedInfoForTenant ({getters, commit}) {
    const successFunc = (warehouseKey) => {
      /**
       * @param {firebase.firestore.QueryDocumentSnapshot} queryDocSnapshot
       */
      function success (queryDocSnapshot) {
        if (queryDocSnapshot.exists) {
          const {
            otherRates = {},
            rates = {},
            stripePublicLiveKey = '',
            stripePublicTestKey = '',
            warehouseName = '',
            useePayKey,
            useePayOrgNo,
            featuresInOrg = [],
            packings = []
          } = queryDocSnapshot.data()
          let warehouseLimitedInfoForTenant = getters.warehouseLimitedInfoForTenant
          const newInfos = warehouseLimitedInfoForTenant.filter(({key}) => key !== warehouseKey)
          newInfos.push({
            featuresInOrg,
            otherRates,
            rates,
            stripePublicLiveKey,
            stripePublicTestKey,
            warehouseName,
            key: warehouseKey,
            useePayKey,
            useePayOrgNo
          })
          commit('setPackings', packings.map(pkg => {
            return {...pkg, warehouseKey, id: pkg.name || ''}
          }))
          commit('setWarehouseLimitedInfoForTenant', newInfos)
        }
      }
      return success
    }
    let promises = getters.warehouses
      .filter(warehouse => warehouse.warehouseName !== 'Others')
      .map(warehouse => {
        let {warehouseKey} = warehouse
        return dbAccessor.queryStoreRT(
          successFunc(warehouseKey),
          (error) => {
            console.log(error)
            commit('setLoading', false)
            throw error
          },
          [],
          'warehouseLimitedInfo', warehouseKey
        )
      })
    promises.forEach((unsubscribe, index) => {
      commit('addTosubscribed', {['warehouseLimitedInfo_' + index]: unsubscribe})
    })
  },
  getAllWarehouses ({getters, commit}, isSelectAll = false) {
    const predicates = isSelectAll
      ? []
      : [{ field: 'isListed', compare: '==', value: true }]
    return dbAccessor.queryWithPredicatesStore(predicates, 'warehouseLimitedInfo')
      .then(docs => {
        let allWarehouses = []
        docs.forEach(doc => allWarehouses.push({...doc.data(), warehouseKey: doc.id}))
        return allWarehouses
      })
  },
  addSelfSiteForTenant ({getters, commit}, payload) {
    return dbAccessor.queryStore('tenantLimitedInfo', getters.activeOrganization)
      .then(doc => {
        let warehouses = doc.data().warehouses
        warehouses[0].sites.push(payload)
        let newPayload = {
          warehouses: warehouses
        }
        return dbAccessor.updateFieldsStore(newPayload, 'tenantLimitedInfo', getters.activeOrganization)
      })
  },
  editSelfSiteForTenant ({getters, commit}, payload) {
    let {newAddress, oldAddress} = payload
    if (getters.products.some(product => Object.values(product.distribution || {}).some(dist =>
      !dist.warehouseKey && dist.siteName === oldAddress.siteName && dist.quantity > 0
    ))) {
      return Promise.reject(Error('Please clean up related inventory before deleting this site.'))
    }
    return dbAccessor.queryStore('tenantLimitedInfo', getters.activeOrganization)
      .then(doc => {
        let warehouses = doc.data().warehouses
        let siteIndex = warehouses[0].sites.findIndex(site => site.siteName === oldAddress.siteName)
        warehouses[0].sites[siteIndex] = newAddress
        let newPayload = {
          warehouses: warehouses
        }
        return dbAccessor.updateFieldsStore(newPayload, 'tenantLimitedInfo', getters.activeOrganization)
      })
  },
  deleteSelfSiteForTenant ({getters, commit}, payload) {
    if (getters.products.some(product => Object.values(product.distribution || {}).some(dist =>
      !dist.warehouseKey && dist.siteName === payload.siteName && dist.quantity > 0
    ))) {
      return Promise.reject(Error('Please clean up related inventory before deleting this site.'))
    }
    return dbAccessor.queryStore('tenantLimitedInfo', getters.activeOrganization)
      .then(doc => {
        let warehouses = doc.data().warehouses
        warehouses[0].sites = warehouses[0].sites.filter(site => site.siteName !== payload.siteName)
        let newPayload = { warehouses: warehouses }
        return dbAccessor.updateFieldsStore(newPayload, 'tenantLimitedInfo', getters.activeOrganization)
      })
  },
  processPackageFile ({commit, getters}, payload) {
    let data = {tenantKey: getters.activeOrganization, file: payload}
    return dbAccessor.callFunction('importPackagesFromFile', data)
      .then(res => {
        return res.data
      })
  },
  checkTenantDistribution ({getters}, {siteName}) {
    let {products} = getters
    let siteAbrev = `self-${siteName}`
    let warehouseSites = new Set(products
      .map(item => item.distribution ? Object.values(item.distribution)
        .map(distribution => distribution.warehouseSite) : []).flat())
    return warehouseSites.has(siteAbrev)
  },
  searchPackages ({commit, getters}, payload) {
    return getters.activeWarehouse ?
      dbAccessor.queryWithPredicatesStore(payload.predicates, ...payload.path) :
      dbAccessor.queryCollectionGroup(payload.predicates, 'packages')
  },
  async getOneUnlinkPackage ({ commit, dispatch }) {
    const unlinkPackage = await dispatch('searchPackagesPagination', {
      unlinked: true,
      limit: 1,
      predicates: {}
    })
    commit('setUnlinkPackageInfo', unlinkPackage.models)
  },
  searchPackagesPagination ({commit, getters}, payload) {
    let predicates = []
    payload.startDate && payload.endDate && (predicates = [...predicates, {
      field: `createTime`,
      compare: '>=',
      value: payload.startDate
    },
    {
      field: `createTime`,
      compare: '<=',
      value: payload.endDate
    }])
    if (getters.activeOrganization) {
      predicates.push({
        field: 'organizationKey',
        compare: '==',
        value: getters.activeOrganization
      })
    }
    if (getters.activeWarehouse) {
      predicates = [...predicates, ...warehousesSitesPredicates(getters.activeWarehouse, getters.user.roles, getters.currentWarehouseUserSites, 'warehouseSite')]
    }
    if (payload.predicates && payload.predicates.predicateText) {
      let textArr = payload.predicates.predicateText.split('*')
      if (textArr.length === 2) {
        predicates.push({
          field: 'sku',
          compare: '==',
          value: textArr[1]
        })
      } else {
        textArr = payload.predicates.predicateText.split('%')
        if (textArr.length === 2) {
          predicates.push({
            field: 'keywords',
            compare: 'array-contains',
            value: textArr[1].toUpperCase().trim()
          })
        } else {
          predicates.push({
            field: 'upc',
            compare: '==',
            value: textArr[0]
          })
        }
      }
    }
    if (payload.unlinked) {
      predicates.push({
        field: 'isAddedToInventory',
        compare: '==',
        value: false
      })
    }
    if (payload.predicates.predicateSelect) {
      predicates.push({
        field: `organizationKey`,
        compare: '==',
        value: payload.predicates.predicateSelect
      })
    }

    if (payload.predicates.actionPredicates) {
      predicates = [...predicates, ...payload.predicates.actionPredicates]
    }
    let res
    try {
      if (getters.activeOrganization) {
        res = dbAccessor.queryCollectionGroupWithPagination(
          predicates, 'packages', 'createTime', true,
          payload && payload.startAfter,
          payload && payload.limit
        )
      } else {
        res = dbAccessor.queryWithPagination(
          predicates, ['warehouses', getters.activeWarehouse, 'packages'],
          'createTime', true, payload && payload.startAfter,
          payload && payload.limit
        )
      }
    } catch (err) {
      res = Promise.reject(err)
    }
    return res.then(querySnapshots => {
      if (!querySnapshots.size) {
        return {models: [], docs: querySnapshots}
      }
      let models = querySnapshots.docs.map(doc => {
        const warehouseKey = doc.ref.path.split('/')[1]
        return new Package(Package._extractDoc(doc), warehouseKey, getters.uid)
      })
      return {
        models,
        docs: querySnapshots
      }
    }
    )
  },
  searchBoxesPagination ({commit, getters}, payload) {
    let predicates = []
    payload.startDate && payload.endDate && (predicates = [...predicates, {
      field: `createTime`,
      compare: '>=',
      value: payload.startDate
    },
    {
      field: `createTime`,
      compare: '<=',
      value: payload.endDate
    }])
    if (getters.activeOrganization) {
      predicates.push({
        field: 'organizationKey',
        compare: '==',
        value: getters.activeOrganization
      })
    }
    if (getters.activeWarehouse) {
      predicates = [...predicates, ...warehousesSitesPredicates(getters.activeWarehouse, getters.user.roles, getters.currentWarehouseUserSites, 'warehouseSite')]
    }
    if (payload.predicates && payload.predicates.predicateText) {
      let textArr = payload.predicates.predicateText.split('*')
      if (textArr.length === 2) {
        predicates.push({
          field: 'sku',
          compare: '==',
          value: textArr[1]
        })
      } else {
        textArr = payload.predicates.predicateText.split('%')
        predicates.push({
          field: 'keywords',
          compare: 'array-contains',
          value: textArr[0].trim()
        })
      }
    }
    if (payload.predicates.predicateSelect) {
      predicates.push({
        field: `organizationKey`,
        compare: '==',
        value: payload.predicates.predicateSelect
      })
    }

    if (payload.predicates.actionPredicates) {
      predicates = [...predicates, ...payload.predicates.actionPredicates]
    }
    let res
    try {
      if (getters.activeOrganization) {
        res = dbAccessor.queryCollectionGroupWithPagination(
          predicates, 'boxes', 'createTime', true,
          payload && payload.startAfter,
          payload && payload.limit
        )
      } else {
        res = dbAccessor.queryWithPagination(
          predicates, ['warehouses', getters.activeWarehouse, 'boxes'],
          'createTime', true, payload && payload.startAfter,
          payload && payload.limit
        )
      }
    } catch (err) {
      res = Promise.reject(err)
    }
    return res.then(querySnapshots => querySnapshots.size ?
      {
        models: querySnapshots.docs.map(doc => {
          let data = convertTimestampToDateInObj(doc.data())
          return {_key: doc.id, ...data}
        }),
        docs: querySnapshots
      } : {models: [], docs: querySnapshots}
    )
  },
  async uploadPackagesFinanceInfo ({ commit, getters }, payload) {
    const MAX = 5
    const { rows, headers } = payload
    if (!getters.user.roles.some(role => ['warehouseFinance', 'warehousePackageOperator'].includes(role))) return
    if (headers.length < 8) {
      throw Error('File format does not match, please check')
    }

    const errorPackages = []
    const successPackages = []
    for (let i = 0; i < rows.length; i += MAX) {
      const batchRows = rows.slice(i, i + MAX)
      const batch = dbAccessor.getFireStoreBatch()
      await Promise.all(batchRows.map(async row => {
        try {
          let [tracking, upc, , , orgName, , , , , clientName = '', clientKey = '', cost, note = ''] = row
          tracking = tracking.toString()
          upc = upc.toString()
          if (!tracking || !upc || !orgName) {
            throw Error('missing data, tracking or upc or orgName')
          }
          let predicates = [{
            field: 'upc',
            compare: '==',
            value: upc
          }, {
            field: 'trackings',
            compare: 'array-contains',
            value: tracking.split(',')[0]
          }]
          const packageDocs = await dbAccessor.queryWithPredicatesStore(predicates, 'warehouses', getters.activeWarehouse, 'packages')
          if (packageDocs.empty) {
            throw Error('can not find target data')
          }
          if (packageDocs.docs.length > 1) {
            throw Error('find dup target data, please check')
          }
          const targetRef = packageDocs.docs[0].ref
          const updateFields = {}
          if (clientName) {
            updateFields['financeInfo.clientName'] = clientName
          }
          if (clientKey) {
            updateFields['financeInfo.clientKey'] = clientKey
          }
          if (typeof cost === 'number' && cost >= 0 && getters.user.roles.some(role => ['warehouseFinance'].includes(role))) {
            updateFields['financeInfo.cost'] = +cost
          }
          if (note) {
            updateFields['financeInfo.note'] = note
          }
          batch.update(targetRef, dbAccessor.addUpdateDocTimestamp(updateFields))
          successPackages.push(row)
        } catch (err) {
          errorPackages.push([err.message, ...row])
        }
      }))
      await batch.commit()
    }
    return { successPackages, errorPackages }
  },
  generateInvitationCode ({commit, getters}) {
    let invitationCode = Math.random().toString(36).substr(2)
    let payload = {...getters.tenant, invitationCode}
    commit('setTenant', payload)
    return dbAccessor.updateFieldsStore(payload, 'tenants', getters.activeOrganization)
  },
  getReportLostTenant ({commit, getters}) {
    let predicates = [{
      field: `tenantKey`,
      compare: '==',
      value: getters.activeOrganization
    }]

    let successFunc = (docs) => {
      let reportLost = docs.docs.map(doc => {
        let reportDoc = convertTimestampToDateInObj(doc.data())
        return {reportKey: doc.id, ...reportDoc}
      })
      commit('setReportLost', reportLost)
    }

    let errorFunc = (error) => {
      console.log(error)
      commit('setLoading', false)
      throw error
    }

    let unsubscribe = dbAccessor.queryRT(successFunc, errorFunc, predicates, ['reportLost'], 'createTime', false)
    commit('addTosubscribed', {reportLost: unsubscribe})
  },
  clearReportLostData ({getters, commit}) {
    getters.subscribed.reportLost && getters.subscribed.reportLost()
    let data = 'reportLost'
    commit('clearSubscribed', {data, initValues: initialState[data]})
  },
  acceptReport ({getters, commit}, payload) {
    Logger.log('acceptReport', payload)
    let tenantRef = dbAccessor.buildStoreQuery(['tenants', payload.tenantKey, 'inventory', payload.productId])
    let reportRef = dbAccessor.buildStoreQuery(['reportLost', payload.reportKey])
    let balanceRef = dbAccessor.buildStoreQuery(['balance', `${payload.tenantKey}_${payload.userKey}`])
    let transactionRef = dbAccessor.buildStoreQuery(['transaction']).doc()
    let userRef = dbAccessor.buildStoreQuery(['userLimitedInfo', payload.userKey, 'inventory', payload.productKey])
    let relatedReportLost = getters.reportLost.filter(rl => rl.productKey === payload.productKey)

    return dbAccessor.runInTransactionStore(transaction => {
      return Promise.all([transaction.get(tenantRef), transaction.get(balanceRef), transaction.get(userRef), transaction.get(reportRef)])
        .then(([tenantDoc, balanceDoc, userDoc, reportDoc]) => {
          if (!reportDoc.exists) throw Error('missing report.')
          let newPayload = {}
          let balance = balanceDoc.data()
          balance.total = addNumbers(balance.total, -payload.quantity * payload.price)
          balance.released = addNumbers(balance.released, -payload.quantity * payload.price)
          let { distribution, quantity: storeQuantity } = tenantDoc.data()
          newPayload.quantity = storeQuantity - payload.quantity
          // check quantity
          let tenantDistributionKey = Buffer.from(payload.productId + payload.userKey + payload.warehouseSite).toString('base64')
          if (distribution[tenantDistributionKey].quantity === payload.quantity) {
            delete distribution[tenantDistributionKey]
          } else {
            distribution[tenantDistributionKey].quantity -= payload.quantity
          }
          newPayload.distribution = distribution
          transaction.delete(reportRef)
          transaction.update(balanceRef, dbAccessor.addUpdateDocTimestamp(balance))
          transaction.set(transactionRef, dbAccessor.addNewDocTimestamp({newTotalBalance: balance.total, amount: payload.price * payload.quantity, ...payload, transactionType: 'reportLost', tenantName: getters.tenant.name}))
          transaction.update(tenantRef, dbAccessor.addUpdateDocTimestamp(newPayload))
          if (userDoc.data().quantity === 0 && relatedReportLost.length <= 1) {
            return transaction.delete(userRef)
          }
          if (userDoc.data().distribution[payload.distributionKey] === 0) {
            delete userDoc.data().distribution[payload.distributionKey]
            return transaction.update(userRef, dbAccessor.addUpdateDocTimestamp({distribution: userDoc.data().distribution}))
          }
          return transaction.update(userRef, dbAccessor.addUpdateDocTimestamp({}))
        })
    })
      .catch(error => {
        Logger.critical('reportLost', {error: error.message, ...payload})
      })
  },
  cancelReportTenant ({getters, commit}, payload) {
    Logger.log('cancelReport', payload)
    let { distributionKey, quantity: reportLostQty, warehouseSite } = payload
    let userRef = dbAccessor.buildStoreQuery(['userLimitedInfo', payload.userKey, 'inventory', payload.productKey])
    let reportRef = dbAccessor.buildStoreQuery(['reportLost', payload.reportKey])

    return dbAccessor.runInTransactionStore(transaction => {
      return transaction.get(userRef)
        .then(doc => {
          let newPayload = {}
          let { distribution } = doc.data()
          newPayload.quantity = doc.data().quantity + reportLostQty
          if (distribution && distribution[distributionKey] && distribution[distributionKey].quantity) {
            distribution[payload.distributionKey].quantity += payload.quantity
          } else {
            distribution[payload.distributionKey] = { quantity: reportLostQty, warehouseSite }
          }
          newPayload.distribution = distribution
          transaction.delete(reportRef)
          return transaction.update(userRef, dbAccessor.addUpdateDocTimestamp(newPayload))
        })
    })
  },
  addDestination ({commit, getters}, payload) {
    return dbAccessor.updateFieldAddToArrayStore('destinations', payload, 'tenants', getters.activeOrganization)
  },
  editDestination ({commit, getters}, payload) {
    let ref = dbAccessor.buildStoreQuery(['tenants', getters.activeOrganization])
    return dbAccessor.runInTransactionStore(transaction => {
      return transaction.get(ref)
        .then(doc => {
          let tenant = doc.data()
          let {index, ...info} = payload
          tenant.destinations[index] = info
          return transaction.update(ref, dbAccessor.addUpdateDocTimestamp({destinations: tenant.destinations}))
        })
    })
  },
  deleteDestination ({commit, getters}, payload) {
    let ref = dbAccessor.buildStoreQuery(['tenants', getters.activeOrganization])
    return dbAccessor.runInTransactionStore(transaction => {
      return transaction.get(ref)
        .then(doc => {
          let tenant = doc.data()
          let {index} = payload
          tenant.destinations.splice(index, 1)
          tenant.destinations = [...tenant.destinations]
          return transaction.update(ref, dbAccessor.addUpdateDocTimestamp({destinations: tenant.destinations}))
        })
    })
  },
  addInstruction ({commit, getters}, payload) {
    return dbAccessor.updateFieldAddToArrayStore('instructions', payload, 'tenants', getters.activeOrganization)
  },
  editInstruction ({commit, getters}, payload) {
    let ref = dbAccessor.buildStoreQuery(['tenants', getters.activeOrganization])
    return dbAccessor.runInTransactionStore(transaction => {
      return transaction.get(ref)
        .then(doc => {
          let tenant = doc.data()
          let {index, ...info} = payload
          tenant.instructions[index] = info
          return transaction.update(ref, dbAccessor.addUpdateDocTimestamp({instructions: tenant.instructions}))
        })
    })
  },
  deleteInstruction ({commit, getters}, payload) {
    let ref = dbAccessor.buildStoreQuery(['tenants', getters.activeOrganization])
    return dbAccessor.runInTransactionStore(transaction => {
      return transaction.get(ref)
        .then(doc => {
          let tenant = doc.data()
          let {index} = payload
          tenant.instructions.splice(index, 1)
          tenant.instructions = [...tenant.instructions]
          return transaction.update(ref, dbAccessor.addUpdateDocTimestamp({instructions: tenant.instructions}))
        })
    })
  },
  submitPayRequest ({commit, getters}, payload) {
    let {paymentType} = payload
    payload.tenantKey = getters.activeOrganization || ''
    payload.user && (payload.user.userName = getters.userExtra.name)
    if (payload.payVendor === 'authorize') {
      const userEmail = getters.userExtra?.email
      const clientKey = getters.activeOrganization || getters.activeWarehouse
      const { name } = getters.userExtra
      payload.businessArgs = {clientKey, receiptEmail: userEmail, clientName: name, note: `${payload.payVendor} online charge ${payload.amount} dollars`}
      if (payload.warehouseKey) payload.businessArgs.warehouseKey = payload.warehouseKey
      if (payload.warehouseName) payload.businessArgs.warehouseName = payload.warehouseName
    }
    if (!paymentType) throw Error('invalid-payment-type')
    return dbAccessor.callFunction('makePayment', payload)
  },
  mergeProducts ({commit, getters}, payload) {
    let {curProductId, targetProductId} = payload
    return dbAccessor.callFunction('mergeTwoProducts', {
      currentProductId: curProductId,
      targetProductId,
      tenantKey: getters.activeOrganization
    }).then(() => {
      return Logger.changeLog({
        beforeValue: payload.beforeValue,
        actionPayload: payload.payload,
        actionName: 'mergeProducts',
        categories: ['inventory'],
        keys: [curProductId, targetProductId],
        keywords: payload.keywords
      })
    })
  },
  getTenantAnnouncements ({commit, getters}, payload) {
    const cbFunc = (data) => {
      commit('setTenantAnnouncements', data)
    }
    let unsubscribe = Announcement.getByTenantRT(cbFunc, getters.activeOrganization)
    commit('addTosubscribed', {tenantAnnouncements: unsubscribe})
  },
  addPackageReportTenant ({commit, getters}, payload) {
    let report = new PackageReportTenant(payload, getters.activeOrganization)
    return report.insert()
  },
  deletePackageReportTenant ({commit, getters}, payload) {
    let report = new PackageReportTenant(payload, getters.activeOrganization)
    return report.delete()
  },
  loadPackageReportsTenant ({commit, getters}) {
    const cbFunc = (data) => {
      commit('setPackageReports', data)
    }
    let unsubscribe = PackageReportTenant.getRT(cbFunc, getters.activeOrganization, [])
    commit('addTosubscribed', {packageReports: unsubscribe})
  },
  getPendingProductTransfer ({dispatch, commit, getters}) {
    let predicates = [{
      field: 'isPending',
      compare: '==',
      value: true
    }, {
      field: `involvedKeys`,
      compare: 'array-contains',
      value: getters.activeOrganization || getters.activeWarehouse
    }]

    const cbFunc = (data) => {
      commit('setPendingProductTransfers', data)
      if (data.length) {
        dispatch('addNotification', {
          key: 'newPendingTransfers',
          displayName: 'pending product transfer',
          pathName: 'product transfer',
          path: '/productTransferTenant'
        })
      } else commit('removeNotification', {key: 'newPendingTransfers'})
    }
    let unsubscribe = ProductTransfer.getRT(cbFunc, predicates, [['createTime', false]])
    commit('addTosubscribed', {pendingProductTransfers: unsubscribe})
  },
  async validateOrgByWarehouseKeyIsDClass ({getters}, {warehouseKey, organizationKey}) {
    try {
      const orgDoc = await dbAccessor.buildStoreQuery(['warehouses', warehouseKey, 'organizations', organizationKey]).doc()

      if (!orgDoc.exists) {
        return false
      }
      const data = orgDoc.data()

      if (data.features.includes('InboundForecastDropshipping')) {
        return true
      }
      return false
    } catch (error) {
      return false
    }
  },
  async createProductTransfer ({commit, getters, dispatch}, payload) {
    let {productsSelected, toName, note, files, userKey, userName, to, isModifiable} = payload

    let {warehouseSite, warehouseKey, siteName, uid} = productsSelected[0]
    if (productsSelected.some(item => item.warehouseSite !== warehouseSite)) throw Error('Transfer items must belong to the same site.')
    if (productsSelected.some(item => !item.toShip)) throw Error('Transfer quantity must greater than 0')
    if (productsSelected.some(item => !(item.unitPrice >= 0))) throw Error('Unit price must be a number greater or equal to 0.')
    if (productsSelected.some(item => item.unitPrice !== 0 && !item.unitPrice)) throw Error('Unit price is missing')
    if (await dispatch('validateOrgByWarehouseKeyIsDClass', {warehouseKey, organizationKey: to})) {
      throw Error('Cannot transfer to D class organization')
    }
    if (await dispatch('validateOrgByWarehouseKeyIsDClass', {warehouseKey, organizationKey: getters.activeOrganization})) {
      throw Error('D class organization cannot transfer')
    }
    let transferInfo = {
      note,
      location: siteName,
      from: getters.activeOrganization,
      fromName: getters.userExtra.name,
      toName: toName.trim(),
      items: productsSelected.map(item => {
        let {warehouseSite, warehouseKey, siteName, userName, uid, productId, toShip, unitPrice, upc, name, id, condition, asin, fbmKey} = item
        return {warehouseSite, warehouseKey, siteName, userName, uid, productId, toShip, unitPrice, upc, name, id, condition, asin, fbmKey}
      }),
      warehouseKey,
      warehouseSite,
      userName,
      uid,
      warehouseName: productsSelected[0].userName,
      files,
      userKey,
      isModifiable,
      to
    }
    let transfer = new ProductTransfer(transferInfo)
    return transfer.insert()
  },
  modifyTransferProductPrice ({commit, getters}, payload) {
    Logger.log('modifyTransferProductPrice', {...payload, operator: getters.activeOrganization})
    const {items, _key} = payload
    return dbAccessor.updateFieldsStore(dbAccessor.addUpdateDocTimestamp({items}), 'transferTransactions', _key)
  },
  addTransferToInventory ({commit, getters}, payload) {
    let transfer = new ProductTransfer(payload)
    return transfer.addToInventory()
  },
  getHistoryTransfers ({commit, getters}, payload) {
    let {startDate, endDate} = payload
    let predicates = []

    if (payload && payload.predicates && payload.predicates.actionPredicates) {
      predicates = [...predicates, ...payload.predicates.actionPredicates]
    }

    if (startDate) {
      predicates.push({
        field: `createTime`,
        compare: '>=',
        value: startDate
      })
    }

    if (endDate) {
      predicates.push({
        field: `createTime`,
        compare: '<=',
        value: endDate
      })
    }
    const { user, activeWarehouse, currentWarehouseUserSites } = getters
    return dbAccessor.queryWithPagination(
      [...predicates, ...warehousesSitesPredicates(activeWarehouse, user.roles, currentWarehouseUserSites, 'warehouseSite')],
      ['transferTransactions'],
      'createTime',
      true,
      payload && payload.startAfter,
      payload && payload.limit
    )
  },
  sendAnnouncementEmails ({commit}, payload) {
    return dbAccessor.callFunction('sendAnnouncementEmails', payload)
  },
  async checkToShowReturnPackageNotification ({commit, getters, dispatch}, payload) {
    const intervalTime = 43200000
    const returnPackageTimer = getters.returnPackageTimer
    if (returnPackageTimer) {
      clearTimeout(returnPackageTimer)
    } else {
      const predicates = [
        {
          field: 'clientKey',
          compare: '==',
          value: getters.activeOrganization
        },
        {
          field: 'status',
          compare: '==',
          value: 'returnReceived'
        }
      ]
      const isTargetDocExists = await dbAccessor.exists(predicates, ['returnPackages'])
      let notifications = [...getters.notifications.filter(({key}) => key !== 'returnPackageNotifications')]
      if (isTargetDocExists) {
        notifications.push({
          key: 'returnPackageNotifications',
          displayName: 'return packages',
          pathName: 'returnPackages',
          path: '/returnPackages'
        })
      }
      commit('setNotifications', notifications)
    }
    const timer = setTimeout(() => {
      commit('setReturnPackageTimer', null)
      dispatch('checkToShowReturnPackageNotification')
    }, intervalTime)

    commit('setReturnPackageTimer', timer)
  },
  getActiveSupports ({getters, commit}, payload) {
    const uid = getters.user.uid
    const checkSCase = (sCase) => {
      return (sCase.comments.length === 0 &&
        sCase['lastRead_' + uid] &&
        sCase['lastRead_' + uid].getTime() < sCase.createTime.getTime()
      ) ||
      (sCase.comments.length > 0 &&
        sCase['lastRead_' + uid] &&
        sCase['lastRead_' + uid].getTime() < sCase.comments[sCase.comments.length - 1].createTime.getTime()
      )
    }

    const cbFunc = (data) => {
      let isNewPendingCase = false
      let isNewInProgressComment = false
      let notifications = [...getters.notifications.filter(({key}) => key !== 'newPendingSupportCase' && key !== 'newInProgressSupportComments')]
      for (let sCase of data) {
        if (!isNewPendingCase &&
          sCase.status === 'pending' &&
          getters.activeWarehouse && !sCase.agentUid
        ) {
          notifications.push({
            key: 'newPendingSupportCase',
            displayName: 'unassigned support case',
            pathName: 'support',
            path: '/support'
          })
          isNewPendingCase = true
        }
        if (!isNewInProgressComment && (
          (!sCase['lastRead_' + uid] && sCase.comments.length) ||
          checkSCase(sCase)
        )) {
          notifications.push({
            key: 'newInProgressSupportComments',
            displayName: 'new support comment',
            pathName: 'support',
            path: '/support'
          })
          isNewInProgressComment = true
        }
      }
      commit('setNotifications', notifications)
      commit('setSupports', data)
    }
    const userExtra = getters.userExtra
    const currentUserAuthorities = getters.user.roles
    let currentUserRoleCode = (userExtra && String(userExtra.role)) || ''
    let unsubscribe
    if (getters.activeOrganization) {
      unsubscribe = Support.getByTenantRT(cbFunc, getters.activeOrganization, getters.user.uid)
    } else if (getters.activeWarehouse) {
      if (currentUserRoleCode === '1' && userExtra && userExtra.warehouses && userExtra.warehouses.length) currentUserRoleCode = '2'
      const isAvailable = validateUserModuleAuthority(currentUserAuthorities, 'Support', currentUserRoleCode || 'admin')
      if (isAvailable) unsubscribe = Support.getByWarehouseRT(cbFunc, getters.activeWarehouse, getters.user.uid)
    } else if (getters.user.isAdmin) {
      unsubscribe = Support.getByAdminRT(cbFunc, getters.user.uid)
    }
    if (unsubscribe !== undefined) commit('addTosubscribed', {supportsOnSubscribed: unsubscribe})
  },
  async addSupport ({commit, state, getters}, payload) {
    const res = await dbAccessor.callFunction('processSupport', {
      action: 'create',
      ...payload
    })
    return res.data
  },
  async findExistingSupportByTracking ({getters}, payload) {
    const lookup = typeof payload === 'string' ? { trackingNumber: payload } : (payload || {})
    const trackingValue = String(lookup.trackingNumber || '').trim()
    const normalizedTrackingNumber = trackingValue.toUpperCase()
    const tenantKey = String(getters.activeOrganization || '').trim()

    if (!trackingValue || !tenantKey) {
      return null
    }

    const supportSnapshot = await dbAccessor.queryWithPredicatesStore([
      { field: 'keywords', compare: 'array-contains', value: normalizedTrackingNumber },
      { field: 'tenantKey', compare: '==', value: tenantKey }
    ], 'supports')
    const supports = supportSnapshot.docs.map(doc => Support._extractDoc(doc))
    const activeStatuses = ['pending', 'in progress']
    supports.sort((left, right) => {
      const statusDifference = Number(activeStatuses.includes(right.status)) - Number(activeStatuses.includes(left.status))
      if (statusDifference) {
        return statusDifference
      }
      return new Date(right.lastModifiedTime || right.createTime || 0).getTime() -
        new Date(left.lastModifiedTime || left.createTime || 0).getTime()
    })

    return supports[0] || null
  },
  async getSupportByKey ({getters}, caseKey) {
    const support = await Support.get('supports', caseKey)

    if (getters.activeOrganization && support.tenantKey !== getters.activeOrganization) {
      throw new Error('support-case-not-available')
    }

    return support
  },
  cancelSupport ({commit}, payload) {
    return (payload instanceof Support) ? payload.delete() : Support.deleteByKey(payload._key)
  },
  updateSupport ({commit}, payload) {
    const {key, ...fields} = payload
    return Support.updateByKey(fields, key)
  },
  resolveSupport ({commit, getters}, payload) {
    const {key, keywords, details, ...rest} = payload
    const fields = {
      ...rest,
      internalComment: {
        content: details,
        createTime: new Date(),
        name: (getters.userExtra && getters.userExtra.name) || 'IT support',
        userKey: getters.uid,
        isResolution: true
      },
      status: 'closed',
      keywordDisplay: keywords,
      keywords: [
        ...payload.resolveTypes.map(type => `RES-${type.split(' ').join('-').toUpperCase()}`),
        ...splitKeyword(keywords).map(item => item.toUpperCase())
      ],
      action: 'resolve',
      key
    }
    return dbAccessor.callFunction('processSupport', fields).then(() => {
      return fields
    })
  },
  getDoneSupports ({getters, commit}, payload) {
    let predicates = [{ field: `status`, compare: '==', value: 'closed' }]
    if (getters.activeOrganization) {
      predicates.push({ field: `tenantKey`, compare: '==', value: getters.activeOrganization })
    } else if (getters.activeWarehouse) {
      predicates.push({ field: `warehouseKey`, compare: '==', value: getters.activeWarehouse })
    }
    if (payload.startDate) {
      const oneYearAgo = new Date()
      oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1)
      payload.startDate = oneYearAgo
    }

    if (payload.startDate && payload.endDate) {
      predicates = [
        ...predicates,
        { field: `lastModifiedTime`, compare: '>=', value: payload.startDate },
        { field: `lastModifiedTime`, compare: '<=', value: payload.endDate }
      ]
    }
    if (payload.predicates && payload.predicates.predicateText) {
      predicates.push({
        field: 'keywords', compare: 'array-contains', value: payload.predicates.predicateText.toUpperCase().trim()
      })
    }

    if (payload.predicates && payload.predicates.actionPredicates?.length) {
      predicates.push(...payload.predicates.actionPredicates)
    }

    if (payload.predicates && payload.predicates.predicateSelect && getters.activeOrganization) {
      predicates.push({ field: `warehouseKey`, compare: '==', value: payload.predicates.predicateSelect })
    }

    if (getters.user.isAdmin) {
      predicates.push({
        field: `warehouseKey`,
        compare: '==',
        value: 'system'
      })
    }
    return dbAccessor.queryWithPagination(predicates, ['supports'], 'lastModifiedTime', true, payload && payload.startAfter, payload && payload.limit)
  },
  async validateUser ({commit, getters, dispatch}, payload) {
    let {tenantName, userName, warehouseKey} = payload
    let predicates = (value) => [{
      field: 'name',
      compare: '==',
      value: value
    }]
    let [userDocs, tenantKey] = await Promise.all([dbAccessor.queryWithPredicatesStore(predicates(userName), 'users'), dispatch('validateTenant', {tenantName, warehouseKey})])

    if (userDocs.size !== 1) return Promise.reject(Error('Balance receiver does not exist, please double check.'))

    let {workfor = {}} = userDocs.docs[0].data()
    return {result: workfor[tenantKey] === 3, userKey: userDocs.docs[0].id, to: tenantKey}
  },
  async validateTenant ({commit, getters}, payload) {
    let {tenantName, warehouseKey} = payload
    let predicates = [{
      field: `name`,
      compare: '==',
      value: tenantName
    }]

    let targetTenantDoc = await dbAccessor.queryWithPredicatesStore(predicates, 'tenantLimitedInfo')
    if (targetTenantDoc.size > 1) throw Error('Same name found from different organizations, please contact IT support.')
    if (targetTenantDoc.size === 0) throw Error('Organization name does not exist.')
    if (targetTenantDoc.docs[0].id === getters.activeOrganization || !warehouseKey) throw Error('Self transfers are not supported.')
    let {warehouses} = targetTenantDoc.docs[0].data()
    if (!warehouses.some(item => item.warehouseKey === warehouseKey)) throw Error(`Recipient organization hasn't signup this warehouse.`)

    return targetTenantDoc.docs[0].id
  },
  cancelTransfer ({commit, getters}, payload) {
    return payload.delete()
  },
  updatePackageOrgNote ({commit, getters}, payload) {
    const {warehouseSite, orgNote, pkgKey} = payload
    // get warehouseKey by warehouse Site
    let warehouseKey
    if (warehouseSite) {
      warehouseKey = (getters.warehouses.find(warehouse =>
        (warehouse.sites || []).some(site => site.key === warehouseSite)
      ) || {}).warehouseKey
      if (!warehouseKey) throw Error('update-org-note-invalid-warehouseKey')
    } else {
      warehouseKey = getters.activeOrganization
    }

    return dbAccessor.updateFieldsStore({orgNote},
      'warehouses', warehouseKey, 'packages', pkgKey
    )
  },
  /**
   * Only for offer in frontend
   * @param {{``
   *  productId: string,
   *  data: {
   *    offerId: string,
   *    price: number,
   *    allowSelf: boolean,
   *    bonus?: number
   *  }
   * }} payload */
  async setProductPriceHistoryOfferNode ({getters}, payload) {
    let priceHistory = await PriceHistory.get(getters.activeOrganization, payload.productId)
    priceHistory.addPriceHistoryOfferItem(payload.data)
    await priceHistory.update()
  },
  async getProductPriceHistory ({commit, getters}, payload) {
    const {productId} = payload
    if (productId) {
      let now = new Date()
      let index = getters.priceHistories.findIndex(item => item.productId === productId)
      if (index >= 0 &&
        getters.priceHistories[index].lastUpdatedTime > getters.cronjobTimes.productPriceLastScanDate
      ) return
      let priceHistory = await PriceHistory.get(getters.activeOrganization, productId)
      let newItem = {
        inbound: (priceHistory || {}).inbound || [],
        lastUpdatedTime: now,
        productId
      }
      let newPriceHistories = [...getters.priceHistories]
      if (index >= 0) {
        newPriceHistories[index] = newItem
      } else newPriceHistories.push(newItem)
      commit('setPriceHistories', newPriceHistories)
    }
  },
  async addUserToTenant ({commit, getters, dispatch}, payload) {
    // is there security risk?
    const { userExtra, activeOrganization } = getters
    let predicates = [{
      field: 'email',
      compare: '==',
      value: payload.email
    }]
    let docs = await dbAccessor.queryWithPredicatesStore(predicates, 'users')

    if (docs.size === 0) {
      throw Error('Email address not found.')
    }

    const userDoc = docs.docs[0]
    const { warehouses = [], organizations = [], accounts = [], role } = userDoc.data()
    if (role !== 1) throw Error('Only individuals can be staff of the company.')
    if (accounts.length >= 10) throw Error('He became an staff(member) of up to ten companies, cannot add.')
    let userPayload = {
      organizations: [activeOrganization],
      accounts: dbAccessor.fieldValue().arrayUnion({
        email: userExtra.email,
        name: userExtra.name,
        key: activeOrganization,
        role: userExtra.role,
        roles: payload.roles
      })
    }
    if (warehouses.length && !accounts.length) {
      const {users = [], name: warehousesName} = (await dbAccessor.queryStore('warehouses', warehouses[0])).data()
      let warehousesInfo = users.find(user => user.name === warehousesName)
      userPayload = {
        accounts: [
          {
            email: warehousesInfo.email,
            name: warehousesInfo.name,
            key: warehouses[0],
            role: 2,
            roles: warehousesInfo.roles
          },
          {
            email: userExtra.email,
            name: userExtra.name,
            key: activeOrganization,
            role: userExtra.role,
            roles: payload.roles
          }]
      }
    }
    if (organizations.length && !accounts.length) {
      const {users = [], name: tenantName} = (await dbAccessor.queryStore('tenants', organizations[0])).data()
      let tenantInfo = users.find(user => user.name === tenantName)
      userPayload = {
        accounts: [
          {
            email: tenantInfo.email,
            name: tenantInfo.name,
            key: organizations[0],
            role: 0,
            roles: tenantInfo.roles
          },
          {
            email: userExtra.email,
            name: userExtra.name,
            key: activeOrganization,
            role: userExtra.role,
            roles: payload.roles
          }]
      }
    }
    if (warehouses.length || organizations.length) delete userPayload.organizations
    let params = userPayload.accounts.reduce?.((acc, account) => {
      acc[account.key] = account.roles
      return acc
    }, {
      email: payload.email,
      roles: accounts[0]?.roles || payload.roles,
      [activeOrganization]: payload.roles
    }) ||
    accounts.reduce((acc, account) => {
      acc[account.key] = account.roles
      return acc
    }, {
      email: payload.email,
      roles: accounts[0]?.roles || payload.roles,
      [activeOrganization]: payload.roles
    })
    return dbAccessor.runInBatch(batch => {
      batch.update(dbAccessor.buildStoreQuery(['tenants', activeOrganization]), {
        users: dbAccessor.fieldValue().arrayUnion({
          ...payload,
          key: docs.docs[0].id,
          name: docs.docs[0].data().name
        })
      })

      batch.update(dbAccessor.buildStoreQuery(['users', docs.docs[0].id]), userPayload)
    })
      .then(() => {
        return dbAccessor.callFunction('grantUserRole', params)
      })
  },
  async removeUserFromTenant  ({commit, getters, dispatch}, payload) {
    // is there security risk?
    const tenantRef = dbAccessor.buildStoreQuery(['tenants', getters.activeOrganization])
    const predicates = [
      {
        field: `email`,
        compare: '==',
        value: payload.email
      }
    ]
    const userDocs = await dbAccessor.queryWithPredicatesStore(predicates, 'users')
    if (userDocs.size === 0) {
      throw Error('Email address not found.')
    }
    const userRef = userDocs.docs[0].ref
    let params = {}
    return dbAccessor.runInTransactionStore(async (transaction) => {
      return Promise.all([transaction.get(tenantRef), transaction.get(userRef)])
        .then(([tenantDoc, userDoc]) => {
          let { accounts = [] } = userDoc.data()
          let { users = [] } = tenantDoc.data()
          let userAccounts = accounts.filter((account) => account.email !== getters.userExtra.email)
          let userPayload = {
            accounts: userAccounts,
            organizations: []
          }
          params = userAccounts.reduce((acc, account) => {
            acc[account.key] = account.roles
            return acc
          }, {
            email: payload.email,
            roles: ['user']
          })
          if (accounts[0].email !== getters.userExtra.email) {
            delete userPayload.organizations
            params.roles = accounts[0].roles
          }
          if (accounts[1] && accounts[0].email === getters.userExtra.email) {
            params.roles = accounts[1].roles
            if (accounts[1].role === 0) userPayload.organizations = [accounts[1].key]
            if (accounts[1].role === 2) userPayload.warehouses = [accounts[1].key]
          }

          transaction.update(tenantRef, {
            users: users.filter(user => user.email !== payload.email)
          })
          !userPayload.accounts.length && (userPayload.organizations = [])
          transaction.update(userRef, userPayload)
        })
    })
      .then(() => {
        return dbAccessor.callFunction('grantUserRole', params)
      })
  },
  async editUserForTenant  ({commit, getters, dispatch}, payload) {
    // is there security risk?
    const { userExtra, activeOrganization } = getters
    const tenantRef = dbAccessor.buildStoreQuery(['tenants', activeOrganization])
    let predicates = [{
      field: 'email',
      compare: '==',
      value: payload.email
    }]
    const userDocs = await dbAccessor.queryWithPredicatesStore(predicates, 'users')
    if (userDocs.size === 0) {
      throw Error('Email address not found.')
    }
    let params
    return dbAccessor.runInTransactionStore(async (transaction) => {
      return Promise.all([transaction.get(tenantRef), transaction.get(userDocs.docs[0].ref)])
        .then(([tenantDoc, userSnapshot]) => {
          const userDoc = userDocs.docs[0]
          let { accounts = [] } = userDoc.data()
          let {users} = tenantDoc.data()
          if (!accounts.length) {
            accounts = [{
              email: userExtra.email,
              name: userExtra.name,
              key: activeOrganization,
              role: userExtra.role,
              roles: payload.roles
            }]
          }

          params = { email: payload.email }
          accounts.forEach(account => {
            if (account.email === getters.userExtra.email) account.roles = payload.roles
            params[account.key] = account.roles
          })
          params.roles = accounts[0].roles
          params[activeOrganization] = payload.roles

          users.forEach(user => {
            if (user.email === payload.email) {
              user.roles = payload.roles
              user.note = payload.note || ''
            }
          })

          transaction.update(tenantRef, {users})
          transaction.update(userSnapshot.ref, {accounts})
        })
    })
      .then(() => {
        return dbAccessor.callFunction('grantUserRole', params)
      })
  },
  archiveProduct ({commit, getters}, product) {
    let offers = getters.offers.filter(offer => offer.productId === product.id)
    let proposes = getters.proposes.filter(propose => propose.productId === product.id)
    let archiveCollectionRef = dbAccessor.buildStoreQuery(['offers', 'offers', 'archives'])
    let productRef = dbAccessor.buildStoreQuery(['tenants', getters.activeOrganization, 'inventory', product.id])
    let archivedProductRef = dbAccessor.buildStoreQuery(['tenants', getters.activeOrganization, 'archivedInventory', product.id])

    let archiveProduct = {
      ...product,
      keywords: [
        ...splitProductName(product.name),
        product.id,
        product.upc,
        ...(product.asin || []).map(item => item.toLowerCase()),
        ...(product.sku || []).map(item => item.toLowerCase())
      ]
    }

    return dbAccessor.runInBatch(batch => {
      batch.delete(productRef)
      batch.set(archivedProductRef, dbAccessor.addNewDocTimestamp(archiveProduct))

      offers.forEach(offer => {
        batch.delete(dbAccessor.buildStoreQuery(['offers', 'offers', 'active', offer.key]))
        const product = getters.products.find(item => item.id === offer.productId) || {}
        batch.set(archiveCollectionRef.doc(), dbAccessor.addNewDocTimestamp({
          ...offer,
          productName: product.name
        }))
      })

      proposes.forEach(propose => {
        batch.delete(dbAccessor.buildStoreQuery(['offers', 'offers', 'proposes', propose.key]))
      })
    })
  },
  restoreProduct ({commit, getters}, product) {
    return dbAccessor.removeStore(
      'tenants',
      getters.activeOrganization,
      'archivedInventory',
      product._key)
      .then(() => {
        let {keywords, ...rest} = product
        dbAccessor.updateStore(
          rest,
          'tenants',
          getters.activeOrganization,
          'inventory',
          product._key)
      })
      .then(() => {
        if (product.upc) {
          return dbAccessor.callFunction('processPackages', {
            tenantKey: getters.activeOrganization,
            productId: product._key,
            upc: product.upc
          })
        }
        return product._key
      })
      .then(() => {
        return Logger.changeLog({
          beforeValue: {},
          actionPayload: product,
          actionName: 'restoreProduct',
          categories: ['inventory'],
          keys: [product._key],
          keywords: product.upc ? [product.upc] : []
        })
      })
      .catch(error => {
        Logger.critical('addProduct', {error: error.message, ...product})
      })
  },
  getArchivedProducts ({commit, getters}, payload) {
    let predicates = []

    payload.startDate && payload.endDate && (predicates = [...predicates, {
      field: `createTime`,
      compare: '>=',
      value: payload.startDate
    },
    {
      field: `createTime`,
      compare: '<=',
      value: payload.endDate
    }])

    payload.predicates && payload.predicates.predicateText &&
      (predicates.push({
        field: `keywords`,
        compare: 'array-contains',
        value: payload.predicates.predicateText
      }))

    return dbAccessor.queryWithPagination(predicates, ['tenants', getters.activeOrganization, 'archivedInventory'], 'createTime', true, payload && payload.startAfter, payload && payload.limit)
  },
  uploadOrders ({commit, getters}, payload) {
    const {files} = payload
    const message = {
      uploadedFiles: files,
      tenantKey: getters.activeOrganization,
      type: 'upload'
    }
    return dbAccessor.callFunction('processOrders', message)
  },
  uploadAppleOrders ({commit, getters}, payload) {
    payload.organizationKey = getters.activeOrganization || payload.organizationKey
    payload.warehouseKey = getters.activeWarehouse || ''
    return dbAccessor.callFunction('processAppleOrders', payload)
  },
  deleteAppleOrder ({commit, getters}, payload) {
    let organizationKey = getters.activeOrganization || payload.organizationKey
    Logger.log('deleteAppleOrders', {...payload, organizationKey})
    const {key} = payload
    return dbAccessor.removeStore('appleOrders', key)
  },
  getAppleOrders ({commit, getters}, payload) {
    let organizationKey = getters.activeOrganization
    let predicates = organizationKey ? [
      {
        field: 'organizationKey',
        compare: '==',
        value: organizationKey
      }
    ] : []
    let predicateText = payload.predicates?.predicateText || ''
    if (predicateText) {
      let reg = /^W\d{10}$/
      if (reg.test(predicateText)) {
        predicates.push({
          field: 'orderId',
          compare: '==',
          value: predicateText
        })
        return dbAccessor.queryWithPredicatesStore(predicates, 'appleOrders')
      } else if (guessCarrier(predicateText)?.length) {
        predicates.push({
          field: 'tracking',
          compare: '==',
          value: predicateText
        })
        return dbAccessor.queryWithPredicatesStore(predicates, 'appleOrders')
      } else {
        predicates.push({
          field: 'keywords',
          compare: 'array-contains',
          value: predicateText.toUpperCase()
        })
      }
    }
    payload.startDate && payload.endDate && (predicates = [...predicates, {
      field: `createTime`,
      compare: '>=',
      value: payload.startDate
    },
    {
      field: `createTime`,
      compare: '<=',
      value: payload.endDate
    }])
    if (payload.predicates?.actionPredicates) {
      predicates = [...predicates, ...payload.predicates.actionPredicates]
    }
    return dbAccessor.queryWithPagination(
      predicates, ['appleOrders'],
      'createTime', true, payload && payload.startAfter,
      payload && payload.limit
    )
  },
  getAppleOrdersByDate ({getters}, payload) {
    const {startDate, endDate} = payload
    let organizationKey = getters.activeOrganization || payload.organizationKey
    let predicates = [
      {
        field: `createTime`,
        compare: '>=',
        value: startDate
      },
      {
        field: `createTime`,
        compare: '<=',
        value: endDate
      }
    ]
    if (organizationKey) {
      predicates.push({
        field: 'organizationKey',
        compare: '==',
        value: organizationKey
      })
    }
    return dbAccessor.queryWithPredicatesStore(predicates, 'appleOrders')
      .then(docs => {
        let requests = []
        docs.forEach(doc => {
          requests.push({
            ...convertTimestampToDateInObj(doc.data())
          })
        })
        return requests
      })
  },
  getOrgLatestWeChatBilling ({commit, getters}, payload) {
    return dbAccessor.callFunction('getOrgWeChatBilling', payload)
  },
  getWeChatGroupInfo ({commit, getters}, payload) {
    return dbAccessor.callFunction('getWeChatGroupInfo')
  },
  getWeChatBilling ({commit, getters}, payload) {
    let organizationKey = getters.activeOrganization || payload?.actionPayload?.organizationKey
    if (!organizationKey) {
      return Promise.resolve([])
    }
    let predicates = [{
      field: `organizationKey`,
      compare: '==',
      value: organizationKey
    }]
    return dbAccessor.queryWithPredicatesStore(predicates, 'weChatBilling')
  },
  reportScanLog ({commit, getters}, payload) {
    const {dateKeyStr, scanItems} = payload
    let historyList = getters.systemBalance.scanLabelStatistics || []
    let item = historyList.find(item => item.dateKeyStr === dateKeyStr)
    let change = {}
    if (item) {
      item.scanItems = scanItems + item.scanItems
      change.scanLabelStatistics = historyList
    } else {
      change.scanLabelStatistics = [
        ...historyList,
        {
          dateKeyStr,
          scanItems
        }
      ]
    }
    window.localStorage.setItem('scanCache', '')
    dbAccessor.updateFieldsStore(change, 'systemBalance', getters.activeWarehouse)
  },
  getTenantActiveOrders ({commit, getters}) {
    let successFunc = (docs) => {
      let activeOrders = docs.docs.map(doc => {
        let order = doc.data()
        return OrderFactory.makeOrder(convertTimestampToDateInObj({...order, _key: doc.id}), getters.activeOrganization)
      })
      commit('setActiveOrders', activeOrders)
    }

    let errorFunc = (error) => {
      console.error(error)
      commit('setLoading', false)
      throw error
    }

    const now = new Date()
    const lastMonth = addDays(addMonths(now, -6), -1)
    let predicates = [{
      field: `status`,
      compare: 'in',
      value: ['open', 'partial']
    }, {
      field: `purchaseDate`,
      compare: '>=',
      value: lastMonth
    }]
    let unsubscribe = dbAccessor.queryRT(successFunc, errorFunc, predicates, ['tenants', getters.activeOrganization, 'orders'], 'purchaseDate', false, getters.tenant.orderRTLimitMax || 500)
    commit('addTosubscribed', {activeOrders: unsubscribe})
  },
  async markTasksAsTimedOut ({comment, getters}, tasks) {
    return dbAccessor.runInTransactionStore(async transaction => {
      const docs = await Promise.all(tasks.map(task => transaction.get(dbAccessor.buildStoreQuery(['tenants', getters.activeOrganization, 'shipmentTask', task._key]))))
      docs.forEach(doc => {
        if (!doc.exists) return
        const {processStatus} = doc.data()
        if (processStatus === 'pending') {
          transaction.update(doc.ref, {
            processStatus: 'failed',
            error: {
              message: 'processing timeout. please try again.',
              code: 'TIMED_OUT'
            }
          })
        }
      })
    })
  },
  getTenantOrdersTask ({commit, getters}) {
    let successFunc = (docs) => {
      const tasks = docs.docs.map(doc => convertTimestampToDateInObj({...doc.data(), _key: doc.id}))
      commit('setPendingOrdersTask', tasks)
    }

    let errorFunc = (error) => {
      console.error(error)
      commit('setLoading', false)
      throw error
    }

    let predicates = [{
      field: `processStatus`,
      compare: 'in',
      value: ['pending', 'failed']
    }]
    let unsubscribe = dbAccessor.queryRT(successFunc, errorFunc, predicates, ['tenants', getters.activeOrganization, 'ordersTask'], 'createTime', false, 500)
    commit('addTosubscribed', {ordersTask: unsubscribe})
  },
  getTenantFulfillmentOrders ({commit, getters}) {
    let successFunc = (docs) => {
      let fulfillmentOrders = docs.docs.map(doc => {
        let order = doc.data()
        return OrderFactory.makeOrder(convertTimestampToDateInObj({...order, _key: doc.id}), getters.activeOrganization)
      })
      commit('setFulfillmentOrders', fulfillmentOrders)
    }

    let errorFunc = (error) => {
      console.error(error)
      commit('setLoading', false)
      throw error
    }

    let predicates = [{
      field: `status`,
      compare: 'in',
      value: ['partial', 'readyToFulfillment', 'pendingFulfillment']
    }]
    let unsubscribe = dbAccessor.queryRT(successFunc, errorFunc, predicates, ['tenants', getters.activeOrganization, 'orders'], 'createTime', false, getters.tenant.orderRTLimitMax || 100)
    commit('addTosubscribed', {fulfillmentOrders: unsubscribe})
  },
  getSystemBalance ({ commit, getters, dispatch }) {
    let successFunc = (doc) => {
      if (doc.exists) {
        commit('setSystemBalance', doc.data())
      }
      let cache = window.localStorage.getItem('scanCache')
      if (cache) {
        dispatch('reportScanLog', (JSON.parse(cache)))
      }
    }

    let errorFunc = (error) => {
      console.error(error)
      commit('setLoading', false)
      throw error
    }

    let unsubscribe = dbAccessor.queryRT(successFunc, errorFunc, [], ['systemBalance', getters.activeOrganization || getters.activeWarehouse])
    commit('addTosubscribed', { systemBalance: unsubscribe })
  },
  getWarehouseUploadHistory ({commit, getters}) {
    let successFunc = (doc) => {
      if (doc.exists) {
        const {trackings} = doc.data()
        commit('setUploadedTrackings', new Set(trackings))
      }
    }

    let errorFunc = (error) => {
      console.error(error)
      commit('setLoading', false)
      throw error
    }

    let unsubscribe = dbAccessor.queryRT(successFunc, errorFunc, [], ['warehouses', getters.activeWarehouse, 'uploadHistory', 'uploadedTrackings'])
    commit('addTosubscribed', {uploadedTrackings: unsubscribe})
  },
  getTenantUploadHistory ({commit, getters}) {
    let successFunc = (docs) => {
      let uploadHistory = {}
      docs.docs.forEach(doc => {
        uploadHistory[doc.id] = convertTimestampToDateInObj(doc.data())
      })
      commit('setUploadHistory', uploadHistory)
    }

    let errorFunc = (error) => {
      console.error(error)
      commit('setLoading', false)
      throw error
    }

    let unsubscribe = dbAccessor.queryRT(successFunc, errorFunc, [], ['tenants', getters.activeOrganization, 'uploadHistory'])
    commit('addTosubscribed', {uploadHistory: unsubscribe})
  },
  getReturnPackagesWithPagination ({commit, getters}, payload) {
    const { predicates = {}, limit, startAfter, startDate, endDate } = payload
    const {predicateSelect = '', predicateText = '', actionPredicates = []} = predicates
    const searchPredicates = []

    if (getters.activeOrganization) {
      searchPredicates.push({
        field: 'clientKey',
        compare: '==',
        value: getters.activeOrganization
      })
    }
    if (startDate) {
      searchPredicates.push({
        field: 'returnCreateTime',
        compare: '>=',
        value: startDate
      })
    }
    if (endDate) {
      searchPredicates.push({
        field: 'returnCreateTime',
        compare: '<=',
        value: endDate
      })
    }
    if (predicateText) {
      searchPredicates.push({
        field: 'keywords',
        compare: 'array-contains',
        value: predicateText.trim().toLowerCase()
      })
    }
    if (actionPredicates.length) {
      searchPredicates.push(...actionPredicates)
    } else {
      const activeStatusList = ['returnReceived', 'requestResend', 'resendInProgress', 'resendCompleted', 'requestDisposal', 'disposalInProgress', 'disposeCompleted', 'error']
      if (predicateSelect) {
        searchPredicates.push({
          field: 'status',
          compare: '==',
          value: predicateSelect
        })
      } else {
        searchPredicates.push({
          field: 'status',
          compare: 'in',
          value: activeStatusList
        })
      }
    }

    return dbAccessor.queryWithPagination(searchPredicates, ['returnPackages'], 'returnCreateTime', false, startAfter, limit)
  },
  cancelErrorMsg ({commit, getters}, payload) {
    return dbAccessor.runInTransactionStore(async transaction => {
      let doc = await transaction.get(dbAccessor.buildStoreQuery(['tenants', getters.activeOrganization, 'uploadHistory', 'errorMessages']))
      let {errorMsg} = doc.data()
      delete errorMsg[payload.key]
      transaction.update(doc.ref, {errorMsg})
    })
  },
  async getOrdersPagination ({commit, getters}, payload) {
    let { startDate, endDate, status, dateType } = payload
    let predicates = []

    if (status) {
      predicates.push({
        field: 'status',
        compare: '==',
        value: status
      })
    }

    if (startDate) {
      predicates.push({
        field: dateType || `createTime`,
        compare: '>=',
        value: startDate
      })
    }

    if (endDate) {
      predicates.push({
        field: dateType || `createTime`,
        compare: '<=',
        value: endDate
      })
    }

    if (payload.predicates && (payload.predicates.predicateText || payload.predicates.predicateSelect)) {
      predicates.push({
        field: `keywords`,
        compare: 'array-contains',
        value: payload.predicates.predicateText || payload.predicates.predicateSelect
      })
    }

    if (payload.predicates && payload.predicates.actionPredicates && payload.predicates.actionPredicates.length) {
      let {actionPredicates} = payload.predicates
      if (actionPredicates.length > 1 || actionPredicates[0].value) predicates.push(...actionPredicates)
    }

    const docs = await dbAccessor.queryWithPredicates(predicates, ['tenants', getters.activeOrganization, 'orders'])
    return docs.docs.map(doc => convertTimestampToDateInObj(doc.data()))
  },
  getHistoryOrdersPagination ({commit, getters}, payload) {
    let { startDate, endDate, limit, startAfter, type, endBefore, isDesc = false } = payload
    let predicates = [{
      field: 'status',
      compare: 'in',
      value: ['closed', 'partial', 'archived']
    }]

    if (startDate) {
      predicates.push({
        field: `processTime`,
        compare: '>=',
        value: startDate
      })
    }

    if (endDate) {
      predicates.push({
        field: `processTime`,
        compare: '<=',
        value: endDate
      })
    }

    if (payload.predicates && (payload.predicates.predicateText || payload.predicates.predicateSelect)) {
      predicates.push({
        field: `keywords`,
        compare: 'array-contains',
        value: payload.predicates.predicateText || payload.predicates.predicateSelect
      })
    }

    if (payload.predicates && payload.predicates.actionPredicates && payload.predicates.actionPredicates.length) {
      let {actionPredicates} = payload.predicates
      if (actionPredicates.length > 1 || actionPredicates[0].value) predicates.push(...actionPredicates)
    }

    return dbAccessor.queryWithPagination(predicates, ['tenants', getters.activeOrganization, 'orders'], 'processTime', !isDesc, startAfter, limit, endBefore, type)
  },
  getHistoryCanceledOrdersPagination ({ commit, getters }, payload) {
    let { startDate, endDate, limit, startAfter, type, endBefore, isDesc = false } = payload
    let predicates = [{
      field: 'status',
      compare: 'in',
      value: ['canceled']
    }]

    if (startDate) {
      predicates.push({
        field: `lastModifiedTime`,
        compare: '>=',
        value: startDate
      })
    }

    if (endDate) {
      predicates.push({
        field: `lastModifiedTime`,
        compare: '<=',
        value: endDate
      })
    }

    if (payload.predicates && (payload.predicates.predicateText || payload.predicates.predicateSelect)) {
      predicates.push({
        field: `keywords`,
        compare: 'array-contains',
        value: payload.predicates.predicateText || payload.predicates.predicateSelect
      })
    }

    if (payload.predicates && payload.predicates.actionPredicates && payload.predicates.actionPredicates.length) {
      let {actionPredicates} = payload.predicates
      if (actionPredicates.length > 1 || actionPredicates[0].value) predicates.push(...actionPredicates)
    }
    return dbAccessor.queryWithPagination(predicates, ['tenants', getters.activeOrganization, 'orders'], 'lastModifiedTime', !isDesc, startAfter, limit, endBefore, type)
  },
  async cancelOrders ({commit, getters}, payload) {
    Logger.log('cancelOrders', payload)
    let {orders} = payload
    return dbAccessor.callFunction('processOrders', {
      clientKey: getters.activeOrganization || getters.activeWarehouse,
      type: 'cancel',
      orderKeys: orders.map(order => order._key)
    })
  },
  async remarkOrder ({commit, getters}, payload) {
    Logger.log('remarkOrder', payload)
    let { order } = payload
    return dbAccessor.updateFieldsStore({ remark: order.remark }, 'tenants', getters.activeOrganization, 'orders', order._key)
  },
  async deleteOrders ({commit, getters}, payload) {
    Logger.log('deleteOrders', payload)
    let {orders} = payload
    return dbAccessor.callFunction('processOrders', {
      clientKey: getters.activeOrganization || getters.activeWarehouse,
      type: 'delete',
      orders: orders.map(order => ({ key: order._key, orderId: order.orderId, platform: order.platform }))
    })
  },
  async restoreOrders ({commit, getters}, payload) {
    Logger.log('restoreOrders', payload)
    let {orders} = payload
    return dbAccessor.callFunction('processOrders', {
      clientKey: getters.activeOrganization || getters.activeWarehouse,
      type: 'restore',
      orderKeys: orders.map(order => order._key)
    })
  },
  archiveOrder ({commit, getters}, payload) {
    Logger.log('archiveOrder', payload)
    let orders = payload
    return dbAccessor.callFunction('processOrders', {
      clientKey: getters.activeOrganization || getters.activeWarehouse,
      type: 'archive',
      orderKeys: orders.map(order => order._key)
    })
  },
  addNewSenderName ({commit, getters}, payload) {
    let updates = {
      senderNames: dbAccessor.fieldArrayUnion([payload])
    }
    return dbAccessor.updateFieldsStore(updates, 'users', getters.userExtra.uid)
  },
  deleteSenderName ({commit, getters}, payload) {
    let updates = {
      senderNames: dbAccessor.fieldArrayRemove([payload])
    }
    return dbAccessor.updateFieldsStore(updates, 'users', getters.userExtra.uid)
  },
  getRates ({commit, getters}, payload) {
    const isAutoGetRate = payload.carriers && payload.carriers.length
    let role = ''
    if (getters.activeOrganization) role = 'organization'
    else if (getters.activeWarehouse) role = 'warehouse'
    // else if (getters.activeWorkfor) role = 'organization'

    return dbAccessor.callFunction('processShippingLabel', {
      label: payload,
      clientKey: getters.activeOrganization || getters.activeWarehouse,
      type: 'getRates',
      margin: getters.systemBalance.margin || 0,
      role
    }).then(rtn => {
      if (rtn.data.channel) {
        rtn.data.serviceType = rtn.data.serviceType + ' - ' + rtn.data.channel
      }
      if (Array.isArray(rtn.data.moreRates) && rtn.data.moreRates?.length) {
        rtn.data.moreRates = rtn.data.moreRates.map(rate => {
          if (rate.channel) {
            rate.serviceType = rate.serviceType + ' - ' + rate.channel
          }
          return rate
        }).filter(rate => {
          const carrier = isAutoGetRate ? rate.carrier : payload.carrier
          let checkValue = true
          const serviceSetting = getters.allLabelSeverTypeSettingsMap[`${carrier}_${rate.serviceType}`.toUpperCase()]
          if (serviceSetting) {
            const { allowedFromStates } = serviceSetting
            // if (betaFeature) checkValue = getters.visibleBetaFeatures.includes(betaFeature)
            if (allowedFromStates.length) { checkValue = allowedFromStates.includes(payload.from.state) && checkValue }
          }
          return checkValue
        })
      }
      return rtn
    })
  },
  verificationAddress ({commit, getters}, payload) {
    return dbAccessor.callFunction('processShippingLabel', {
      address: payload.address,
      type: 'verificationAddress'
    })
  },
  getLocations ({commit, getters}, payload) {
    return dbAccessor.callFunction('processShippingLabel', {
      address: payload.address,
      clientKey: getters.activeOrganization || getters.activeWarehouse,
      type: 'locations'
    })
  },
  getLabelPagination ({commit, getters}, payload) {
    let { startDate, endDate, limit, startAfter, type, endBefore, isDesc = false, predicates = {} } = payload
    const {actionPredicates = []} = predicates
    const dbPredicates = actionPredicates
    if (!getters.user.isAdmin) {
      dbPredicates.push({
        field: `clientKey`,
        compare: '==',
        value: getters.activeOrganization || getters.activeWarehouse
      })
    }
    let hasInPredicate = dbPredicates.some(item => item.compare === 'in' && item.field !== 'trackStatus')
    if (!hasInPredicate) {
      if (startDate) {
        dbPredicates.push({
          field: `createTime`,
          compare: '>=',
          value: startDate
        })
      }

      if (endDate) {
        dbPredicates.push({
          field: `createTime`,
          compare: '<=',
          value: endDate
        })
      }
    }
    // const statusPredicate = dbPredicates.find(predicate => predicate.field === 'status')
    // if (!getters.user.isAdmin && statusPredicate?.value === 'ready') {
    //   dbPredicates.push({
    //     compare: '==',
    //     field: 'trackStatus',
    //     value: 'ready'
    //   })
    // }
    return dbAccessor.queryWithPagination(dbPredicates, ['labels'], !hasInPredicate && 'createTime', !isDesc, startAfter, limit, endBefore, type)
  },
  async getApiLabels ({commit, dispatch}, payload) {
    let { startDate, endDate, startAfter, isDesc = false, predicates = {} } = payload
    const {actionPredicates = []} = predicates
    const dbPredicates = actionPredicates
    const types = ['status', 'requestId', 'trackingNumber']
    const targetType = dbPredicates.find(item => types.includes(item.field))
    const type = targetType ? targetType.field : ''
    const search = targetType ? Array.isArray(targetType.value) ? targetType.value[0] : targetType.value : ''
    const res = await dbAccessor.callFunction('processApiLabel', {
      type: 'list',
      data: {
        startDate,
        endDate,
        limit: 200,
        isDesc,
        type,
        search,
        startKey: startAfter
      }
    })
    const list = res.data?.data || []
    if (list) {
      const result = await dbAccessor.callFunction('processApiLabel', {
        type: 'trackingDetails',
        data: {
          trackingNumbers: list.map(item => item.trackingNumber).filter(item => !!item)
        }
      }).catch(err => {
        console.error(err)
        return { data: [] }
      })
      const trackingDetails = result.data
      if (trackingDetails.length) {
        list.forEach(item => {
          const trackDetail = trackingDetails.find(
            detail => detail.trackingNumber === item.trackingNumber
          )
          if (trackDetail) {
            item.trackStatus = trackDetail.trackStatus
            item.trackDescription = trackDetail.trackDescription
          }
        }
        )
      }
    }
    return res
  },
  async getApiTrackingEvents ({commit, getters}, payload) {
    const { trackingNumbers } = payload
    return dbAccessor.callFunction('processApiLabel', {
      type: 'trackingEvents',
      data: { trackingNumbers }
    })
  },
  async getTrackingMonitorSummary ({commit, getters}, payload = {}) {
    const { isAdmin, clientKey } = getTrackingMonitorIdentity(getters)
    const requestPayload = sanitizeTrackingMonitorPayload(payload)
    const result = await dbAccessor.callFunction('processApiLabel', {
      type: 'trackingMonitorSummary',
      data: {
        ...requestPayload,
        scope: isAdmin ? 'all' : 'tenant',
        ...(clientKey ? { clientKey } : {})
      }
    })
    return result.data
  },
  async getBusinessDashboardSummary ({commit, getters}, payload = {}) {
    const { isAdmin, clientKey } = getTrackingMonitorIdentity(getters)
    const requestPayload = sanitizeTrackingMonitorPayload(payload)
    const result = await dbAccessor.callFunction('processApiLabel', {
      type: 'businessDashboardSummary',
      data: {
        ...requestPayload,
        scope: isAdmin ? 'all' : 'tenant',
        ...(clientKey ? { clientKey } : {})
      }
    })
    return result.data
  },
  async getBusinessDashboardTheftExport ({commit, getters}, payload = {}) {
    const data = {
      startDate: payload.startDate,
      endDate: payload.endDate
    }
    const email = String(payload.email || '').trim()
    if (email) data.email = email

    const result = await dbAccessor.callFunction('processApiLabel', {
      type: 'businessDashboardTheftExport',
      data
    })
    return result.data
  },
  async getTrackingMonitorList ({commit, getters}, payload = {}) {
    const { isAdmin, clientKey } = getTrackingMonitorIdentity(getters)
    const {
      startDate,
      endDate,
      page = 1,
      limit = 25,
      handleStatus = '',
      monitorType = '',
      email = '',
      trackingNumbers = [],
      zoneTheft = false,
      weightTheft = false
    } = payload
    const normalizedEmail = String(email || '').trim()
    const normalizedTrackingNumbers = Array.from(new Set(
      (Array.isArray(trackingNumbers) ? trackingNumbers : [trackingNumbers])
        .flatMap(item => String(item || '').split(/\r?\n|,/g))
        .map(item => item.trim())
        .filter(Boolean)
    ))

    const normalizedPage = Number(page || 1)
    const normalizedLimit = Number(limit || 25)
    const result = await dbAccessor.callFunction('processApiLabel', {
      type: 'trackingMonitorList',
      data: {
        scope: isAdmin ? 'all' : 'tenant',
        ...(clientKey ? { clientKey } : {}),
        startDate,
        endDate,
        page: normalizedPage,
        limit: normalizedLimit,
        handleStatus,
        monitorType,
        email: normalizedEmail,
        trackingNumbers: normalizedTrackingNumbers,
        ...(zoneTheft === true ? { zoneTheft: true } : {}),
        ...(weightTheft === true ? { weightTheft: true } : {})
      }
    })
    const response = result.data || {}
    return {
      items: Array.isArray(response.items) ? response.items : [],
      total: Number(response.total || 0),
      page: Number(response.page || normalizedPage),
      limit: Number(response.limit || normalizedLimit),
      summary: response.summary || {}
    }
  },
  async getTrackingMonitorExport ({commit, getters}, payload = {}) {
    const { isAdmin, clientKey } = getTrackingMonitorIdentity(getters)
    const {
      startDate,
      endDate,
      handleStatus = '',
      monitorType = '',
      email = '',
      trackingNumbers = []
    } = payload
    const normalizedEmail = String(email || '').trim()
    const normalizedTrackingNumbers = Array.from(new Set(
      (Array.isArray(trackingNumbers) ? trackingNumbers : [trackingNumbers])
        .flatMap(item => String(item || '').split(/\r?\n|,/g))
        .map(item => item.trim())
        .filter(Boolean)
    ))
    const result = await dbAccessor.callFunction('processApiLabel', {
      type: 'trackingMonitorExport',
      data: {
        scope: isAdmin ? 'all' : 'tenant',
        ...(clientKey ? { clientKey } : {}),
        startDate,
        endDate,
        handleStatus,
        monitorType,
        email: normalizedEmail,
        trackingNumbers: normalizedTrackingNumbers
      }
    })
    return Array.isArray(result.data) ? result.data : []
  },
  async getTrackingMonitorListHistory ({commit, getters}, payload = {}) {
    const { isAdmin, clientKey } = getTrackingMonitorIdentity(getters)
    const {
      startDate,
      endDate,
      page = 1,
      limit = 25,
      handleStatus = '',
      monitorType = '',
      email = '',
      trackingNumbers = []
    } = payload
    const normalizedEmail = String(email || '').trim()
    const normalizedTrackingNumbers = Array.from(new Set(
      (Array.isArray(trackingNumbers) ? trackingNumbers : [trackingNumbers])
        .flatMap(item => String(item || '').split(/\r?\n|,/g))
        .map(item => item.trim())
        .filter(Boolean)
    ))
    const normalizedPage = Number(page || 1)
    const normalizedLimit = Number(limit || 25)
    const result = await dbAccessor.callFunction('processApiLabel', {
      type: 'trackingMonitorListHistory',
      data: {
        scope: isAdmin ? 'all' : 'tenant',
        ...(clientKey ? { clientKey } : {}),
        startDate,
        endDate,
        page: normalizedPage,
        limit: normalizedLimit,
        handleStatus,
        monitorType,
        email: normalizedEmail,
        trackingNumbers: normalizedTrackingNumbers
      }
    })
    const response = result.data || {}
    return {
      items: Array.isArray(response.items) ? response.items : [],
      total: Number(response.total || 0),
      page: Number(response.page || normalizedPage),
      limit: Number(response.limit || normalizedLimit),
      summary: response.summary || {}
    }
  },
  async getTrackingMonitorHistory ({commit, getters}, payload = {}) {
    const { clientKey } = getTrackingMonitorIdentity(getters)
    const trackingNumber = String(payload.trackingNumber || '').trim()

    if (!trackingNumber) {
      return {
        items: []
      }
    }

    const result = await dbAccessor.callFunction('processApiLabel', {
      type: 'trackingMonitorHistory',
      data: {
        ...(clientKey ? { clientKey } : {}),
        trackingNumber
      }
    })
    const response = result.data
    const items = Array.isArray(response)
      ? response
      : Array.isArray(response?.items)
        ? response.items
        : []

    return {
      items
    }
  },
  async updateTrackingMonitorHandleStatus ({commit, getters}, payload = {}) {
    const { clientKey } = getTrackingMonitorIdentity(getters)
    const { trackingDetailId, handleStatus, handleRemark = '' } = payload
    const result = await dbAccessor.callFunction('processApiLabel', {
      type: 'trackingMonitorHandleStatus',
      data: {
        ...(clientKey ? { clientKey } : {}),
        trackingDetailId,
        handleStatus,
        handleRemark
      }
    })
    return result.data
  },
  async batchUpdateTrackingMonitorHandleStatus ({commit, getters}, payload = {}) {
    const { clientKey } = getTrackingMonitorIdentity(getters)
    const { trackingDetailIds, handleStatus, handleRemark = '' } = payload
    const result = await dbAccessor.callFunction('processApiLabel', {
      type: 'trackingMonitorBatchHandleStatus',
      data: {
        ...(clientKey ? { clientKey } : {}),
        trackingDetailIds,
        handleStatus,
        handleRemark
      }
    })
    return result.data
  },
  async getNoInvoicedLabelsSummary ({commit, getters}, payload = {}) {
    const result = await dbAccessor.callFunction('processApiLabel', {
      type: 'noInvoicedLabelsSummary',
      data: payload
    })
    return result.data
  },
  async getNoInvoicedLabelsDetails ({commit, getters}, payload = {}) {
    const result = await dbAccessor.callFunction('processApiLabel', {
      type: 'noInvoicedLabelsDetails',
      data: payload
    })
    return result.data
  },
  async getApiTransactions ({commit, getters}, payload) {
    let { startDate, endDate, limit, startAfter, isDesc = false, predicates = {} } = payload
    const {predicateSelect} = predicates
    return dbAccessor.callFunction('processApiLabel', {
      type: 'listTransaction',
      data: {
        startDate,
        endDate,
        limit,
        isDesc,
        transactionType: predicateSelect || '',
        startKey: startAfter
      }
    })
  },
  createLabels ({commit, getters}, payload) {
    if ((getters.systemBalance.balance || 0) <= (getters.systemBalance.lowestBalance || 0) && !getters.isModeLabel) throw Error('Can not create label, balance is too low.')
    payload.forEach(item => {
      item.clientType = 'VITE'
    })
    return dbAccessor.callFunction('processShippingLabel', {
      labels: payload,
      type: 'create',
      clientKey: getters.activeOrganization || getters.activeWarehouse,
      clientName: getters.activeWarehouse ? getters.warehouseLimitedInfo.warehouseName : getters.tenantLimitedInfo.name,
      isBeta: getters.isLabelBetaUser,
      margin: getters.systemBalance.margin || 0
    })
      .then(rtn => rtn.data)
  },
  createInternationalLabel ({commit, getters}, payload) {
    if ((getters.systemBalance.balance || 0) <= (getters.systemBalance.lowestBalance || 0) && !getters.isModeLabel) throw Error('Can not create label, balance is too low.')
    return dbAccessor.callFunction('processShippingLabel', {
      label: { ...payload, clientType: 'VITE' },
      type: 'createInternational',
      clientKey: getters.activeOrganization || getters.activeWarehouse,
      clientName: getters.activeWarehouse ? getters.warehouseLimitedInfo.warehouseName : getters.tenantLimitedInfo.name,
      isBeta: getters.isLabelBetaUser,
      isInternational: true,
      margin: getters.systemBalance.margin || 0
    })
      .then(rtn => rtn.data)
  },
  async subscriptionEeiByItn ({commit, getters}, {itn, cbFunc}) {
    const successFunc = (doc) => (doc.exists && cbFunc(convertTimestampToDateInObj(doc.data())))
    const errorFunc = (error) => {
      console.error(error)
      throw error
    }
    const unsubscribe = dbAccessor.queryStoreRT(successFunc, errorFunc, [], 'eeiRecords', itn)
    return unsubscribe
  },
  async subscriptionLabelByRequestId ({commit, getters}, {requestId, cbFunc, errorFunc}) {
    const successFunc = (doc) => (doc.exists && cbFunc(convertTimestampToDateInObj(doc.data())))
    const defaultErrorFunc = (error) => {
      console.error(error)
      throw error
    }
    const unsubscribe = dbAccessor.queryStoreRT(successFunc, errorFunc || defaultErrorFunc, [], 'labels', requestId)
    return unsubscribe
  },
  async getAddressFromItn ({commit, getters}, {itn}) {
    let predicates = [{
      field: `itn`,
      compare: '==',
      value: itn
    }]
    const docs = await dbAccessor.queryWithPredicates(predicates, ['eeiRecords'])
    return docs.docs[0] ? docs.docs[0].data() : {}
  },
  getProofDeliveryHistory ({commit, getters}, payload) {
    let {startDate, endDate, limit, startAfter} = payload
    let predicates = getters.user.isAdmin ? [] : [{
      field: `clientKey`,
      compare: '==',
      value: getters.activeOrganization || getters.activeWarehouse
    }]

    predicates.push({
      field: `isProofDelivery`,
      compare: '==',
      value: true
    })

    if (startDate) {
      predicates.push({
        field: `proofTime`,
        compare: '>=',
        value: startDate
      })
    }

    if (endDate) {
      predicates.push({
        field: `proofTime`,
        compare: '<=',
        value: endDate
      })
    }

    if (payload.predicates && payload.predicates.predicateText) {
      predicates.push({
        field: `keywords`,
        compare: 'array-contains',
        value: payload.predicates.predicateText
      })
    }

    if (payload.predicates && payload.predicates.predicateSelect) {
      if (getters.activeOrganization || getters.activeWarehouse) {
        predicates.push({
          field: `status`,
          compare: '==',
          value: payload.predicates.predicateSelect
        })
      } else {
        // for admin
        predicates.push({
          field: `clientKey`,
          compare: '==',
          value: payload.predicates.predicateSelect
        })
      }
    }
    return dbAccessor.queryWithPagination(predicates, ['labels'], 'proofTime', true, startAfter, limit)
  },
  getOP950Pagination ({commit, getters}, payload) {
    let {startDate, endDate, limit, startAfter} = payload
    let predicates = []

    if (startDate) {
      predicates.push({
        field: `createTime`,
        compare: '>=',
        value: startDate
      })
    }

    if (endDate) {
      predicates.push({
        field: `createTime`,
        compare: '<=',
        value: endDate
      })
    }

    if ((payload.predicates && payload.predicates.predicateSelect)) {
      // for admin or filter
      predicates.push({
        field: `siteKey`,
        compare: '==',
        value: payload.predicates.predicateSelect
      })
    } else if (getters.activeWarehouse) {
      if (getters.activeWarehouse) {
        const siteKeys = getters.warehousesSites.map(site => site.key)
        // for warehouse
        predicates.push({
          field: `siteKey`,
          compare: 'in',
          value: siteKeys.length ? siteKeys : ['none']
        })
      }
    }
    return dbAccessor.queryWithPagination(predicates, ['op950'], 'createTime', true, startAfter, limit)
  },
  processEei ({commit, getters}, payload) {
    if ((getters.systemBalance.balance || 0) <= (getters.systemBalance.lowestBalance || 0) && !getters.isModeLabel) throw Error('Can not create eei, balance is too low.')
    return dbAccessor.callFunction('processEei', {
      ...payload,
      clientKey: getters.activeOrganization || getters.activeWarehouse,
      clientName: getters.activeWarehouse ? getters.warehouseLimitedInfo.warehouseName : getters.tenantLimitedInfo.name
    })
      .then(rtn => rtn.data)
  },
  getEeiStatus ({commit, getters}, payload) {
    return dbAccessor.callFunction('processEei', {
      ...payload,
      type: 'getStatus'
    })
      .then(rtn => rtn.data)
  },
  cancelEei ({commit, getters}, payload) {
    return dbAccessor.callFunction('processEei', {
      ...payload,
      type: 'cancel',
      clientKey: getters.activeOrganization || getters.activeWarehouse,
      clientName: getters.activeWarehouse ? getters.warehouseLimitedInfo.warehouseName : getters.tenantLimitedInfo.name
    })
      .then(rtn => rtn.data)
  },
  async getCommodityKey ({commit, getters}, {keyword}) {
    let path = getters.activeOrganization ?
      ['tenants', getters.activeOrganization, 'commodities'] :
      ['warehouses', getters.activeWarehouse, 'commodities']

    let predicates1 = [
      {
        field: `profileName`,
        compare: '==',
        value: keyword
      }
    ]

    const docs1 = await dbAccessor.queryWithPredicates(predicates1, path, null, null, 1)
    if (docs1.size > 0) {
      return docs1.docs[0].id
    }

    let predicates2 = [
      {
        field: `scheduleBDescription`,
        compare: '==',
        value: keyword
      }
    ]
    const docs2 = await dbAccessor.queryWithPredicates(predicates2, path, null, null, 1)
    return (docs2.size > 0) ? docs2.docs[0].id : null
  },
  async getCommodities ({commit, getters}, {keyword}) {
    let predicates = [
      {
        field: `keywords`,
        compare: 'array-contains',
        value: keyword.toLowerCase()
      }
    ]

    let path = getters.activeOrganization ?
      ['tenants', getters.activeOrganization, 'commodities'] :
      ['warehouses', getters.activeWarehouse, 'commodities']

    const docs = await dbAccessor.queryWithPredicates(predicates, path)
    return docs.docs.map(doc => {
      return {
        ...doc.data(),
        key: doc.id
      }
    })
  },
  async getOrganizationCommodities ({getters, commit}) {
    let predicates = [
      {
        field: `clientKey`,
        compare: '==',
        value: getters.activeOrganization || getters.activeWarehouse
      }
    ]
    let path = getters.activeOrganization ?
      ['tenants', getters.activeOrganization, 'commodities'] :
      ['warehouses', getters.activeWarehouse, 'commodities']

    let successFunc = (docs) => {
      let commodities = docs.docs.map(doc => {
        let data = convertTimestampToDateInObj(doc.data())
        return {key: doc.id, ...data}
      })
      commit('setOrganizationCommodities', commodities)
    }

    let errorFunc = (error) => {
      console.log(error)
      throw error
    }

    let unsubscribe = dbAccessor.queryRT(successFunc, errorFunc, predicates, path)
    commit('addTosubscribed', {organizationCommodities: unsubscribe})
  },
  async addCommodity ({getters}, {isUpdate, key, ...payload}) {
    let path = getters.activeOrganization ?
      ['tenants', getters.activeOrganization, 'commodities'] :
      ['warehouses', getters.activeWarehouse, 'commodities']

    payload.keywords = splitProductName(payload.profileName)
    payload.clientKey = getters.activeOrganization || getters.activeWarehouse
    return isUpdate && key ? dbAccessor.updateStore(payload, ...path, key) :
      dbAccessor.insertStore(payload, ...path)
  },
  async removeCommodity ({getters}, {key}) {
    let path = getters.activeOrganization ?
      ['tenants', getters.activeOrganization, 'commodities', key] :
      ['warehouses', getters.activeWarehouse, 'commodities', key]

    return dbAccessor.removeStore(...path)
  },
  async loadLetterheads ({ commit, getters }) {
    try {
      const snapshot = await dbAccessor.queryStore('tenants', getters.activeOrganization, 'letterheads')
      const letterheads = snapshot.docs.map(doc => {
        const data = convertTimestampToDateInObj(doc.data())
        return {
          id: doc.id,
          ...data
        }
      })
      commit('setLetterheads', letterheads)
      return letterheads
    } catch (error) {
      console.error('Error loading letterheads:', error)
      throw error
    }
  },
  async addLetterhead ({ commit, getters }, imageData) {
    try {
      const docRef = await dbAccessor.insertStore(imageData, 'tenants', getters.activeOrganization, 'letterheads')
      const newLetterhead = {
        id: docRef.id,
        ...imageData,
        createdAt: new Date()
      }

      await this.dispatch('loadLetterheads')
      return newLetterhead
    } catch (error) {
      console.error('Error adding letterhead:', error)
      throw error
    }
  },
  async removeLetterhead ({ commit, getters }, letterheadId) {
    try {
      await dbAccessor.removeStore('tenants', getters.activeOrganization, 'letterheads', letterheadId)

      await this.dispatch('loadLetterheads')
    } catch (error) {
      console.error('Error removing letterhead:', error)
      throw error
    }
  },
  async getRecentItns ({getters}) {
    let predicates = [
      {
        field: `clientKey`,
        compare: '==',
        value: getters.activeOrganization || getters.activeWarehouse
      },
      {
        field: `status`,
        compare: 'in',
        value: ['pending', 'ready']
      }
    ]
    const docs = await dbAccessor.queryWithPagination(predicates, ['eeiRecords'], 'createTime', true, null, 3)
    return docs.docs.map(doc => doc.data())
  },
  async cancelLabel ({commit, getters, dispatch}, payload) {
    const clientKey = getters.activeOrganization || getters.activeWarehouse
    const ignoreCheckClientKeys = ['mGIfq5pPDCUHIotTTkhQ', '6qbtS7FfCZdzKXvpo4Xu', 'SaEBTJIGRS9vty5u6mqN', 'ixUPQIop5ybdgtpuBw8l']
    if (clientKey && !ignoreCheckClientKeys.includes(clientKey)) {
      const balance = getters.systemBalance.balance || 0
      if (balance <= 0 && !getters.isModeLabel) {
        throw Error('Can not cancel label, balance is too low.')
      }
    }
    await dbAccessor.callFunction('processShippingLabel', {
      label: {
        ...payload,
        createTime: payload.createTime.toString()
      },
      type: 'cancel',
      clientKey: getters.activeOrganization || getters.activeWarehouse
    })
    let targetShipment = getters.shipments.find(item => item._key === payload.shipmentId)
    if (targetShipment) await dispatch('cancelShipment', targetShipment)
  },
  async canceApilLabel ({commit, getters, dispatch}, payload) {
    await dbAccessor.callFunction('processApiLabel', {
      requestId: payload.requestId,
      type: 'cancel'
    })
  },
  editLabel ({commit, getters}, payload) {
    return dbAccessor.callFunction('processShippingLabel', {
      label: payload,
      type: 'editNote'
    })
  },
  getLabelStatus ({commit, getters}, payload) {
    return dbAccessor.callFunction('processShippingLabel', {
      orderId: payload.orderId,
      type: 'status'
    })
  },
  getLabelProofDelivery ({ getters }, { trackingNumber, requestId }) {
    return dbAccessor.callFunction('processShippingLabel', {
      trackingNumber,
      requestId,
      clientKey: getters.activeOrganization,
      type: 'proofDelivery'
    })
  },
  getTenantAddress ({commit, getters}) {
    let successFunc = (doc) => {
      let {addresses = []} = doc.data() || {}
      commit('setTenantAddresses', addresses)
    }

    let errorFunc = (error) => {
      console.error(error)
      commit('setLoading', false)
      throw error
    }
    let unsubscribe = dbAccessor.queryRT(successFunc, errorFunc, [], ['tenants', getters.activeOrganization, 'config', 'addresses'])
    commit('addTosubscribed', {addresses: unsubscribe})
  },
  getFavorites ({commit, getters}) {
    let successFunc = (doc) => {
      commit('setFavorites', doc.data() || {})
    }

    let errorFunc = (error) => {
      console.error(error)
      commit('setLoading', false)
      throw error
    }
    let unsubscribe = dbAccessor.queryRT(successFunc, errorFunc, [], ['tenants', getters.activeOrganization, 'config', 'favorites'])
    commit('addTosubscribed', {favorites: unsubscribe})
  },
  updateFavorites ({commit, getters}, payload) {
    if (JSON.stringify(getters.favorites) === '{}') {
      return dbAccessor.updateStore(payload, 'tenants', getters.activeOrganization, 'config', 'favorites')
    }
    return dbAccessor.updateFieldsStore(payload, 'tenants', getters.activeOrganization, 'config', 'favorites')
  },
  getWarehouseAddress ({commit, getters}) {
    let successFunc = (doc) => {
      let {addresses = []} = doc.data() || {}
      commit('setTenantAddresses', addresses)
    }

    let errorFunc = (error) => {
      console.error(error)
      commit('setLoading', false)
      throw error
    }
    let unsubscribe = dbAccessor.queryRT(successFunc, errorFunc, [], ['warehouses', getters.activeWarehouse, 'config', 'addresses'])
    commit('addTosubscribed', {addresses: unsubscribe})
  },
  labelCreateAddress ({commit, getters}, payload) {
    if (!payload.addresses || !payload.addresses.length) throw Error('Address not found.')
    const addressRef = getters.activeOrganization ? dbAccessor.buildStoreQuery(['tenants', getters.activeOrganization, 'config', 'addresses']) :
      dbAccessor.buildStoreQuery(['warehouses', getters.activeWarehouse, 'config', 'addresses'])

    return dbAccessor.runInTransactionStore(async transaction => {
      const addressDoc = await transaction.get(addressRef)
      if (!addressDoc.exists) {
        transaction.set(addressDoc.ref, dbAccessor.addNewDocTimestamp({addresses: payload.addresses}))
      } else {
        let {addresses = []} = addressDoc.data()
        payload.addresses.forEach(address => {
          const idx = addresses.findIndex(item => item.siteName === address.siteName)
          if (idx !== -1) {
            addresses[idx] = address
          } else {
            addresses.push(address)
          }
        })

        transaction.update(addressDoc.ref, dbAccessor.addUpdateDocTimestamp({addresses}))
      }
    })
  },
  labelEditAddress ({commit, getters}, payload) {
    const addressRef = dbAccessor.buildStoreQuery(['tenants', getters.activeOrganization, 'config', 'addresses'])
    return dbAccessor.runInTransactionStore(async transaction => {
      let doc = await transaction.get(addressRef)
      let {addresses = []} = doc.data()
      let targetIdx = addresses.findIndex(item => item.siteName === payload.siteName)
      addresses[targetIdx] = payload
      transaction.update(doc.ref, dbAccessor.addUpdateDocTimestamp({addresses}))
    })
  },
  labelDeleteAddress ({commit, getters}, payload) {
    let addressRef
    if (getters.activeOrganization) {
      addressRef = dbAccessor.buildStoreQuery(['tenants', getters.activeOrganization, 'config', 'addresses'])
    } else {
      addressRef = dbAccessor.buildStoreQuery(['warehouses', getters.activeWarehouse, 'config', 'addresses'])
    }
    return dbAccessor.runInTransactionStore(async transaction => {
      let doc = await transaction.get(addressRef)
      let {addresses = []} = doc.data()
      Logger.log('labelDeleteAddress', { addresses, payload })
      transaction.update(doc.ref, {addresses: addresses.filter(address => address.siteName !== payload.siteName)})
    })
  },
  getTenantPackaging ({commit, getters}) {
    let successFunc = (doc) => {
      let {packagings = []} = doc.data() || {}
      commit('setTenantPackagings', packagings.map(item => { return {...item, id: item.name} }))
    }

    let errorFunc = (error) => {
      console.error(error)
      commit('setLoading', false)
      throw error
    }
    let unsubscribe = dbAccessor.queryRT(successFunc, errorFunc, [], ['tenants', getters.activeOrganization, 'config', 'packagings'])
    commit('addTosubscribed', {packagings: unsubscribe})
  },
  getWarehousePackaging ({commit, getters}) {
    let successFunc = (doc) => {
      let {packagings = []} = doc.data() || {}
      commit('setTenantPackagings', packagings.map(item => { return {...item, id: item.name} }))
    }

    let errorFunc = (error) => {
      console.error(error)
      commit('setLoading', false)
      throw error
    }
    let unsubscribe = dbAccessor.queryRT(successFunc, errorFunc, [], ['warehouses', getters.activeWarehouse, 'config', 'packagings'])
    commit('addTosubscribed', {packagings: unsubscribe})
  },
  editPackaging ({commit, getters}, payload) {
    const {packagingInEdit} = payload
    const packagingRef = getters.activeOrganization ? dbAccessor.buildStoreQuery(['tenants', getters.activeOrganization, 'config', 'packagings']) :
      dbAccessor.buildStoreQuery(['warehouses', getters.activeWarehouse, 'config', 'packagings'])
    return dbAccessor.runInTransactionStore(async transaction => {
      const packagingDoc = await transaction.get(packagingRef)
      if (!packagingDoc.exists) {
        transaction.set(packagingDoc.ref, dbAccessor.addNewDocTimestamp({packagings: [packagingInEdit]}))
      } else {
        let {packagings = []} = packagingDoc.data()

        const idx = packagings.findIndex(item => item.name === packagingInEdit.name)
        if (idx !== -1) {
          packagings[idx] = packagingInEdit
        } else {
          packagings.push(packagingInEdit)
        }

        transaction.update(packagingDoc.ref, dbAccessor.addUpdateDocTimestamp({packagings}))
      }
    })
  },
  deletePackaging ({commit, getters}, payload) {
    let packagingRef
    if (getters.activeOrganization) {
      packagingRef = dbAccessor.buildStoreQuery(['tenants', getters.activeOrganization, 'config', 'packagings'])
    } else {
      packagingRef = dbAccessor.buildStoreQuery(['warehouses', getters.activeWarehouse, 'config', 'packagings'])
    }
    return dbAccessor.runInTransactionStore(async transaction => {
      let doc = await transaction.get(packagingRef)
      let {packagings = []} = doc.data()
      transaction.update(doc.ref, {packagings: packagings.filter(packaging => packaging.name !== payload.name)})
    })
  },
  getTemplates ({commit, getters}) {
    let successFunc = (docs) => {
      let templates = docs.docs.map(doc => {
        const data = doc.data()
        return {
          ...data,
          key: doc.id,
          sku: Array.isArray(data.sku) ? data.sku.join(',') : data.sku
        }
      })
      commit('setTemplates', templates)
    }

    let errorFunc = (error) => {
      console.error(error)
      commit('setLoading', false)
      throw error
    }

    let path = getters.activeOrganization ? [
      'tenants',
      getters.activeOrganization,
      'templates'
    ] : [
      'warehouses',
      getters.activeWarehouse,
      'templates'
    ]

    let unsubscribe = dbAccessor.queryRT(successFunc,
      errorFunc,
      [],
      path)

    commit('addTosubscribed', {templates: unsubscribe})
  },
  updateTemplate ({commit, getters}, payload) {
    const {options, ...rest} = payload
    const {
      organizationKey
    } = options || {}
    const organization = organizationKey || getters.activeOrganization
    const path = organization ? [
      'tenants',
      organization,
      'templates'
    ] : [
      'warehouses',
      getters.activeWarehouse,
      'templates'
    ]
    return payload.key ?
      dbAccessor.updateStore(rest, ...path, rest.key) :
      dbAccessor.insertStore(rest, ...path)
  },
  deleteTemplate ({commit, getters}, payload) {
    const path = getters.activeOrganization ? [
      'tenants',
      getters.activeOrganization,
      'templates',
      payload.key
    ] : [
      'warehouses',
      getters.activeWarehouse,
      'templates',
      payload.key
    ]

    return dbAccessor.removeStore(...path)
  },
  getLabelTemplates ({commit, getters}) {
    if (!getters.activeOrganization) {
      commit('setLabelTemplates', [])
      return Promise.resolve()
    }
    const successFunc = (docs) => {
      const templates = docs.docs.map(doc => {
        const data = doc.data() || {}
        return {
          ...data,
          key: doc.id,
          sku: Array.isArray(data.sku) ? data.sku.join(',') : data.sku
        }
      })
      commit('setLabelTemplates', templates)
    }

    const errorFunc = (error) => {
      console.error(error)
      throw error
    }

    const path = ['tenants', getters.activeOrganization, 'labelTemplates']
    const unsubscribe = dbAccessor.queryRT(successFunc, errorFunc, [], path)
    commit('addTosubscribed', {labelTemplates: unsubscribe})
  },
  getLabelTemplateDefaults ({commit, getters}) {
    if (!getters.activeOrganization) {
      commit('setLabelTemplateDefaults', {})
      return Promise.resolve()
    }
    const successFunc = (doc) => {
      const data = (doc && doc.data && doc.data()) || {}
      commit('setLabelTemplateDefaults', data)
    }

    const errorFunc = (error) => {
      console.error(error)
      throw error
    }

    const path = ['tenants', getters.activeOrganization, 'labelTemplateDefaults', 'default']
    const unsubscribe = dbAccessor.queryRT(successFunc, errorFunc, [], path)
    commit('addTosubscribed', {labelTemplateDefaults: unsubscribe})
  },
  createOrUpdateLabelTemplate ({getters}, payload) {
    const {options, ...rest} = payload
    const organization = options?.organizationKey || getters.activeOrganization
    const path = ['tenants', organization, 'labelTemplates']
    return payload.key
      ? dbAccessor.updateStore(rest, ...path, rest.key)
      : dbAccessor.insertStore(rest, ...path)
  },
  deleteLabelTemplate ({getters}, payload) {
    return dbAccessor.removeStore('tenants', getters.activeOrganization, 'labelTemplates', payload.key)
  },
  setLabelTemplateDefault ({getters}, payload) {
    const { businessType, templateId } = payload
    const fieldNameMap = {
      domestic: 'domesticTemplateId',
      export: 'exportTemplateId',
      import: 'importTemplateId'
    }
    const field = fieldNameMap[businessType]
    if (!field) throw new Error(`invalid businessType: ${businessType}`)

    const defaults = getters.labelTemplateDefaults || {}
    const updatePayload = {
      updatedAt: Date.now(),
      [field]: templateId
    }

    ;['domesticTemplateId', 'exportTemplateId', 'importTemplateId'].forEach(key => {
      if (defaults[key] !== undefined && updatePayload[key] === undefined) {
        updatePayload[key] = defaults[key]
      }
    })

    const userEmail = getters.userExtra?.email || getters.user?.email
    if (userEmail) updatePayload.updatedBy = userEmail

    return dbAccessor.updateStore(updatePayload, 'tenants', getters.activeOrganization, 'labelTemplateDefaults', 'default')
  },
  getCommodityTemplates ({commit, getters, state}) {
    // Check if already subscribed
    if (state.subscribed && state.subscribed.commodityTemplates) {
      return Promise.resolve()
    }

    let successFunc = (docs) => {
      let commodityTemplates = docs.docs.map(doc => {
        const data = doc.data()
        return {
          ...data,
          key: doc.id
        }
      })
      commit('setCommodityTemplates', commodityTemplates)
    }

    let errorFunc = (error) => {
      console.error(error)
      commit('setLoading', false)
      throw error
    }

    let path = getters.activeOrganization ? [
      'tenants',
      getters.activeOrganization,
      'commodityTemplates'
    ] : [
      'warehouses',
      getters.activeWarehouse,
      'commodityTemplates'
    ]

    let unsubscribe = dbAccessor.queryRT(successFunc,
      errorFunc,
      [],
      path)

    commit('addTosubscribed', {commodityTemplates: unsubscribe})
  },
  updateCommodityTemplate ({commit, getters}, payload) {
    const {options, ...rest} = payload
    const organization = getters.activeOrganization
    const path = organization ? [
      'tenants',
      organization,
      'commodityTemplates'
    ] : [
      'warehouses',
      getters.activeWarehouse,
      'commodityTemplates'
    ]
    return payload.key ?
      dbAccessor.updateStore(rest, ...path, rest.key) :
      dbAccessor.insertStore(rest, ...path)
  },
  deleteCommodityTemplate ({commit, getters}, payload) {
    const path = getters.activeOrganization ? [
      'tenants',
      getters.activeOrganization,
      'commodityTemplates',
      payload.key
    ] : [
      'warehouses',
      getters.activeWarehouse,
      'commodityTemplates',
      payload.key
    ]

    return dbAccessor.removeStore(...path)
  },
  exportOrderShippingsConfirmFiles ({commit, getters}, payload) {
    const orders = payload.orders.map(order => {
      let orderClone = cloneDeep(order)
      let {shipments} = orderClone
      if (Array.isArray(shipments)) {
        shipments.forEach(shipment => {
          // look up cache
          if (shipment.status === 'pending') {
            const {trackingNum, labels = []} = getters.shipments.find(({_key}) => shipment.key === _key) || {}
            shipment.trackingNumber = labels.length ? labels[0].trackingNum : trackingNum
            shipment.method = (labels[0] || {}).serviceType || ''
            shipment.carrier = (labels[0] || {}).carrier || ''
          }
        })
      } else {
        orderClone.items.forEach(item => {
          shipments = [{
            carrierCode: '',
            carrierName: '',
            channel: '',
            labelKey: '',
            labelUrl: '',
            quantity: item.quantityPurchased,
            serviceType: '',
            status: orderClone.statue,
            trackingNumber: '',
            sku: item.sku,
            orderItemId: item.orderItemId,
            productName: item.productName,
            productStatus: orderClone.statue,
            quantityPurchased: item.quantityPurchased
          }]
        })
      }
      return OrderFactory.makeOrder({...orderClone, shipments}, getters.activeOrganization)
    })
    return OrderFactory.exportOrdersToFiles(orders, { startDate: payload.startDate, endDate: payload.endDate })
  },
  async downloadSelectedOrderLabels ({commit, getters, dispatch}, {orders, isMergePDF}) {
    let urls = []
    let duplicateFilter = {}
    orders.map(order => {
      const {shipments, orderId} = order
      if (Array.isArray(shipments)) {
        shipments.forEach(shipment => {
          if (shipment.status === 'pending') {
            const {labels = []} = getters.shipments.find(({_key}) => shipment.key === _key) || {}
            labels.forEach(label => {
              const url = {
                url: label.url,
                name: getters.tenantLimitedInfo?.isRenameLabelByOrderKey && orderId
                  ? orderId
                  : label.trackingNum
              }
              if (label.url && !duplicateFilter[url.name]) {
                duplicateFilter[url.name] = true
                urls.push(url)
              }
            })
          } else {
            let {trackingNumber, labelUrl} = shipment
            const url = {
              url: labelUrl,
              name: getters.tenantLimitedInfo?.isRenameLabelByOrderKey && orderId
                ? orderId
                : trackingNumber
            }
            if (labelUrl && !duplicateFilter[url.name]) {
              duplicateFilter[url.name] = true
              urls.push(url)
            }
          }
        })
      }
    })

    const downloadErr = (errMsg) => {
      dispatch('showToast', {info: errMsg, level: 'error'})
      throw Error(errMsg)
    }
    if (!urls.length) {
      downloadErr('No label to download.')
    }
    if (urls.length > 100) {
      downloadErr('Download label quantity is limited to 100.')
    }
    const res = await dbAccessor.callFunction('downloadLabelZip', {
      files: urls,
      isMergePDF
    })
    const {zipFile} = res.data
    await dispatch('downloadFile', {
      fullPath: zipFile,
      name: isMergePDF ? 'labels.pdf' : 'labels.zip'
    })

    await updateDownloadFieldByLabels(
      urls.map(item => item.name),
      dbAccessor
    )
    dbAccessor.removeFile(zipFile)
  },
  async syncEeveeBalance ({ commit, getters }) {
    const { isModeLabel } = getters
    if (!isModeLabel) return
    return dbAccessor.callFunction('syncEeveeBalance', {})
  },
  async refreshApiBalance ({ commit, getters }, item) {
    if (!item.orgKey || !item.apiKey || !item.mode === 'label') return
    return dbAccessor.callFunction('syncEeveeBalance', {
      orgKey: item.orgKey,
      clientKey: item.clientKey
    })
  },
  // async getEeveeDepartments ({commit, getters}) {
  //   const data = await dbAccessor.callFunction('processEeveeInfo', {
  //     type: 'getDepartments'
  //   })
  //   commit('setEeveeDepartments', data.data || [])
  // },
  async downloadSelectedLabels ({commit, getters, dispatch}, {labels, isMergePDF, printShipments}) {
    let urls = labels.map(label => {
      return {
        url: label.url,
        name: (getters.tenantLimitedInfo || {}).isRenameLabelByOrderKey && label.orderKey
          ? label.orderKey.split('-').slice(1).join('-')
          : label.trackingNumber || label.trackingNum || label.name || label._key || extractFilenameFromUrl(label.url)
      }
    })
    if (urls.length > 100) {
      const errMsg = 'Download label quantity is limited to 100.'
      dispatch('showToast', {info: errMsg, level: 'error'})
      console.error(Error(errMsg))
      throw Error(errMsg)
    }
    const res = await dbAccessor.callFunction('downloadLabelZip', {
      files: urls,
      isMergePDF
    })
    const {zipFile} = res.data
    await dispatch('downloadFile', {fullPath: zipFile, name: isMergePDF ? 'labels.pdf' : 'labels.zip', isPrint: !!printShipments})
    const now = new Date()
    if (printShipments) {
      await Promise.all(printShipments.map(item => {
        return dispatch('updateShipments', {docKey: item._key, isPrinted: true, printedTime: now})
      }))
    } else {
      await updateDownloadFieldByLabels(urls.map(item => item.name), dbAccessor)
    }
    dbAccessor.removeFile(zipFile)
  },
  async getShipFrom ({commit, getters, dispatch}, distribution) {
    let {warehouseKey, warehouseSite, siteName, uid, userName} = distribution
    if (!warehouseKey && warehouseSite === siteName) {
      // this is user storage
      const name = siteName.split(' - ')[2]
      await dispatch('getUserSites', uid)
      const targetSite = getters.sites.find(item => item.siteName === name)
      if (targetSite) {
        const {address1, address2, city, state, zip: zipCode} = targetSite
        return {address1, address2, city, state: getters.statesToAbbrev[state], zipCode}
      }
      return {}
    }

    if (userName === 'self') {
      // this is tenant self storage
      const {address1, address2, city, state, zipCode} = getters.siteKeyMap.get(siteName)
      return {address1, address2, city, state: getters.statesToAbbrev[state], zipCode}
    }
    // this is warehouse storage
    const {address1, address2, city, state, zipCode, phone} = getters.siteKeyMap.get(warehouseSite)
    return {address1, address2, city, state: getters.statesToAbbrev[state], zipCode, phone}
  },
  async addOrderLabels ({commit, getters}, payload) {
    if ((getters.systemBalance.balance || 0) <= (getters.systemBalance.lowestBalance || 0)) {
      if (!getters.isModeLabel) {
        throw Error('Can not create label, balance is too low.')
      }
    }
    const { labels } = payload
    const maxIndex = Math.floor(labels.length / 5)
    const batchLabels = []
    for (let i = 0; i <= maxIndex; i++) {
      batchLabels[i] = labels.slice(i * 5, 5 + i * 5)
    }
    const result = await Promise.all(batchLabels.map(async targetLabels => {
      try {
        targetLabels.forEach(label => {
          label.clientType = 'VITE'
        })
        const res = await dbAccessor.callFunction('processOrders', {
          ...payload,
          labels: targetLabels,
          type: 'addOrderLabel',
          clientKey: getters.activeOrganization,
          clientName: getters.tenantLimitedInfo.name,
          isBeta: getters.isLabelBetaUser,
          margin: getters.systemBalance.margin || 0
        })
        return res.data
      } catch (err) {
        const orderKey = err.message.match(/#(.+)#/)?.[0]?.replace(/#/g, '') || ''
        const errorLabels = labels.map(label => {
          const payload = { ...label, message: '' }
          const regExp = new RegExp('#(' + orderKey + ')#')
          if (label.orderKey === orderKey) payload.message = err.message.replace(regExp, '')
          else payload.message = err.message
          return payload
        })
        return {
          successLabels: [],
          errorLabels
        }
      }
    }))
    return result.reduce((res, item) => {
      const { successLabels, errorLabels } = item
      res.successLabels.push(...successLabels)
      res.errorLabels.push(...errorLabels)
      return res
    }, {
      successLabels: [],
      errorLabels: []
    })
  },
  async batchAddOrderLabels ({commit, getters}, payload) {
    let role = ''
    if (getters.activeOrganization) role = 'organization'
    else if (getters.activeWarehouse) role = 'warehouse'
    payload.labels.forEach(item => {
      item.clientType = 'VITE'
    })
    const res = await dbAccessor.callFunction('processLabelTask', {
      ...payload,
      type: 'createGetRates',
      clientKey: getters.activeOrganization,
      clientName: getters.tenantLimitedInfo.name,
      isBeta: getters.isLabelBetaUser,
      margin: getters.systemBalance.margin || 0,
      role
    })
    return res.data
  },
  async splitOrder ({commit, getters}, payload) {
    const res = await dbAccessor.callFunction('processOrders', {
      ...payload,
      type: 'split',
      clientKey: getters.activeOrganization,
      clientName: getters.tenantLimitedInfo.name
    })
    return res.data
  },
  addSkuRequest ({commit, getters}, payload) {
    return dbAccessor.insertStore({
      ...payload,
      tenantKey: getters.activeOrganization
    }, 'skuRequests')
  },
  updateSkuRequest ({commit, getters}, payload) {
    const {key, ...rest} = payload
    return dbAccessor.updateStore({
      ...rest,
      tenantKey: getters.activeOrganization
    }, 'skuRequests', key)
  },
  removeSkuRequest ({commit, getters}, payload) {
    return dbAccessor.removeStore('skuRequests', payload.key)
  },
  getSkuRequests ({commit, getters, dispatch}) {
    const successFunc = (docs) => {
      if (docs.size > 0 && getters.activeWarehouse) {
        dispatch('addNotification', {
          key: 'newSkuRequests',
          displayName: 'sku requests',
          pathName: 'sku requests',
          path: '/package?tab=skuRequests'
        })
      }
      commit('setSkuRequests', docs.docs.map(doc => convertTimestampToDateInObj({...doc.data(), key: doc.id})))
    }

    const errorFunc = (error) => {
      console.error(error)
      commit('setLoading', false)
      throw error
    }

    const predicates = getters.activeOrganization ? [{
      field: `tenantKey`,
      compare: '==',
      value: getters.activeOrganization
    }] : (getters.activeWarehouse && [{
      field: `warehouseKey`,
      compare: '==',
      value: getters.activeWarehouse
    }])

    const unsubscribe = dbAccessor.queryRT(successFunc, errorFunc, predicates, ['skuRequests'])
    commit('addTosubscribed', {skuRequests: unsubscribe})
  },
  createShipmentDraft ({commit, getters}, payload) {
    const {files, ...rest} = payload
    const fileInfoArr = files.map(item => {
      let name, prettySize
      let {metadata, file} = item
      if (metadata) {
        name = file.name
        prettySize = file.prettySize
      } else {
        metadata = {...item}
        name = item.name
        prettySize = null
      }
      return {
        metadata,
        task: {
          progress: 100,
          snapshot: {
            state: 'success'
          }
        },
        file: {
          name,
          prettySize
        }
      }
    })
    return dbAccessor.insertStore({...rest, files: fileInfoArr}, 'tenants', getters.activeOrganization, 'shipmentDrafts')
  },
  getShipmentDrafts ({commit, getters, dispatch}) {
    const successFunc = (docs) => {
      const drafts = docs.docs.map(doc => convertTimestampToDateInObj({...doc.data(), _key: doc.id}))
      commit('setShipmentDrafts', drafts)
    }

    const errorFunc = (error) => {
      console.error(error)
      commit('setLoading', false)
      throw error
    }

    const unsubscribe = dbAccessor.queryRT(successFunc, errorFunc, [], ['tenants', getters.activeOrganization, 'shipmentDrafts'], 'createTime', true)
    commit('addTosubscribed', {shipmentDrafts: unsubscribe})
  },
  async cancelShipmentDraft ({commit, getters}, payload) {
    let needSaveDraft = (payload.IMEIRecords && payload.IMEIRecords.length) || (payload.label && payload.label.length)
    if (needSaveDraft) {
      await dbAccessor.runInTransactionStore(async transaction => {
        let draftRef = dbAccessor.buildStoreQuery(['tenants', getters.activeOrganization, 'shipmentDrafts', payload._key])
        let canceledDraftRef = dbAccessor.buildStoreQuery(['deletedShipments', payload.requestId])
        transaction.delete(draftRef)
        const canceledDraft = {
          deleteTime: new Date(),
          tenantKey: getters.activeOrganization,
          cancelerKey: getters.userExtra.uid,
          cancelerName: getters.userExtra.name,
          ...payload
        }
        transaction.set(canceledDraftRef, canceledDraft)
      })
      return Promise.resolve()
    } else {
      return dbAccessor.removeStore('tenants', getters.activeOrganization, 'shipmentDrafts', payload._key)
    }
  },
  updateShipmentDraft ({commit, getters}, {key, data}) {
    const {files, ...rest} = data
    const fileInfoArr = files.map(item => {
      const {metadata, file} = item
      const {name, prettySize} = file
      return {
        metadata,
        task: {
          progress: 100,
          snapshot: {
            state: 'success'
          }
        },
        file: {
          name,
          prettySize
        }
      }
    })
    return dbAccessor.updateFieldsStore({...rest, files: fileInfoArr}, 'tenants', getters.activeOrganization, 'shipmentDrafts', key)
  },
  async getTenantDiscount ({commit, getters, dispatch}, {warehouseKey}) {
    const {discountKey, isBlockCreditCardDeposit} = await dispatch('getOrgForWarehouse', {warehouseKey})
    const warehouseLimitedInfoDoc = await dbAccessor.queryStore('warehouseLimitedInfo', warehouseKey)
    const {tierDiscounts = {}, isNeedDepositFee = false} = warehouseLimitedInfoDoc.data() || {}
    return {discount: tierDiscounts[discountKey], isBlockCreditCardDeposit, isNeedDepositFee}
  },
  async getOrgForWarehouse ({commit, getters}, {warehouseKey}) {
    const orgDoc = await dbAccessor.queryStore('warehouses', warehouseKey, 'organizations', getters.activeOrganization)
    if (!orgDoc.exists) return {}
    return orgDoc.data()
  },
  async getAmazonSites ({commit, getters}, payload) {
    const doc = await dbAccessor.queryStore('sysAdmin', 'amazonSites')
    if (!doc.exists) return 'done'
    const {sites = []} = doc.data()
    commit('setAmazonSites', sites.map(({siteName, ...rest}) => {
      return {...rest, siteName: `Amazon - ${siteName}`, isAmazon: true}
    }))
  },
  async getFreightSites ({commit, getters}, payload) {
    const doc = await dbAccessor.queryStore('sysAdmin', 'freightSites')
    if (!doc.exists) return 'done'
    const {sites = []} = doc.data()
    commit('setFreightSites', sites)
  },
  async loadHazmatSites ({commit, state}) {
    const successFunc = docs => {
      if (!docs.exists) return
      commit('setHazmatSites', docs.data() || {})
    }

    const errorFunc = error => {
      console.error(error)
      throw error
    }
    let unsubscribe = dbAccessor.queryStoreRT(successFunc, errorFunc, [], 'sysAdmin', 'hazmatSites')
    commit('addTosubscribed', {hazmatSites: unsubscribe})
  },
  async addAuthorizationSites ({commit, state}, payload) {
    const { warehouses = {} } = cloneDeep(state.hazmatSites)
    const sites = warehouses[payload.warehouseKey] || []
    const isExits = sites.some(site => site.key === payload.siteKey)
    if (isExits) throw String('exist')
    warehouses[payload.warehouseKey] = [...sites, {
      ...payload.siteInfo,
      key: payload.siteKey,
      warehouseName: payload.warehouseName,
      warehouseKey: payload.warehouseKey,
      authorizationId: payload.authorizationId
    }]
    const update = { warehouses }
    await dbAccessor.updateFieldsStore(update, 'sysAdmin', 'hazmatSites')
  },
  async deleteAuthorizationSites ({state}, payload) {
    const { warehouses = {} } = cloneDeep(state.hazmatSites)
    const update = {}
    Object.keys(warehouses).forEach(warehouseKey => {
      const sites = warehouses[warehouseKey] || []
      const filterSite = sites.filter(site => site.key !== payload.siteKey)
      if (!sites.length || !filterSite.length) return
      update[warehouseKey] = filterSite
    })
    await dbAccessor.updateFieldsStore({ warehouses: update }, 'sysAdmin', 'hazmatSites')
  },
  async updateAuthorizationSites ({ state }, payload) {
    const { warehouseKey, key } = payload
    const warehouseSitesRef = await dbAccessor.queryStore('warehouses', warehouseKey, 'sites', key)
    if (!warehouseSitesRef.exists) return
    const { authorizationId, ...data } = warehouseSitesRef.data()
    const { warehouses = {} } = cloneDeep(state.hazmatSites)
    const sites = warehouses[warehouseKey] || []
    const index = sites.findIndex(site => site.key === key)
    if (index < -1) throw String('not exist')
    sites[index] = { ...payload, ...data, zipCode: data.zip }
    await dbAccessor.updateFieldsStore({ warehouses }, 'sysAdmin', 'hazmatSites')
  },
  getEeiPagination ({commit, getters}, payload) {
    let predicates = getters.user.isAdmin ? [] : [{
      field: 'clientKey',
      compare: '==',
      value: getters.activeOrganization || getters.activeWarehouse
    }]

    if (payload.predicates.predicateSelect) {
      predicates.push({
        field: `clientKey`,
        compare: '==',
        value: payload.predicates.predicateSelect
      })
    }

    if (payload.predicates && payload.predicates.predicateText) {
      predicates.push({
        field: `keywords`,
        compare: 'array-contains',
        value: payload.predicates.predicateText.toLowerCase()
      })
    }

    payload.startDate && payload.endDate && (predicates = [...predicates, {
      field: `createTime`,
      compare: '>=',
      value: payload.startDate
    },
    {
      field: `createTime`,
      compare: '<=',
      value: payload.endDate
    }])
    return dbAccessor.queryWithPagination(predicates, ['eeiRecords'], 'createTime', true, payload && payload.startAfter, payload && payload.limit)
  },
  async getAESHTS ({commit, getters}) {
    try {
      const blob = await dbAccessor.getFileBlob(process.env.AESHTSUri)
      const file = await blob.arrayBuffer()
      let wb = xlsx.read(file, {type: 'buffer'})
      let ws = wb.Sheets[wb.SheetNames[0]]
      let entries = xlsx.utils.sheet_to_json(ws, { raw: false })
      let map = {}
      entries.forEach((entry) => {
        const {hts_code: code, hts_desc: desc, uom, uom1 = 'NULL'} = entry
        map[code] = {
          desc,
          uom,
          uom1
        }
      })
      commit('setScheduleBMap', map)
    } catch (error) {
      throw error
    }
  },
  async getAllCities ({commit, getters}) {
    const blob = await dbAccessor.getFileBlob(process.env.allCityFilePath)
    const zip = await JSZip.loadAsync(blob)
    const file = await zip.file('us-cities.json').async('string')
    const cityJson = JSON.parse(file)
    commit('setAllCities', cityJson)
  },
  async deleteLabelInvoice ({commit, getters}, {
    tenantKey,
    file,
    labelInvoices = []
  }) {
    await dbAccessor.removeFile(file)
    await dbAccessor.updateFieldsStore({
      labelInvoices: labelInvoices.filter(labelFile => labelFile.file !== file)
    }, 'systemBalance', tenantKey)
  },
  async checkArchive ({commit, getters}, upc) {
    let predicates = [{
      field: 'upc',
      compare: '==',
      value: upc
    }]
    const docs = await dbAccessor.queryWithPredicatesStore(predicates, 'tenants', getters.activeOrganization, 'archivedInventory')
    return docs.docs[0]
  },
  addOfflineDeposits ({commit, getters}, payload) {
    return dbAccessor.updateStore(payload, 'depositRequests', getRandomIdByTime(3))
      .catch((error) => {
        console.log(error)
        commit('setError', error)
      })
      .then(() => {
        return 'Offline deposit request succeeded'
      })
  },

  async getOfflineDeposits ({commit, getters}, payload) {
    if (getters.offlineDeposits.length) return
    commit('setLoading', true)
    let successFunc = (docs) => {
      let offlineArray = docs.docs.map(doc => {
        let offlineDeposit = convertTimestampToDateInObj(doc.data())
        let id = doc.id
        return {...offlineDeposit, id}
      })
      commit('setOfflineDeposits', offlineArray)
      commit('setLoading', false)
    }

    let errorFunc = (error) => {
      console.error(error)
      commit('setLoading', false)
      throw error
    }
    let predicates = [{ field: 'status', compare: 'in', value: ['open'] }]
    predicates.push(getters.user.isAdmin ?
      {
        field: 'vendorKey',
        compare: '==',
        value: 'system'
      } : getters.activeOrganization ? {
        field: 'tenantKey',
        compare: '==',
        value: getters.activeOrganization
      } : {
        field: 'vendorKey',
        compare: '==',
        value: getters.activeWarehouse
      })

    let unsubscribe = await dbAccessor.queryRT(successFunc, errorFunc, predicates, ['depositRequests'])
    commit('addTosubscribed', {offlineDeposits: unsubscribe})
  },
  getHistoryOfflineDeposit ({getters, commit}, payload) {
    let predicates = [
      { field: 'status', compare: 'in', value: ['success', 'canceled'] },
      getters.user.isAdmin ? { field: 'vendorKey', compare: '==', value: 'system' } :
        getters.activeOrganization ? { field: 'tenantKey', compare: '==', value: getters.activeOrganization } :
          { field: 'vendorKey', compare: '==', value: getters.activeWarehouse }
    ]

    payload.startDate && payload.endDate && (predicates = [...predicates, {
      field: `createTime`,
      compare: '>=',
      value: payload.startDate
    },
    {
      field: `createTime`,
      compare: '<=',
      value: payload.endDate
    }])

    return dbAccessor.queryWithPagination(predicates, ['depositRequests'], 'createTime', true, payload && payload.startAfter, payload && payload.limit)
  },
  updateOfflineDeposits ({commit, getters}, payload) {
    let { status, docKey, clientName } = payload
    commit('setLoading', true)
    return dbAccessor.updateFieldsStore({status}, 'depositRequests', docKey)
      .then(() => {
        Logger.changeLog({
          beforeValue: {},
          actionPayload: payload,
          actionName: 'depositRequests',
          categories: ['deposit'],
          keys: [docKey],
          keywords: [getters.user.email || getters.userExtra.email, clientName] || []
        })
        commit('setLoading', false)
        return 'Offline deposit request succeeded'
      })
      .catch(error => {
        commit('setLoading', false)
        return error
      })
  },
  addStore ({commit, getters, dispatch}, payload) {
    let data = {
      ...payload,
      type: 'addStore',
      accountId: getRandomIdByTime(3),
      tenantKey: getters.activeOrganization,
      tenantName: getters.tenant.name,
      operatorKey: getters.userExtra.uid,
      operatorName: getters.userExtra.name
    }
    return dbAccessor.callFunction('processEcomRequest', data)
      .catch((error) => {
        console.log(error)
        throw error
      })
      .then((res) => {
        return {...res.data, createTime: new Date()}
      })
  },
  getStores ({commit, getters}, payload) {
    let successFunc = (docs) => {
      let storesArray = docs.docs.map(doc => {
        return convertTimestampToDateInObj(doc.data())
      })
      commit('setStores', storesArray)
    }

    let errorFunc = (error) => {
      console.log(error)
      throw error
    }
    let predicates = [
      {
        field: `tenantKey`,
        compare: '==',
        value: getters.activeOrganization
      }
    ]
    let unsubscribe = dbAccessor.queryStoreRT(successFunc, errorFunc, predicates, 'store')
    commit('addTosubscribed', {stores: unsubscribe})
  },
  clearRealTimeStores ({commit, getters}) {
    getters.subscribed.stores && getters.subscribed.stores()
    let data = 'stores'
    commit('clearSubscribed', {data, initValues: initialState[data]})
  },
  toAuthorize ({commit, getters}, payload) {
    const {platform, ...rest} = payload
    let redirectUrl = `${process.env.firebaseApi}ecomPlatformCallback?type=storeAuthorized`
    let params = encodeURIComponent(JSON.stringify({
      ...rest,
      redirectUrl
    }))
    let ebayUrl = `${process.env.eeveeApi.url}store/oauth/${platform}/oauthlogin?state=${params}`
    open(ebayUrl)
  },
  processEcomRequest ({commit, getters}, payload) {
    return dbAccessor.callFunction('processEcomRequest', payload)
      .catch((error) => {
        throw error
      })
      .then((res) => res.data)
  },
  async setOrderStatus ({commit, getters, dispatch}, payload) {
    let { fulfillments, status } = payload
    return Promise.all(fulfillments.map(async fulfillment => {
      if (status === 'open') {
        const labels = await Promise.all(
          fulfillment.shipments.map(shipment => {
            return dbAccessor
              .buildStoreQuery(['labels', shipment.labelKey])
              .get()
          })
        )
        const invalidLabel = labels.find(
          label => label.get('status') !== 'canceled'
        )
        if (invalidLabel) {
          throw Error(
            `label status is not canceled, cancel label first please, requestId: ${invalidLabel.get(
              'requestId'
            )}`
          )
        }
        return dbAccessor.runInTransactionStore(async transaction => {
          const orderDoc = await transaction.get(dbAccessor.buildStoreQuery(['tenants', getters.activeOrganization, 'orders', fulfillment._key]))
          let payload = {}
          let targetShipmentArray = []
          let deduplication = {}
          fulfillment.shipments.forEach(async (shipment, index) => {
            if (shipment.labelKey) {
              if (orderDoc.exists) {
                const { shipments, items } = orderDoc.data()
                items.forEach(item => {
                  shipments.forEach(shipment => {
                    if (item.orderItemId === shipment.orderItemId && shipment.status !== 'closed') {
                      item.quantityShipped -= shipment.quantity
                    }
                  })
                  // over shipped
                  if (item.quantityShipped < 0) {
                    throw Error(`Exceed purchase quantity for item orderItemId: ${item.orderItemId}`)
                  }
                })
                if (index === 0) {
                  payload = {
                    status: items.some(item => item.quantityShipped > 0) ? 'partial' : status,
                    items,
                    shipments: []
                  }
                }
                let fulfilledShipment = shipments.find(shipmentItem => !shipmentItem.labelKey || shipmentItem.status === 'closed') || {}
                if (Object.keys(fulfilledShipment).length > 0) {
                  payload.shipments.push(fulfilledShipment)
                }
              }
            } else {
              let targetShipment = getters.shipments.find(item => item._key === shipment.key)
              if (targetShipment && !deduplication[targetShipment.trackingNum]) {
                deduplication[targetShipment.trackingNum] = true
                targetShipmentArray.push(targetShipment)
              }
            }
          })
          transaction.update(orderDoc.ref, dbAccessor.addUpdateDocTimestamp(payload))

          if (targetShipmentArray.length > 0) {
            targetShipmentArray.forEach(targetShipment => {
              dispatch('cancelShipment', targetShipment)
            })
          }
        })
      } else {
        return dbAccessor.updateFieldsStore({status}, 'tenants', getters.activeOrganization, 'orders', fulfillment._key)
      }
    }))
      .catch(error => {
        throw error
      })
  },

  async getWarehouseSites ({ commit, getters }, warehouseKey) {
    if (!getters.user.isAdmin) return
    const warehouseSitesRef = await dbAccessor.queryStore('warehouses', warehouseKey, 'sites')
    return warehouseSitesRef.docs.map(doc => {
      const { createTime, lastModifiedTime, ...data } = doc.data()
      return {
        text: data.siteName,
        value: doc.id,
        data
      }
    })
  },

  async getHelpManualData ({commit, getters}, helpManualFileUrl) {
    const url = await dbAccessor.getFileUrl(helpManualFileUrl)
    let result = await new Promise((resolve, reject) => {
      let request = new XMLHttpRequest()
      request.open('get', url)
      request.onload = () => {
        resolve(request.response)
      }
      request.send()
    })
    return result
  },

  exportLabelsToExcel ({ getters }, { labels = [], startDate, endDate }) {
    let content = [
      [
        'Label ID',
        'Tracking Number',
        'Carrier',
        'shipping Service',
        'Ship Date',
        'Sender Address1',
        'Sender Address2',
        'Sender City',
        'Sender Company',
        'Sender Country Code',
        'Sender Email',
        'Sender Full Name',
        'Sender Phone',
        'Sender State',
        'Sender Zip Code',
        'Recipient Address1',
        'Recipient Address2',
        'Recipient City',
        'Recipient Company',
        'Recipient Full Name',
        'Recipient Phone',
        'Recipient State',
        'Recipient Zip Code',
        'Height',
        'Length',
        'Width',
        'Weight',
        'Memo',
        'Note',
        'Reference',
        'Estimated fee',
        'Label Status'
      ],
      [
        '运单编号',
        '追踪号',
        '承运方',
        '运输服务',
        '发货时间',
        '发件人地址1',
        '发件人地址2',
        '发件人城市',
        '发件人公司',
        '发件人国家代码',
        '发件人邮箱',
        '发件人姓名',
        '发件人手机号',
        '发件人州/省',
        '发件人邮政编号',
        '收件人地址1',
        '收件人地址2',
        '收件人城市',
        '收件人公司',
        '收件人姓名',
        '收件人电话',
        '收件人州/省',
        '收件人邮政编号',
        '高',
        '长',
        '宽',
        '重',
        '备忘录',
        '备注',
        '参考',
        '预收费',
        '状态'
      ]
    ]
    let deduplication = {}
    labels.forEach(label => {
      let {
        _key,
        requestId,
        trackingNumber,
        carrier,
        shippingService,
        shipDate,
        from,
        to,
        packages = [],
        memo,
        note,
        trackingNumbers = [],
        totalAmount,
        amountDetails = {},
        isLabelTask = false,
        reference = '',
        status
      } = label

      if (!trackingNumbers.length) trackingNumbers.push(trackingNumber)
      const isMpsLabel = packages.length > 1
      if (!isMpsLabel) trackingNumbers = trackingNumbers.filter(item => item === trackingNumber)
      packages.forEach(pkg => {
        // const { height, length, width, weight } = packages[0]
        const newObj = [
          _key || requestId,
          pkg.trackingNumber || trackingNumber,
          carrier,
          shippingService,
          shipDate,
          from.address1,
          from.address2,
          from.city,
          from.company,
          from.countryCode,
          from.email,
          from.fullName,
          from.phone,
          from.state,
          from.zipCode,
          to.address1,
          to.address2,
          to.city,
          to.company,
          to.fullName,
          to.phone,
          to.state,
          to.zipCode,
          pkg.height,
          pkg.length,
          pkg.width,
          pkg.weight,
          pkg.memo || memo,
          pkg.note || note,
          pkg.reference || reference,
          totalAmount || Object.values(amountDetails).reduce((sum, item) => sum + item, 0) || 0,
          status
        ]
        const actualTrackingNumber = pkg.trackingNumber || trackingNumber
        if (!deduplication[actualTrackingNumber] || (!actualTrackingNumber && status === 'canceled')) {
          if (!isLabelTask) deduplication[actualTrackingNumber] = true
          content.push(newObj)
        }
      })
    })
    const date = [startDate, endDate].filter(date => date).map(date => toPickerDateString(date)).join(' ~ ')
    const book = xlsx.utils.book_new()
    const sheet = xlsx.utils.aoa_to_sheet(content)
    xlsx.utils.book_append_sheet(book, sheet, 'sheet1')
    xlsx.writeFile(book, `${getters.tenant.name}-${date || toPickerDateString(new Date())}.xlsx`, {bookType: 'xlsx'})
  },

  modifyPkgSpecification ({ commit, getters }, order) {
    const { packagingSpecs = [], isMPS, platform, orderId } = order
    let params = {
      packagingSpecs,
      isMPS
    }
    if (!order.packaging.packageName) {
      Object.assign(params, {
        length: order.packaging.length,
        width: order.packaging.width,
        height: order.packaging.height,
        weight: order.packaging.weight,
        skus: order.packaging.skus?.[0] || {}
      })
    }
    return dbAccessor.updateFieldsStore(
      params,
      'tenants',
      getters.activeOrganization,
      'orders',
      `${platform}-${orderId}`
    )
  },
  updateForecast ({ commit, getters }, payload) {
    let {historyTrackings = [], forecast = {}, isNewForecast = false, isSkipHistoryUpdate = false} = payload
    return dbAccessor.runInTransactionStore(async transaction => {
      let { activeOrganization } = getters
      let { key, ...rest } = forecast
      const docKey = isNewForecast ? getRandomIdByTime(3) : key
      let forecastRef = await transaction.get(dbAccessor.buildStoreQuery(['forecasts', docKey]))

      let historyTrackingsRef = null
      if (!isSkipHistoryUpdate) {
        historyTrackingsRef = await transaction.get(dbAccessor.buildStoreQuery(['tenants', activeOrganization, 'uploadHistory', 'historyTrackings']))
      }
      // const containerId = rest.containerId
      // if (containerId) {
      //   const containerRef = await transaction.get(dbAccessor.buildStoreQuery(['tenants', activeOrganization, 'uploadHistory', 'historyContainers']))
      //   const { historyContainers = {} } = containerRef.data() || {}
      //   if (!historyContainers[containerId]) {
      //     historyContainers[containerId] = 0
      //   }
      //   if (containerRef.exists) {
      //     transaction.update(containerRef.ref, {historyContainers})
      //   } else {
      //     transaction.set(containerRef.ref, dbAccessor.addNewDocTimestamp({historyContainers, organizationKey: activeOrganization}))
      //   }
      // }
      if (isNewForecast) {
        transaction.set(forecastRef.ref, dbAccessor.addNewDocTimestamp(forecast))
      } else {
        const {lastModifiedTime} = forecastRef.data()
        if (+payload.lastModifiedTime !== +lastModifiedTime.toDate() && !payload.isMockItem) throw Error('The current package may have changed, refresh and try again')
        transaction.update(forecastRef.ref, rest)
      }
      if (!isSkipHistoryUpdate) {
        if (historyTrackingsRef.exists) {
          transaction.update(historyTrackingsRef.ref, {historyTrackings})
        } else {
          transaction.set(historyTrackingsRef.ref, dbAccessor.addNewDocTimestamp({historyTrackings}))
        }
      }
      const result = isNewForecast ? {...forecast, _key: docKey} : forecast
      return result
    })
  },
  deleteForecast ({getters}, {trackings = [], key}) {
    if (!key) throw Error('miss document key')
    return dbAccessor.runInTransactionStore(async transaction => {
      let { activeOrganization, tenantForecastTrackings = [] } = getters
      let forecastRef = await transaction.get(dbAccessor.buildStoreQuery(['forecasts', key]))
      let historyTrackingsRef = await transaction.get(dbAccessor.buildStoreQuery(['tenants', activeOrganization, 'uploadHistory', 'historyTrackings']))
      transaction.delete(forecastRef.ref)
      if (!historyTrackingsRef.exists) {
        transaction.set(historyTrackingsRef.ref, {
          historyTrackings: []
        })
      } else {
        transaction.update(historyTrackingsRef.ref, {
          historyTrackings: tenantForecastTrackings.filter(trk => !trackings.includes(trk))
        })
      }
    }).then(() => {
      getters.activeWarehouse && Logger.changeLog({
        beforeValue: key,
        actionPayload: {key: key},
        actionName: 'deleteForecast',
        categories: ['forecast'],
        keys: [key],
        keywords: [key],
        warehouseKey: getters.activeWarehouse
      })
    })
  },
  confirmForecast ({getters}, key) {
    return dbAccessor.runInTransactionStore(async transaction => {
      let forecastDoc = await transaction.get(dbAccessor.buildStoreQuery(['forecasts', key]))
      if (!forecastDoc.exists) throw Error('forecast doc is missing')
      let { packages = {} } = forecastDoc.data()
      Object.keys(packages).forEach(tracking => {
        packages[tracking].packageStatus === 'partial' && (packages[tracking].packageStatus = 'ready')
      })
      transaction.update(forecastDoc.ref, {status: 'confirmed', packages})
    })
  },
  getActiveForecasts ({commit, getters}, payload) {
    let {startDate, endDate, limit, startAfter} = payload
    let predicates = []
    if (startDate) {
      predicates.push({
        field: `createTime`,
        compare: '>=',
        value: startDate
      })
    }

    if (endDate) {
      predicates.push({
        field: `createTime`,
        compare: '<=',
        value: endDate
      })
    }

    if (getters.activeOrganization) {
      predicates.push({
        field: `organizationKey`,
        compare: '==',
        value: getters.activeOrganization
      })
      if (payload.predicates.predicateSelect) {
        predicates.push({
          field: `status`,
          compare: '==',
          value: payload.predicates.predicateSelect
        })
      } else {
        predicates.push({
          field: `status`,
          compare: 'in',
          value: ['ready', 'partial']
        })
      }
    }
    if (getters.activeWarehouse) {
      predicates.push({
        field: `warehouseKey`,
        compare: '==',
        value: getters.activeWarehouse
      })
      predicates.push({
        field: `status`,
        compare: 'in',
        value: ['ready', 'partial']
      })
      if (payload.predicates.predicateSelect) {
        predicates.push({
          field: `organizationKey`,
          compare: '==',
          value: payload.predicates.predicateSelect
        })
      }
    }
    if (payload.predicates?.predicateText) {
      predicates.push({
        field: `keywords`,
        compare: 'array-contains',
        value: payload.predicates.predicateText.toUpperCase()
      })
    }
    const res = dbAccessor.queryWithPagination(predicates, ['forecasts'], 'createTime', true, startAfter, limit)
    return res
  },
  isExistForecast ({getters}, item) {
    return dbAccessor.queryWithPagination([{
      field: `keywords`,
      compare: 'array-contains',
      value: item.upc
    }, {
      field: `organizationKey`,
      compare: '==',
      value: getters.activeOrganization
    }, {
      field: `status`,
      compare: 'in',
      value: ['ready', 'partial']
    }], ['forecasts'], 'createTime', true, 0, 1)
      .then(res => res.docs.length > 0)
  },
  getHistoryForecasts ({commit, getters}, payload) {
    let {startDate, endDate, limit, startAfter} = payload
    let predicates = []
    if (startDate) {
      predicates.push({
        field: `createTime`,
        compare: '>=',
        value: startDate
      })
    }

    if (endDate) {
      predicates.push({
        field: `createTime`,
        compare: '<=',
        value: endDate
      })
    }

    if (getters.activeOrganization) {
      predicates.push({
        field: `organizationKey`,
        compare: '==',
        value: getters.activeOrganization
      })
    }
    if (getters.activeWarehouse) {
      predicates.push({
        field: `warehouseKey`,
        compare: '==',
        value: getters.activeWarehouse
      })
    }

    if (payload.predicates?.predicateText) {
      predicates.push({
        field: `keywords`,
        compare: 'array-contains',
        value: payload.predicates.predicateText.toUpperCase()
      })
    }

    if (payload.predicates.predicateSelect) {
      predicates.push({
        field: `status`,
        compare: '==',
        value: payload.predicates.predicateSelect
      })
    } else {
      predicates.push({
        field: `status`,
        compare: 'in',
        value: ['done', 'confirmed']
      })
    }
    return dbAccessor.queryWithPagination(predicates, ['forecasts'], 'createTime', true, startAfter, limit)
  },

  getForecastHistoryTrackings ({commit, getters}) {
    let successFunc = (docs) => {
      if (!docs.exists) return

      let {historyTrackings = []} = docs.data()
      commit('setTenantForecastTrackings', historyTrackings)
    }

    let errorFunc = (error) => {
      console.log(error)
      throw error
    }
    let unsubscribe = dbAccessor.queryStoreRT(successFunc, errorFunc, [], 'tenants', getters.activeOrganization, 'uploadHistory', 'historyTrackings')
    commit('addTosubscribed', {stores: unsubscribe})
  },

  acceptDeclaimer ({commit, getters}, payload) {
    const collections = {
      tenant: 'tenants',
      warehouse: 'warehouses',
      user: 'users'
    }
    let userType
    let key
    if (getters.activeOrganization) {
      userType = 'tenant'
      key = getters.activeOrganization
    } else if (getters.activeWarehouse) {
      userType = 'warehouse'
      key = getters.activeWarehouse
    } else {
      userType = 'user'
      key = getters.uid
    }
    return dbAccessor.updateFieldsStore({
      acceptedDeclaimers: dbAccessor.fieldValue().arrayUnion(payload)
    }, collections[userType], key)
  },
  getBeforeShipmentForecasts ({commit, getters}, payload) {
    let {startDate, endDate, limit, startAfter} = payload
    let predicates = []
    if (startDate) {
      predicates.push({
        field: `createTime`,
        compare: '>=',
        value: startDate
      })
    }

    if (endDate) {
      predicates.push({
        field: `createTime`,
        compare: '<=',
        value: endDate
      })
    }
    if (getters.activeOrganization) {
      predicates.push({
        field: `organizationKey`,
        compare: '==',
        value: getters.activeOrganization
      })
      predicates.push({
        field: `shipmentStatus`,
        compare: 'in',
        value: ['ready', 'partial']
      })
      if (payload.predicates?.predicateSelect) {
        predicates.push({
          field: `warehouseSite`,
          compare: '==',
          value: payload.predicates.predicateSelect
        })
      }
    }
    if (getters.activeWarehouse) {
      predicates.push({
        field: `warehouseKey`,
        compare: '==',
        value: getters.activeWarehouse
      })
      predicates.push({
        field: `shipmentStatus`,
        compare: 'in',
        value: ['ready', 'partial']
      })
    }
    if (payload.predicates?.predicateText) {
      predicates.push({
        field: `keywords`,
        compare: 'array-contains',
        value: payload.predicates.predicateText.toUpperCase()
      })
    }
    return dbAccessor.queryWithPagination(predicates, ['forecasts'], 'createTime', true, startAfter, limit)
  },
  getShippedHistoryForecasts ({commit, getters}, payload) {
    let {startDate, endDate, limit, startAfter} = payload
    let predicates = []
    if (startDate) {
      predicates.push({
        field: `createTime`,
        compare: '>=',
        value: startDate
      })
    }

    if (endDate) {
      predicates.push({
        field: `createTime`,
        compare: '<=',
        value: endDate
      })
    }
    if (getters.activeOrganization) {
      predicates.push({
        field: `organizationKey`,
        compare: '==',
        value: getters.activeOrganization
      })
      predicates.push({
        field: `shipmentStatus`,
        compare: 'in',
        value: ['shipped', 'partial']
      })
    }
    if (getters.activeWarehouse) {
      predicates.push({
        field: `warehouseKey`,
        compare: '==',
        value: getters.activeWarehouse
      })
      if (payload.predicates.predicateSelect) {
        predicates.push({
          field: `organizationKey`,
          compare: '==',
          value: payload.predicates.predicateSelect
        })
      }
    }
    if (payload.predicates?.predicateText) {
      predicates.push({
        field: `keywords`,
        compare: 'array-contains',
        value: payload.predicates.predicateText.toUpperCase()
      })
    }
    return dbAccessor.queryWithPagination(predicates, ['forecasts'], 'createTime', true, startAfter, limit)
  },

  async createForecastShipment ({commit, getters}, payload) {
    Logger.log('addForecastShipment', payload)
    payload.tenantKey = getters.activeOrganization
    payload.tenantName = getters.tenant.name
    payload.orgEmail = getters.userExtra.email
    payload.creator = getters.userExtra.name
    let {products = [], isForecastedSplitShipment = false} = payload
    let forecastsMap = new Map()
    products.forEach(product => {
      const {forecastDocKey, tracking, upc, toShip} = product
      if (!forecastsMap.has(forecastDocKey)) {
        forecastsMap.set(forecastDocKey, {pkgs: {}})
      }
      let {pkgs} = forecastsMap.get(forecastDocKey)
      if (!pkgs[tracking]) pkgs[tracking] = []

      pkgs[tracking].push({upc, toShip})
    })
    let payloadShipment = Shipment.newDoc({...payload, isUnzipSingleFile: true})
    return dbAccessor.runInTransactionStore(async (transaction) => {
      const shipmentRef = dbAccessor.buildStoreQuery(['shipments', payload._key])
      let [shipmentDoc, ...forecastDocs] = await Promise.all([
        transaction.get(shipmentRef),
        ...[...forecastsMap.keys()].map((key) => transaction.get(dbAccessor.buildStoreQuery(['forecasts', key])))
      ])
      payloadShipment.keywords = payloadShipment.keywords
        .filter(item => item)
      if (!shipmentDoc.exists) {
        payloadShipment.insertOrUpdateT(transaction)
      } else {
        let {readyLabels} = shipmentDoc.data()
        payloadShipment.labels.forEach(item => {
          let targetLabel = readyLabels.find(label => label.orderId === item.orderId)
          if (targetLabel) {
            item.url = targetLabel.url
            item.trackingNum = targetLabel.trackingNumber
          }
        })
        payloadShipment.trackingNum = payloadShipment.labels
          .filter(item => item.trackingNum)
          .map(item => item.trackingNum)
          .join(' ')
        payloadShipment.keywords = [...payloadShipment.keywords, ...payloadShipment.trackingNum.split(' ')]
        if (payloadShipment.labels.length || payloadShipment.files.length) {
          dbAccessor.callFunction('processShipmentLabelFiles', {...payloadShipment.getData(), key: payload._key})
        }
        payloadShipment.insertOrUpdateT(transaction)
      }

      forecastDocs.forEach(doc => {
        if (!doc.exists) {
          throw Error('missing-forecast')
        }
        const key = doc.id
        let {packages = {}} = doc.data()
        const { pkgs = {} } = forecastsMap.get(key) || {}

        Object.keys(pkgs).forEach(tracking => {
          const matchedPkg = packages[tracking]
          const upcs = pkgs[tracking]
          if (!matchedPkg) {
            throw Error('missing-forecast-tracking')
          }
          if (matchedPkg.packageStatus !== 'ready') throw Error('The current package has been modified, please refresh and try again')
          upcs.forEach(item => {
            let [, upc] = item.upc.split(`${tracking}-`)
            let currentUpc = matchedPkg.upcs.find(upcItem => upcItem.upc === upc)
            if (currentUpc) {
              if (item.toShip > currentUpc.inboundQty) throw Error('Quantity error')
              currentUpc.outboundQty = item.toShip + (currentUpc.outboundQty || 0)
              if (currentUpc.outboundQty > currentUpc.inboundQty) throw Error('Quantity error')
            }
          })
          const hasAvailable = isForecastedSplitShipment && matchedPkg.upcs.some(({inboundQty = 0, outboundQty = 0}) => inboundQty - outboundQty > 0)
          if (!hasAvailable) matchedPkg.packageStatus = 'created'
        })
        transaction.update(doc.ref, {packages})
      })

      payloadShipment.labels.forEach(label => {
        const labelRef = dbAccessor.buildStoreQuery(['labels', label.orderId.split('-')[1]])
        transaction.update(labelRef, {shipmentId: payloadShipment._key, hasShipment: true})
      })
    })
      .catch(error => {
        Logger.critical('Add Shipment', error.message)
        console.error(error)
        let newError = Error('new-shipment-error')
        newError.internalError = error
        throw newError
      })
      .then((data) => {
        let uploadMetadataPromises = payload.files.map(file => {
          return ViteModel.updateFileMetadata(file.fullPath, {...file, shipmentKey: payload._key})
        })
        return Promise.all(uploadMetadataPromises)
      })
      .catch(error => {
        if (error.message === 'new-shipment-error') throw error
      })
  },
  removeForecastPkgToShipped ({commit, getters}, payload) {
    const {forecastDocKey, tracking} = payload
    return dbAccessor.runInTransactionStore(async transaction => {
      const forecastDoc = await transaction.get(dbAccessor.buildStoreQuery(['forecasts', forecastDocKey]))
      if (!forecastDoc.exists) throw Error('forecast doc is missing')
      const {lastModifiedTime, packages = {}} = forecastDoc.data()
      if (+payload.lastModifiedTime !== +lastModifiedTime.toDate()) throw Error('The current package may have changed, refresh and try again')
      if (packages[tracking]) {
        packages[tracking].packageStatus = 'shipped'
      }
      let updateFields = { packages }
      const hasAvailableToShip = Object.values(packages).some(pkg =>
        ['ready', 'created', 'initial'].includes(pkg.packageStatus)
      )
      updateFields.shipmentStatus = hasAvailableToShip ? 'partial' : 'shipped'
      transaction.update(forecastDoc.ref, dbAccessor.addUpdateDocTimestamp(updateFields))
    })
  },
  callMonthEndClose ({commit, getters}, payload) {
    return dbAccessor.callFunction('callAutoMonthEndClose', {needToProcessTenantKeyList: [getters.activeOrganization]})
  },
  async getMonthEndCloseData ({commit, getters}, payload) {
    if (!getters.activeOrganization) return
    const monthEndCloseRefs = await dbAccessor.buildStoreQuery(['tenants', getters.activeOrganization, 'monthEndClose']).get()
    const monthEndCloseData = monthEndCloseRefs.docs.map(doc => ({_key: doc.id, ...doc.data()}))
    commit('setMonthEndCloseData', monthEndCloseData)
  },
  deleteMonthEndCloseItem ({commit, getters}, item) {
    return dbAccessor.removeStore('tenants', getters.activeOrganization, 'monthEndClose', item._key)
  },
  filterDeletedMonthEndCloseItem ({commit, getters}, item) {
    const newMonthEndCloseItem = getters.monthEndCloseData.filter(single => item._key !== single._key)
    commit('setMonthEndCloseData', newMonthEndCloseItem)
  },
  updateLabelDownloadStatus ({commit, getters}, {key}) {
    return dbAccessor.updateFieldsStore({isDownloaded: true}, 'labels', key)
  },
  async getUpcFromTrackingAndPkg ({commit, getters}, payload) {
    let unconfirmedPackages = []
    let unconfirmedTrackings = []
    payload.unconfirmedPackagesAndTracking.forEach(item => {
      if (item.key || item.packageID) {
        unconfirmedPackages.push(item)
      } else {
        unconfirmedTrackings.push(item)
      }
    })
    let packagePromises = unconfirmedTrackings.map(tracking => {
      const predicate = [
        {
          field: 'trackings',
          compare: 'array-contains',
          value: tracking
        }
      ]
      return payload.warehouseKeys.map(warehouseKey => dbAccessor.queryWithPredicatesStore(predicate, 'warehouses', warehouseKey, 'packages'))
    })

    let packagesDocsArr = await Promise.all(packagePromises.flat(1))
    let pkgs = [...unconfirmedPackages, ...packagesDocsArr.map(docs => docs.docs.map(doc => doc.exists ? convertTimestampToDateInObj({...doc.data(), warehouseKey: doc.ref.path.split('/')[1]}) : {})).flat(1)]
    let uniqueWarehouseKey = new Set()
    let uniqueUpc = new Set()
    pkgs.forEach(pkg => {
      uniqueWarehouseKey.add(pkg.warehouseKey)
      uniqueUpc.add(pkg.upc)
    })
    for (const warehouseKey of [...uniqueWarehouseKey]) {
      const predicate = [
        {
          field: 'upc',
          compare: 'in',
          value: [...uniqueUpc]
        }
      ]
      let warehouseUpcDocs = await dbAccessor.queryWithPredicatesStore(predicate, 'warehouses', warehouseKey, 'upcs')
      let warehouseUpc = {}
      if (!warehouseUpcDocs.empty) {
        warehouseUpc = warehouseUpcDocs.docs.map(doc => doc.data())
      }
      pkgs.forEach(pkg => {
        let matchUpcInfo = warehouseUpc.find(upcInfo => upcInfo.upc === pkg.upc)
        if (matchUpcInfo) {
          pkg.description = matchUpcInfo.description
        }
      })
      if ([...uniqueUpc].every(upc => warehouseUpc.some(upcInfo => upcInfo.upc === upc))) {
        break
      }
    }
    return pkgs
  },
  async updateProductUpc ({commit, getters}, payload) {
    const {productId, upc, warehouseKeys, key} = payload
    return Promise.all([
      dbAccessor.updateFieldsStore({upc, unconfirmedPackagesAndTracking: []}, 'tenants', getters.activeOrganization, 'inventory', productId),
      dbAccessor.updateFieldsStore({unconfirmedPackagesAndTracking: []}, 'offers', 'offers', 'active', key)
    ])
      .then(() => {
        dbAccessor.callFunction('processPackages', {tenantKey: getters.activeOrganization, productId: productId, actionType: 'updateUpc', warehouseKeys})
      })
  },
  async generateBarcodes ({commit, getters}, payload) {
    return dbAccessor.callFunction('batchGenerateBarcode', payload)
  },
  async updateOrderItemQuantity ({commit, getters}, payload) {
    const {orderId, originalQty, changedQty, orderItemId} = payload
    if (typeof changedQty !== 'number') throw Error('Quantity error')
    return dbAccessor.runInTransactionStore(async transaction => {
      const orderRef = dbAccessor.buildStoreQuery(['tenants', getters.activeOrganization, 'orders', orderId])
      const orderDoc = await transaction.get(orderRef)
      if (!orderDoc.exists) throw Error('order doc is missing')
      const {items} = orderDoc.data()
      const targetItem = items.find(item => item.orderItemId === orderItemId)
      if (!targetItem) throw Error('order item is missing')
      targetItem.quantityPurchased = changedQty
      if (!targetItem.originalQty) {
        targetItem.originalQty = originalQty
      }
      if (targetItem.quantityPurchased < 0) throw Error('Quantity error')
      transaction.update(orderRef, dbAccessor.addUpdateDocTimestamp({items}))
    })
  },
  async uploadShipmentFiles ({commit, getters}, payload) {
    let {files, organizationKey, siteKey} = payload
    return dbAccessor.callFunction('batchShipment', {files: files, siteKey, organizationKey, type: 'uploadLabels'})
  },
  async batchCreateShipments ({commit, getters}, payload) {
    const {shipments} = payload
    const clientKey = getters.activeOrganization
    const clientName = getters.tenant.name
    return dbAccessor.callFunction('batchShipment', {shipments, clientKey, clientName, type: 'batchCreateShipments'})
  },
  async retryShipmentTasks ({commit, getters}, shipmentsTaskId) {
    const clientKey = getters.activeOrganization
    return dbAccessor.callFunction('batchShipment', {shipmentsTaskId, clientKey, type: 'retryTasks'})
  },
  async deleteShipmentTask ({commit, getters}, shipmentsTaskId) {
    const path = ['tenants', getters.activeOrganization, 'shipmentTask', shipmentsTaskId]
    const taskDoc = await dbAccessor.queryStore(...path)
    if (!taskDoc.exists) {
      throw Error('task not found')
    }
    const processStatus = taskDoc.get('processStatus')
    if (processStatus === 'failed') {
      return dbAccessor.removeStore(...path)
    } else {
      throw Error('only failed task can be deleted')
    }
  },
  async getPendingShipmentTasksPagination ({commit, getters, dispatch}, payload) {
    let { startDate, endDate, limit, startAfter, type, endBefore, isDesc = false } = payload
    let predicates = [{
      field: `processStatus`,
      compare: 'in',
      value: ['pending', 'failed']
    }]

    if (startDate) {
      predicates.push({
        field: `createTime`,
        compare: '>=',
        value: startDate
      })
    }

    if (endDate) {
      predicates.push({
        field: `createTime`,
        compare: '<=',
        value: endDate
      })
    }

    if (payload.predicates && (payload.predicates.predicateText || payload.predicates.predicateSelect)) {
      predicates.push({
        field: `keywords`,
        compare: 'array-contains',
        value: payload.predicates.predicateText || payload.predicates.predicateSelect
      })
    }

    if (payload.predicates && payload.predicates.actionPredicates && payload.predicates.actionPredicates.length) {
      let {actionPredicates} = payload.predicates
      if (actionPredicates.length > 1 || actionPredicates[0].value) predicates.push(...actionPredicates)
    }
    const tasksDocs = await dbAccessor.queryWithPagination(predicates, ['tenants', getters.activeOrganization, 'shipmentTask'], 'createTime', !isDesc, startAfter, limit, endBefore, type)
    try {
      const tasks = tasksDocs.docs.map(doc => ({
        ...convertTimestampToDateInObj(doc.data()),
        _key: doc.id
      }))
      const now = new Date()
      const timedOutPendingTasks = tasks.filter(task => {
        const createTime = new Date(task.createTime)
        const fifteenMinutes = 15 * 60 * 1000
        const hasTimedOut = now - createTime > fifteenMinutes
        const isPending = task.processStatus === 'pending'
        return hasTimedOut && isPending
      })
      if (timedOutPendingTasks.length) {
        await dispatch('markTasksAsTimedOut', timedOutPendingTasks)
          .catch(console.error)

        tasks.forEach(task => {
          if (task.processStatus === 'pending') {
            task.processStatus = 'failed'
            task.error = {
              message: 'processing timeout. please try again.',
              code: 'TIMED_OUT'
            }
          }
          task.data = () => task
        })
        return {
          docs: tasks,
          forEach: tasks.forEach.bind(tasks)
        }
      }
      return tasksDocs
    } catch (error) {
      console.error(error)
      return tasksDocs
    }
  },
  getFailedShipmentTasksPagination ({commit, getters}, payload) {
    let { startDate, endDate, limit, startAfter, type, endBefore, isDesc = false } = payload
    let predicates = [{
      field: `processStatus`,
      compare: 'in',
      value: ['failed']
    }]

    if (startDate) {
      predicates.push({
        field: `createTime`,
        compare: '>=',
        value: startDate
      })
    }

    if (endDate) {
      predicates.push({
        field: `createTime`,
        compare: '<=',
        value: endDate
      })
    }

    if (payload.predicates && (payload.predicates.predicateText || payload.predicates.predicateSelect)) {
      predicates.push({
        field: `keywords`,
        compare: 'array-contains',
        value: payload.predicates.predicateText || payload.predicates.predicateSelect
      })
    }

    if (payload.predicates && payload.predicates.actionPredicates && payload.predicates.actionPredicates.length) {
      let {actionPredicates} = payload.predicates
      if (actionPredicates.length > 1 || actionPredicates[0].value) predicates.push(...actionPredicates)
    }
    return dbAccessor.queryWithPagination(predicates, ['tenants', getters.activeOrganization, 'shipmentTask'], 'createTime', !isDesc, startAfter, limit, endBefore, type)
  },
  async getApiExporttransactionsList ({ commit, getters }, payload) {
    const { isModeLabel, user } = getters
    if (!isModeLabel && !user.isAdmin) return
    return dbAccessor.callFunction('processApiLabel', { type: 'exportTransactionList', data: payload })
  },
  async getCommoditiesList ({commit, state, getters}, payload) {
    if (state.commoditiesList && state.commoditiesList.length > 0) {
      return { isSuccess: true, message: null, data: state.commoditiesList }
    }
    const result = await dbAccessor.callFunction('processThirdPartyResources', {
      scheduleBCode: payload.scheduleBCode, desc: payload.desc, category: payload.category, actionType: 'getCommodities'
    }).catch(e => {
      console.error(e)
      return { isSuccess: false, message: e.message, data: [] }
    })
    if (result && result.data) {
      commit('setCommoditiesList', result.data)
    }
    return result
  },
  async getLabelByTracking ({commit, state, getters}, payload) {
    const result = await dbAccessor.callFunction('processThirdPartyResources', {
      trackingNumbers: payload.trackingNumbers, actionType: 'getLabelByTracking'
    }).catch(e => {
      console.error(e)
      return { isSuccess: false, message: e.message, data: null }
    })
    return result
  }
}

export const getters = {
  returnPackageTimer (state) {
    return state.returnPackageTimer
  },
  tenant (state) {
    return state.tenant
  },
  monthEndCloseData (state) {
    return state.monthEndCloseData
  },
  products (state) {
    return state.products.map(item => {
      return {...item, asinSkuForSearch: (item.asin ? item.asin.join('') : ' ') + (item.sku ? item.sku.join('') : '')}
    })
  },
  offers (state) {
    return state.offers
  },
  proposes (state) {
    return state.proposes
  },
  expiredOffers (state) {
    return state.expiredOffers
  },
  archives (state) {
    return state.archives
  },
  allCities (state) {
    return state.allCities
  },
  isModeLabel (state) {
    const target = state.tenant?.users?.find(user => user.email === state.tenant.email)
    return target?.roles?.includes('orgLabel') || false
  },
  users (state) {
    return state.users
      .map(user => ({
        ...user,
        status: getApprovalTypeString(user.approvalType),
        balance: (state.balance[user.uid] && state.balance[user.uid].total) || 0
      }))
  },
  userRequest (state) {
    return state.userRequest
  },
  groups (state) {
    return state.groups
  },
  inbound (state) {
    return state.inbound
  },
  allDistribution (state, getters) {
    return getters.products.reduce((acc, product) => {
      const {distribution, ...productInfo} = product
      if (distribution) {
        const productDist = Object.keys(distribution).map(fbmKey => {
          return {
            ...productInfo,
            ...distribution[fbmKey],
            fbmKey
          }
        })
        return [...acc, ...productDist]
      }
      return acc
    }, [])
  },
  shipments (state) {
    return state.shipments
  },
  shipmentsAndDrafts ({shipments, shipmentDrafts}) {
    return [
      ...shipmentDrafts.map(item => {
        return {...item, isDraft: true}
      }),
      ...shipments
    ]
  },
  shipmentToTrackingMap (state) {
    return new Map(state.shipments.map(item => [item._key, item.trackingNum]))
  },
  archivedShipments (state) {
    return state.archivedShipments
  },
  subscribed (state) {
    return state.subscribed
  },
  balance (state) {
    return state.balance
  },
  pendingTransactions (state) {
    return state.pendingTransactions
  },
  tenantLimitedInfo (state) {
    return state.tenantLimitedInfo
  },
  warehouses (state) {
    return state.warehouses
  },
  warehouseKeyToNameMap (state) {
    let map = {}
    state.warehouses.forEach(warehouse => {
      let {warehouseKey, warehouseName} = warehouse
      map[warehouseKey] = warehouseName
    })
    return map
  },
  allPreferredWarehouses (state) {
    return state.warehouses.filter(warehouse => warehouse.orgId && warehouse.orgId.length > 0)
  },
  reportLost (state) {
    return state.reportLost
  },
  warehousesPromotionsMap (state) {
    return state.warehousesPromotionsMap
  },
  warehouseLimitedInfoForTenant (state) {
    return state.warehouseLimitedInfoForTenant
  },
  warehouses2BillingsMap (state) {
    return new Map(state.warehouseBillings.map(item => {
      let {key, ...rest} = item
      return [key.split('_')[0], rest]
    }))
  },
  warehousesWithBalanceAndThreshold (state, getters) {
    return getters.allPreferredWarehouses.map(warehouse => {
      let rtn = {...warehouse}
      let billing = getters.warehouses2BillingsMap.get(warehouse.warehouseKey)
      let threshold = getters.warehouse2ThresholdsMap.get(warehouse.warehouseKey)
      if (billing) {
        const { balance = 0, bond = 0, lowestBalance = 0 } = billing
        rtn = { ...rtn, balance, bond, lowestBalance }
      } else {
        rtn.balance = 0
      }
      if (threshold) {
        rtn = {...rtn, ...threshold}
      }
      return rtn
    })
  },
  promotionsUnreadList (state, getters) {
    return Array.from(state.warehousesPromotionsMap.values()).map(warehousePromotions =>
      warehousePromotions.map(promotion =>
        !(promotion.readList && promotion.readList.includes(getters.activeOrganization)) && promotion.key
      ).filter(key => key)
    ).reduce((preUnreadList, curUnreadList) => preUnreadList.concat(curUnreadList), [])
  },
  warehouse2ThresholdsMap (state) {
    return new Map(state.warehouseLimitedInfoForTenant.map(item => {
      let {key, criticalLowBalanceThreshold = 0, lowBalanceWarningThreshold = 0} = item
      return [key, {criticalLowBalanceThreshold, lowBalanceWarningThreshold}]
    }))
  },
  memberType (state) {
    return state.tenant.memberType || 0
  },
  productsWithUpcChangeableFlag (state) {
    const productsOnShipping = state.shipments.reduce((acc, shipment) => {
      let {products} = shipment
      return [...acc, ...products.map(product => product.id)]
    }, [])
    let shippingProductIds = new Set(productsOnShipping)
    return state.products.map(product => {
      const {quantity, distribution, id, upc, price} = product
      const isDistributionEmpty = !distribution || !Object.values(distribution).some(value => value.quantity > 0)
      const isUpcChangeable = !upc || (!quantity && !shippingProductIds.has(id) && isDistributionEmpty)
      let newProduct = {...product, isUpcChangeable}
      if (price && quantity) {
        newProduct.value = price * quantity
      } else {
        delete newProduct.value
      }
      return newProduct
    })
  },
  tenantUpcToProductNameMap (state) {
    let map = {}
    state.products.forEach(product => {
      const {name, upc} = product
      map[upc] = name
    })
    return map
  },
  skuToProductIdMap (state) {
    let map = new Map()
    state.products.forEach(product => {
      let {sku, id} = product
      if (sku) {
        sku.forEach(item => {
          map.set(item, id)
        })
      }
    })
    return map
  },
  skuSet (state) {
    return new Set(state.products.reduce((acc, product) => {
      if (product.sku) {
        return [...acc, ...product.sku]
      }
      return acc
    }, []))
  },
  tenantAnnouncements (state) {
    return state.tenantAnnouncements
  },
  productTransfersPending (state) {
    return state.pendingProductTransfers
  },
  supports (state) {
    return state.supports
  },
  priceHistories (state) {
    return state.priceHistories
  },
  warehouseSites (state) {
    return state.warehouses.reduce((sites, warehouse) =>
      [
        ...sites,
        ...(warehouse.sites || [])
          .map(site => {
            let newSite = {
              ...site,
              warehouseName: warehouse.warehouseName,
              warehouseKey: warehouse.warehouseKey
            }
            if (warehouse.orgId) newSite.orgId = warehouse.orgId
            return newSite
          })
      ], []
    )
  },
  activeOrders (state) {
    return state.activeOrders
  },
  activeAppleOrders (state) {
    return state.activeAppleOrders
  },
  fulfillmentOrders (state) {
    return state.fulFillmentOrders
  },
  templates (state) {
    return state.templates
  },
  labelTemplates (state) {
    return state.labelTemplates
  },
  labelTemplateDefaults (state) {
    return state.labelTemplateDefaults || {}
  },
  defaultLabelTemplateByType (state) {
    return (businessType) => {
      const defaults = state.labelTemplateDefaults || {}
      const fieldNameMap = {
        domestic: 'domesticTemplateId',
        export: 'exportTemplateId',
        import: 'importTemplateId'
      }
      const field = fieldNameMap[businessType]
      if (!field) return null
      const templateId = defaults[field]
      if (!templateId) return null
      return (state.labelTemplates || []).find(item => item.key === templateId) || null
    }
  },
  commodityTemplates (state) {
    return state.commodityTemplates
  },
  tenantSiteMap (state, getters) {
    return new Map(getters.warehouses
      .map(warehouse => {
        let {sites, warehouseName} = warehouse
        return sites.map(site => {
          return {...site, warehouseName}
        })
      })
      .flat()
      .map(item => {
        const {warehouseName, siteName, address1, address2 = '', city, state, zip: zipCode} = item
        return [siteName, {warehouseName, address1, address2, city, state, zipCode}]
      }))
  },
  siteKeyMap (state, getters) {
    return new Map(getters.warehouses
      .map(warehouse => {
        let {sites, warehouseName} = warehouse
        return sites.map(site => {
          return {...site, warehouseName}
        })
      })
      .flat()
      .map(item => {
        const {warehouseName, siteName, address1, address2 = '', city, state, zip: zipCode, key, phone} = item
        return [key || siteName, {warehouseName, siteName, address1, address2, city, state, zipCode, phone}]
      }))
  },
  enableAmazonSites (state, {tenantLimitedInfo, warehouseInfo}) {
    return !!(tenantLimitedInfo && tenantLimitedInfo.enableAmazonSites) ||
      !!(warehouseInfo && warehouseInfo.generalSettings && warehouseInfo.generalSettings.enableAmazonSites)
  },
  isMeasurementMetric (state, {tenantLimitedInfo, warehouseInfo}) {
    return !!(tenantLimitedInfo && tenantLimitedInfo.isMeasurementMetric) ||
      !!(warehouseInfo && warehouseInfo.generalSettings && warehouseInfo.generalSettings.isMeasurementMetric)
  },
  tenantAddresses (state, {enableAmazonSites}) {
    if (enableAmazonSites) {
      return [
        ...state.tenantAddresses,
        ...state.amazonSites
      ]
    }
    return state.tenantAddresses
  },
  tenantPackagings (state) {
    return state.tenantPackagings.map(item => {
      return {
        ...item,
        id: item.id
      }
    })
  },
  packings () {
    return state.packings || []
  },
  tenantPackagingsWithWarehousePackagings (state) {
    return [ ...state.packings, ...state.tenantPackagings, {
      id: 'Default packaging',
      name: 'Default(8"x8"x8")',
      length: 8,
      width: 8,
      height: 8,
      isPackagingDefault: true
    },
    {
      id: 'vite 20x14x4',
      name: 'vite(20"x14"x4")',
      length: 20,
      width: 14,
      height: 4,
      isPackagingDefault: true
    },
    {
      id: 'vite 20x18x16',
      name: 'vite(20"x18"x16")',
      length: 20,
      width: 18,
      height: 16,
      isPackagingDefault: true
    }]
  },
  fedexPackagings () {
    return [
      {
        id: 'FEDEX_BOX',
        name: 'FedEX Box',
        weight: '20'
      },
      {
        id: 'FEDEX_ENVELOPE',
        name: 'FedEX Envelope',
        weight: '1'
      },
      {
        id: 'FEDEX_PAK',
        name: 'FedEX Pak',
        weight: '20'
      }, {
        id: 'FEDEX_TUBE',
        name: 'FedEX Tube',
        weight: '20'
      },
      {
        id: 'FEDEX_SMALL_BOX',
        name: 'FedEX Small Box',
        weight: '20'
      },
      {
        id: 'FEDEX_MEDIUM_BOX',
        name: 'FedEX Medium Box',
        weight: '20'
      }, {
        id: 'FEDEX_LARGE_BOX',
        name: 'FedEX Large Box',
        weight: '20'
      },
      {
        id: 'FEDEX_EXTRA_LARGE_BOX',
        name: 'FedEX Extra Large Box',
        weight: '20'
      }
    ]
  },
  packagingMap (state, getters) {
    return new Map(getters.tenantPackagingsWithWarehousePackagings.map(item => [item.id, item]))
  },
  systemBalance (state) {
    return state.systemBalance
  },
  systemBalances (state) {
    return state.systemBalances
  },
  eeveeIdMatchTenantKeyMap (state) {
    const eeveeIdMatchTenantKeyMap = new Map()
    const haveBoundledTenantList = state.systemBalances.filter(item => item.eeveeOrgId)
    if (haveBoundledTenantList.length) {
      haveBoundledTenantList.forEach(item => {
        eeveeIdMatchTenantKeyMap.set(item.eeveeOrgId, item.clientKey)
      })
    }
    return eeveeIdMatchTenantKeyMap
  },
  labelTemplateFlexibleVars (state) {
    return state.labelTemplateFlexibleVars
  },
  skuRequests (state) {
    return state.skuRequests
  },
  uploadedTrackings (state) {
    return state.uploadedTrackings
  },
  favorites (state) {
    return state.favorites
  },
  amazonSites (state) {
    return state.amazonSites
  },
  hazmatSites (state, getters) {
    const { warehouses = {} } = state.hazmatSites
    const { user = {} } = getters
    let hazmatSites = []
    if (user.isAdmin || getters.activeWarehouse) {
      const warehouseKey = Object.keys(warehouses)
      warehouseKey.forEach(key => {
        const warehouseSites = warehouses[key] || []
        if (!warehouseSites.length) return
        warehouseSites.forEach(site => hazmatSites.push(site))
      })
      if (getters.activeWarehouse) {
        hazmatSites = hazmatSites.filter(site => getters.warehousesSites.some(item => item.key === site.key))
      }
    } else if (getters.activeOrganization) {
      state.warehouses.forEach(warehouse => {
        const { sites, warehouseKey } = warehouse
        const warehouseSites = warehouses[warehouseKey] || []
        if (!warehouseSites.length || !sites.length) return
        hazmatSites = [...hazmatSites, ...warehouseSites]
      })
    }
    return hazmatSites.map(({ zip, ...site }) => ({
      ...site,
      zipCode: site.zipCode || zip,
      state: getters.statesToAbbrev[site.state] || site.state
    }))
  },
  isLabelBetaUser (state, getters) {
    return state.tenantLimitedInfo.isLabelBetaUser || getters.warehouseLimitedInfo.isLabelBetaUser || false
  },
  viteSupports (state) {
    return state.viteSupports
  },
  scheduleBMap (state) {
    window.scheduleBMap = state.scheduleBMap
    return state.scheduleBMap
  },
  offlineDeposits (state) {
    return state.offlineDeposits
  },
  stores (state) {
    return state.stores
  },
  unlinkPackageInfo (state) {
    return state.unlinkPackageInfo
  },
  freightSites (state, getters) {
    return getters.user.isAdmin || getters.systemBalance.freightSites.includes('ALL') ? state.freightSites : state.freightSites.filter(site => getters.systemBalance.freightSites.includes(site.siteId))
  },
  tenantForecastTrackings (state) {
    return state.tenantForecastTrackings
  },
  isSystemSalesRoleOnly (state, getters) {
    const {user = {}} = getters
    const {roles = []} = user
    const isJustSale = roles.includes('sysAdminDepartmentSale') && roles.length === 1
    return isJustSale
  },
  pendingOrdersTask (state) {
    return state.pendingOrdersTask || []
  },
  organizationCommodities (state) {
    return state.organizationCommodities || []
  },
  commoditiesList (state) {
    return state.commoditiesList || []
  },
  letterheads (state) {
    return state.letterheads || []
  },
  eeveeDepartments (state) {
    return state.eeveeDepartments || []
  },
  eeveeManagers (state) {
    return state.eeveeManagers || []
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/tenant/index.js